<template>
  <!-- 应用类型 -->
  <div class="applicationtype">
    <div class="con">
      <div class="search-input-btn" style="width:100%">
        <div class="input-small">
          <span>名称：</span>
          <el-input v-model="searchName" clearable placeholder="请输入名称"></el-input>
        </div>
        <el-button type="primary" plain @click="search_fn" class="search-btn">查询</el-button>
        <el-button type="primary" @click="add_ed(0)" class="search-btn last-el-button">新增</el-button>
      </div>
      <div class="mytable">
        <el-table id="demo" :height="heights" stripe :data="tableData" style="width: 100%" row-key="id"
          v-loading='isMask'>
          <template slot="empty">
            <span class="noData">
              <img src="@/assets/noData.png" alt="暂无数据">
              <span class="text">暂无数据</span>
            </span>
          </template>
          <el-table-column type="index" label="序号" width="60" align="center">
          </el-table-column>
          <el-table-column label="名称" align="left" min-width="150">
            <template slot-scope="{row}">
              {{ row.name }}
            </template>
          </el-table-column>
          <el-table-column v-for="(item,index) in columns" :key='index' :prop="item.key" :label="item.name"
            :minWidth="item.width">
          </el-table-column>
          <el-table-column label="操作" align="center" width="310">
            <template #default="{row}">
              <div class="public-flex">
                <div @click="edit_ed(row)" class="mr-20">
                  <el-tooltip class="item" effect="dark" content="编辑" placement="top">
                    <elIconBtn btnType='edit'></elIconBtn>
                  </el-tooltip>
                </div>
                <div @click="delete_fn(row)">
                  <el-tooltip class="item" effect="dark" content="删除" placement="top">
                    <elIconBtn btnType='del'></elIconBtn>
                  </el-tooltip>
                </div>
              </div>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <!-- 详情 -->
      <el-dialog title="详情" v-dialogDrag :visible.sync="detail_status" center>
        <div style="display: flex;" class="mydialog">
          <el-form :model="temp" ref="temp" :rules="rules" style="width: 100%;height: 120px;padding-top: 10px;">
            <el-form-item style="margin: 0;" label="父id:">
              <span>{{temp.EnergyTypeParentId}}</span>
            </el-form-item>
          </el-form>
        </div>
        <template #footer>
          <span class="dialog-footer">
            <el-button type="primary" @click="detail_status = false">确 定
            </el-button>
          </span>
        </template>
      </el-dialog>

      <!-- 新增修改 -->
      <el-dialog :title="textMap[dialogStatus]" :close-on-click-modal='false' v-dialogDrag :visible.sync="dialogVisible"
        center>
        <div style="display: flex;" class="mydialog">
          <el-form :model="temp" :rules="rules" ref="temp" class="demo-temp">
            <el-form-item label="类型名称:" prop="name">
              <el-input v-model="temp.name"></el-input>
            </el-form-item>
          </el-form>
        </div>
        <template #footer>
          <span class="dialog-footer">
            <el-button @click="dialogVisible = false">取 消</el-button>
            <el-button type="primary" @click="dialogStatus==='edit'?edit_fn('temp'):add_fn('temp')">确 定
            </el-button>
          </span>
        </template>
      </el-dialog>
    </div>
  </div>
</template>
<script>

  //   import htmlToPdf from '@/vendor/htmlToPdf';
  import {getAllEnergyType,getAllTypeByGroup,getAppTypeByGroupId,saveEnergyType,deleteEnergyType} from "../../api/energySubType";
  import {findAllAppType,apptypeSave,apptypeDeleteById} from "../../api/application";
  import resourcesStore from '@/cache/resourcesStore.js'
  import elIconBtn from '@/components/module/iconBtns.vue'
  export default {
    components: {elIconBtn},
    data () {
      return {
        tableData1: [],
        isMask: false,//遮罩层
        loading: true,
        searchName: "",//搜索名称
        total: 0,
        topLevel: 0,
        detail_status: false,
        Password: '',
        temp: {},
        dialogStatus: '',
        textMap: {
          add: "新增",
          edit: "编辑"
        },
        heights: document.getElementById('app').clientHeight-250,
        tableData: [
          {
            "createTime": null,
            "no": 0,
            "name": "未定义",
            "groupId": "322b3084ed36478facef59016767d0cc",
            "id": "5FDFF98A-9C72-434C-B8BA-28340059BDA6",
            "energyType": null,
            "useDifference": null,
            "enable": 0,
            "entityName": "AppType"
          },
          {
            "createTime": null,
            "no": 1,
            "name": "A相电压",
            "groupId": "31ed13da-4c8d-4d80-8ada-a3713762a49d",
            "id": "F7C2BBAE-E12F-4AB3-957A-15EA261D6677",
            "energyType": null,
            "useDifference": null,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": null,
            "no": 2,
            "name": "B相电压",
            "groupId": "31ed13da-4c8d-4d80-8ada-a3713762a49d",
            "id": "2C488892-10FB-41B9-A170-31CA5563477D",
            "energyType": null,
            "useDifference": null,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": null,
            "no": 3,
            "name": "C相电压",
            "groupId": "31ed13da-4c8d-4d80-8ada-a3713762a49d",
            "id": "3C8785C3-15ED-444F-90EA-EAAFFC43C3AD",
            "energyType": null,
            "useDifference": null,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": null,
            "no": 4,
            "name": "三相平均电压",
            "groupId": "31ed13da-4c8d-4d80-8ada-a3713762a49d",
            "id": "386B4CAD-3C2B-493C-86E2-1A4A54BD90C1",
            "energyType": null,
            "useDifference": null,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": null,
            "no": 5,
            "name": "A相电流",
            "groupId": "aec119cd-245d-4432-b97d-1a11646377c0",
            "id": "C22E2981-3627-49EF-A93E-4A3AC1983994",
            "energyType": 0,
            "useDifference": 1,
            "enable": 0,
            "entityName": "AppType"
          },
          {
            "createTime": null,
            "no": 6,
            "name": "B相电流",
            "groupId": "aec119cd-245d-4432-b97d-1a11646377c0",
            "id": "6EC6E71D-3A7A-4C78-A044-6D8CF4B49ABA",
            "energyType": null,
            "useDifference": null,
            "enable": 0,
            "entityName": "AppType"
          },
          {
            "createTime": null,
            "no": 7,
            "name": "C相电流",
            "groupId": "aec119cd-245d-4432-b97d-1a11646377c0",
            "id": "412EAD66-2930-4AE8-BDAD-386D2B788A0F",
            "energyType": null,
            "useDifference": null,
            "enable": 0,
            "entityName": "AppType"
          },
          {
            "createTime": null,
            "no": 8,
            "name": "三相平均电流",
            "groupId": "aec119cd-245d-4432-b97d-1a11646377c0",
            "id": "32C1BB4E-0E09-4AF0-9D8A-2EA07D9BE786",
            "energyType": null,
            "useDifference": null,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": null,
            "no": 9,
            "name": "AB线电压",
            "groupId": "62aba95d8257461ebeeccc9a23527835",
            "id": "BBD32FC9-1981-4316-9621-FFFF2BBBD336",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": null,
            "no": 10,
            "name": "AC线电压",
            "groupId": "62aba95d8257461ebeeccc9a23527835",
            "id": "A153C0D0-687B-47D5-AB36-031747155BD8",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": null,
            "no": 11,
            "name": "BC线电压",
            "groupId": "62aba95d8257461ebeeccc9a23527835",
            "id": "5C380197-E8DA-429D-ACBE-A35C7ACE6E21",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": null,
            "no": 12,
            "name": "零序电压",
            "groupId": "5af3a0bd9ab44fcf8f5a8701f3e0fce7",
            "id": "6D068ED3-8DE6-4D6D-81B6-626AE19716C6",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": null,
            "no": 13,
            "name": "零序电流",
            "groupId": "6112b4ffa672403fa4fdfc740f0ff6b7",
            "id": "75B3D077-2210-4D85-9BD2-810C0ED82964",
            "energyType": 0,
            "useDifference": 0,
            "enable": 0,
            "entityName": "AppType"
          },
          {
            "createTime": null,
            "no": 14,
            "name": "正序电压",
            "groupId": "6ab82e01ce0245dcbd716c263203413a",
            "id": "44A9BBA3-CF1E-4803-98EE-F391597E5FC2",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": null,
            "no": 15,
            "name": "负序电压",
            "groupId": "99b9170fb1e14b368ab5472691036b8a",
            "id": "F925DFDB-D902-49AE-B326-AE84967391BF",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": null,
            "no": 16,
            "name": "正序电流",
            "groupId": "37e416b7505d483e83914de07891bf35",
            "id": "30F5C930-28CD-4A87-A1CC-4FA2CCCC26D9",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": null,
            "no": 17,
            "name": "负序电流",
            "groupId": "cd569d69dd734363824d699d36e8b5cd",
            "id": "FB6CCDA7-83AE-4721-8AA0-4521C56CFC43",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": null,
            "no": 18,
            "name": "频率",
            "groupId": "43e52f5c-cb53-49ed-a939-70305044eaa4",
            "id": "3E6FC81B-404A-4A82-8A65-B357C0CDB682",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": null,
            "no": 19,
            "name": "A相有功功率",
            "groupId": "cf19635a-e5b7-4aec-b0e3-b8acd85ba8ce",
            "id": "67DB5C00-79A2-4A6E-9C15-42CE6BE7A77B",
            "energyType": null,
            "useDifference": null,
            "enable": 0,
            "entityName": "AppType"
          },
          {
            "createTime": null,
            "no": 20,
            "name": "B相有功功率",
            "groupId": "cf19635a-e5b7-4aec-b0e3-b8acd85ba8ce",
            "id": "383C3657-D260-4A54-94E8-6C8998182118",
            "energyType": null,
            "useDifference": null,
            "enable": 0,
            "entityName": "AppType"
          },
          {
            "createTime": null,
            "no": 21,
            "name": "C相有功功率",
            "groupId": "cf19635a-e5b7-4aec-b0e3-b8acd85ba8ce",
            "id": "3349E75F-2BA1-4AA4-B67F-6761E78B986E",
            "energyType": null,
            "useDifference": null,
            "enable": 0,
            "entityName": "AppType"
          },
          {
            "createTime": null,
            "no": 22,
            "name": "A相无功功率",
            "groupId": "baf429044ce84086bea7cdaec8cbc819",
            "id": "728D59C6-8599-417C-AB52-CC633D591B61",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": null,
            "no": 23,
            "name": "B相无功功率",
            "groupId": "baf429044ce84086bea7cdaec8cbc819",
            "id": "AED6FB27-8382-4E84-A337-26148D5CC525",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": null,
            "no": 24,
            "name": "C相无功功率",
            "groupId": "baf429044ce84086bea7cdaec8cbc819",
            "id": "13F793E1-B98D-460A-9DB4-3CBD16C23369",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": null,
            "no": 25,
            "name": "A相视在功率",
            "groupId": "d9ea197686464ca792ecb41077fc1573",
            "id": "19D9A50B-9C4A-418F-A99B-C47DF14ACDD7",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": null,
            "no": 26,
            "name": "B相视在功率",
            "groupId": "d9ea197686464ca792ecb41077fc1573",
            "id": "E055CEB5-C0C4-4B0D-B1CA-1F02D48C0EF4",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": null,
            "no": 27,
            "name": "C相视在功率",
            "groupId": "d9ea197686464ca792ecb41077fc1573",
            "id": "E39392DC-4DC7-410C-A47D-203D7175A30C",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": null,
            "no": 28,
            "name": "A相功率因数",
            "groupId": "66bc34d4302f485b8a185cb1d4677592",
            "id": "29768F31-0BB4-49DE-AB01-4907B53F9A0B",
            "energyType": null,
            "useDifference": null,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": null,
            "no": 29,
            "name": "B相功率因数",
            "groupId": "66bc34d4302f485b8a185cb1d4677592",
            "id": "381F3606-26AC-4C78-8BDD-AE276C6A0ED8",
            "energyType": null,
            "useDifference": null,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": null,
            "no": 30,
            "name": "C相功率因数",
            "groupId": "66bc34d4302f485b8a185cb1d4677592",
            "id": "3B05C554-7C8D-4093-B56D-CF289166B7C6",
            "energyType": null,
            "useDifference": null,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": null,
            "no": 31,
            "name": "合相有功功率",
            "groupId": "cf19635a-e5b7-4aec-b0e3-b8acd85ba8ce",
            "id": "355F2620-E041-442C-80A5-EE5C1FFC576B",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": null,
            "no": 32,
            "name": "合相无功功率",
            "groupId": "baf429044ce84086bea7cdaec8cbc819",
            "id": "780B7997-FBFB-43F6-9611-17F4DDB4EE0F",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": null,
            "no": 33,
            "name": "合相视在功率",
            "groupId": "d9ea197686464ca792ecb41077fc1573",
            "id": "4C509362-2172-4C62-829E-071B6F8F4C96",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": null,
            "no": 34,
            "name": "合相功率因数",
            "groupId": "66bc34d4302f485b8a185cb1d4677592",
            "id": "F3F7C528-F229-4499-BE6B-9FC1A707BB2D",
            "energyType": null,
            "useDifference": null,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": null,
            "no": 36,
            "name": "总正向有功电量",
            "groupId": "d9624af6-c056-48d9-aedc-56c08a5d173d",
            "id": "C8A3319C-8300-46E4-A98F-A26C2A010CA2",
            "energyType": 1,
            "useDifference": 1,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": null,
            "no": 37,
            "name": "总反向有功电量",
            "groupId": "d9624af6-c056-48d9-aedc-56c08a5d173d",
            "id": "5266277E-6D00-43DF-AB0F-DA75834793B2",
            "energyType": null,
            "useDifference": null,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": null,
            "no": 38,
            "name": "总正向无功电量",
            "groupId": "fd01ac4c1fc74753b18591f038d765f4",
            "id": "B7B1E1AA-B53D-4C87-B5CB-8DCE7396D4C3",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": null,
            "no": 39,
            "name": "总反向无功电量",
            "groupId": "fd01ac4c1fc74753b18591f038d765f4",
            "id": "6DA62F12-0E90-4017-8B02-06F18BCC1A62",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": null,
            "no": 40,
            "name": "A相电流基波值",
            "groupId": "31264cc78cb24e2cbd96f877a3fc050f",
            "id": "2A150DC4-F0E1-4974-AE2C-C262052BCF41",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": null,
            "no": 41,
            "name": "A相电流2次谐波",
            "groupId": "c787166a171d4dd4bd0b8e42f7f8f822",
            "id": "BFC9CB5C-8383-410B-95A3-4DBD6F872CD4",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": null,
            "no": 42,
            "name": "A相电流3次谐波",
            "groupId": "31264cc78cb24e2cbd96f877a3fc050f",
            "id": "F0F0062E-15BC-4087-BC53-E2661272166C",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": null,
            "no": 43,
            "name": "A相电流4次谐波",
            "groupId": "c787166a171d4dd4bd0b8e42f7f8f822",
            "id": "C06B8CBB-A56F-432E-9082-B07E36A2F216",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": null,
            "no": 44,
            "name": "A相电流5次谐波",
            "groupId": "31264cc78cb24e2cbd96f877a3fc050f",
            "id": "5E848B76-30D2-47F7-B6C2-2D3CC62F6EDD",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": null,
            "no": 45,
            "name": "A相电流6次谐波",
            "groupId": "c787166a171d4dd4bd0b8e42f7f8f822",
            "id": "574DA37D-9D39-41EB-8656-741606C30DE1",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": null,
            "no": 46,
            "name": "A相电流7次谐波",
            "groupId": "31264cc78cb24e2cbd96f877a3fc050f",
            "id": "46449195-EB12-47BA-AF6E-DE3007997A96",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": null,
            "no": 47,
            "name": "A相电流8次谐波",
            "groupId": "c787166a171d4dd4bd0b8e42f7f8f822",
            "id": "6D8E1392-81CA-4D53-B35C-EA12A53B2A6E",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": null,
            "no": 48,
            "name": "A相电流9次谐波",
            "groupId": "31264cc78cb24e2cbd96f877a3fc050f",
            "id": "28C03C3A-D163-4F17-B186-7D86415BFF56",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": null,
            "no": 49,
            "name": "A相电流10次谐波",
            "groupId": "c787166a171d4dd4bd0b8e42f7f8f822",
            "id": "396F1C72-0CF8-43B4-858F-11787E20A013",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": null,
            "no": 50,
            "name": "A相电流11次谐波",
            "groupId": "31264cc78cb24e2cbd96f877a3fc050f",
            "id": "1F3C1F86-C10B-485E-BE88-A05D3258D54D",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": null,
            "no": 51,
            "name": "A相电流12次谐波",
            "groupId": "c787166a171d4dd4bd0b8e42f7f8f822",
            "id": "F5B1DEAB-E072-477E-87EC-371F781B60CC",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": null,
            "no": 52,
            "name": "A相电流13次谐波",
            "groupId": "31264cc78cb24e2cbd96f877a3fc050f",
            "id": "D9F8B440-7DDD-4844-8714-0EC994324792",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": null,
            "no": 53,
            "name": "A相电流14次谐波",
            "groupId": "c787166a171d4dd4bd0b8e42f7f8f822",
            "id": "BB1FA517-59D2-4DB1-9D60-CC485FEAB728",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": null,
            "no": 54,
            "name": "A相电流15次谐波",
            "groupId": "31264cc78cb24e2cbd96f877a3fc050f",
            "id": "E78FEBCE-B284-4B8E-B457-86FB3CB81D81",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": null,
            "no": 55,
            "name": "A相电流16次谐波",
            "groupId": "c787166a171d4dd4bd0b8e42f7f8f822",
            "id": "C9162212-489C-450A-BCFF-D767951DBBA8",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": null,
            "no": 56,
            "name": "A相电流17次谐波",
            "groupId": "31264cc78cb24e2cbd96f877a3fc050f",
            "id": "399CAF82-20D0-4C73-8C20-75101369FA59",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": null,
            "no": 57,
            "name": "A相电流18次谐波",
            "groupId": "c787166a171d4dd4bd0b8e42f7f8f822",
            "id": "19BE557B-56BB-4470-8F10-CE828445A05F",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": null,
            "no": 58,
            "name": "A相电流19次谐波",
            "groupId": "31264cc78cb24e2cbd96f877a3fc050f",
            "id": "A6CBF9CD-D283-4EB1-A01F-2D9C74D69092",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": null,
            "no": 59,
            "name": "A相电流20次谐波",
            "groupId": "c787166a171d4dd4bd0b8e42f7f8f822",
            "id": "739D3404-A170-4585-9FE7-F3EC4E4267A8",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": null,
            "no": 60,
            "name": "A相电流21次谐波",
            "groupId": "31264cc78cb24e2cbd96f877a3fc050f",
            "id": "45A4B667-AE6C-4185-BA9D-335D29FC2B4E",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": null,
            "no": 61,
            "name": "A相电流22次谐波",
            "groupId": "c787166a171d4dd4bd0b8e42f7f8f822",
            "id": "2E3E5DBC-E245-43AF-B423-B64CEA549462",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": null,
            "no": 62,
            "name": "A相电流23次谐波",
            "groupId": "31264cc78cb24e2cbd96f877a3fc050f",
            "id": "3EE7AD02-84FF-41D8-A410-5FC1B8F61BC9",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": null,
            "no": 63,
            "name": "A相电流24次谐波",
            "groupId": "c787166a171d4dd4bd0b8e42f7f8f822",
            "id": "0E4EDD96-584D-4950-BC31-5236BAAEE9FC",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": null,
            "no": 64,
            "name": "A相电流25次谐波",
            "groupId": "31264cc78cb24e2cbd96f877a3fc050f",
            "id": "5C7D4101-79AE-4D13-A705-3986F65D0550",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": null,
            "no": 65,
            "name": "A相电流26次谐波",
            "groupId": "c787166a171d4dd4bd0b8e42f7f8f822",
            "id": "B6B047CD-8D26-4F46-9931-99BBB47000C9",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": null,
            "no": 66,
            "name": "A相电流27次谐波",
            "groupId": "31264cc78cb24e2cbd96f877a3fc050f",
            "id": "D3D67BC5-4C44-4FC6-9BB9-D4C479B9B61B",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": null,
            "no": 67,
            "name": "A相电流28次谐波",
            "groupId": "c787166a171d4dd4bd0b8e42f7f8f822",
            "id": "3D2989E6-6111-41EE-901C-733CD83B0BA0",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": null,
            "no": 68,
            "name": "A相电流29次谐波",
            "groupId": "31264cc78cb24e2cbd96f877a3fc050f",
            "id": "A75EC29B-7126-4285-A2DB-E69B74256223",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": null,
            "no": 69,
            "name": "A相电流30次谐波",
            "groupId": "c787166a171d4dd4bd0b8e42f7f8f822",
            "id": "3D3DDA5E-6C54-4BFE-9056-1F501019978C",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": null,
            "no": 70,
            "name": "A相电流31次谐波",
            "groupId": "31264cc78cb24e2cbd96f877a3fc050f",
            "id": "F66AD7A8-98DF-4F87-A9FA-EFBEF1D7E27B",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": null,
            "no": 71,
            "name": "A相电流波形畸变率",
            "groupId": "5f0330d6ea404867b1277b701c103aa3",
            "id": "79B98E0C-25F7-4416-80DA-0BD9A83B0494",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": null,
            "no": 72,
            "name": "B相电流基波值",
            "groupId": "c268a034d37543899878a543c16319c3",
            "id": "EE0E549C-D613-44B0-A05C-913CFC40786E",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": null,
            "no": 73,
            "name": "B相电流2次谐波",
            "groupId": "7cb145e48bec44da9f8106e47a1f5bc7",
            "id": "9B76F69D-89A2-4E05-9949-D8A5E1A4B40E",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": null,
            "no": 74,
            "name": "B相电流3次谐波",
            "groupId": "c268a034d37543899878a543c16319c3",
            "id": "81D8AD49-55E7-43E6-8279-470A662A4A7F",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": null,
            "no": 75,
            "name": "B相电流4次谐波",
            "groupId": "7cb145e48bec44da9f8106e47a1f5bc7",
            "id": "B6B6CDF7-7ED3-47E2-84E1-8691749B4B8E",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": null,
            "no": 76,
            "name": "B相电流5次谐波",
            "groupId": "c268a034d37543899878a543c16319c3",
            "id": "2ECAD7C9-0BE5-452F-9BB7-FFCCE7EDBBC2",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": null,
            "no": 77,
            "name": "B相电流6次谐波",
            "groupId": "7cb145e48bec44da9f8106e47a1f5bc7",
            "id": "71936AE7-2BEC-46C2-8875-1FC0B8ABCEE1",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": null,
            "no": 78,
            "name": "B相电流7次谐波",
            "groupId": "c268a034d37543899878a543c16319c3",
            "id": "1454AADA-775E-4DF1-AB56-280D6B9AB29C",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": null,
            "no": 79,
            "name": "B相电流8次谐波",
            "groupId": "7cb145e48bec44da9f8106e47a1f5bc7",
            "id": "CD192A99-DC2F-48B9-A03D-7DCCA4BB5340",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": null,
            "no": 80,
            "name": "B相电流9次谐波",
            "groupId": "c268a034d37543899878a543c16319c3",
            "id": "3E9FABC9-7D61-41D3-B209-267DE4DDA49F",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": null,
            "no": 81,
            "name": "B相电流10次谐波",
            "groupId": "7cb145e48bec44da9f8106e47a1f5bc7",
            "id": "03EBC024-4FBB-4855-81E3-9D90747577A0",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": null,
            "no": 82,
            "name": "B相电流11次谐波",
            "groupId": "c268a034d37543899878a543c16319c3",
            "id": "2C8AF5F8-B512-47A9-A8E6-0C9D8732F1CB",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": null,
            "no": 83,
            "name": "B相电流12次谐波",
            "groupId": "7cb145e48bec44da9f8106e47a1f5bc7",
            "id": "860B6CC6-E928-40E7-89BD-E61F9390B33A",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": null,
            "no": 84,
            "name": "B相电流13次谐波",
            "groupId": "c268a034d37543899878a543c16319c3",
            "id": "2281CD03-C35F-4755-A4A3-0DFC199CB2CB",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": null,
            "no": 85,
            "name": "B相电流14次谐波",
            "groupId": "7cb145e48bec44da9f8106e47a1f5bc7",
            "id": "390289C6-CFB5-47CC-BCFE-6887D95017A6",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": null,
            "no": 86,
            "name": "B相电流15次谐波",
            "groupId": "c268a034d37543899878a543c16319c3",
            "id": "34DD35F5-81D1-4262-AE5E-93E0E30724ED",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": null,
            "no": 87,
            "name": "B相电流16次谐波",
            "groupId": "7cb145e48bec44da9f8106e47a1f5bc7",
            "id": "BF67491E-76BC-42EF-A335-839C635C0A64",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": null,
            "no": 88,
            "name": "B相电流17次谐波",
            "groupId": "c268a034d37543899878a543c16319c3",
            "id": "25E9F559-653E-4369-9A6E-7DBD22D485FC",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": null,
            "no": 89,
            "name": "B相电流18次谐波",
            "groupId": "7cb145e48bec44da9f8106e47a1f5bc7",
            "id": "CA301D00-E374-437F-BA94-7DE2AEF444A5",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": null,
            "no": 90,
            "name": "B相电流19次谐波",
            "groupId": "c268a034d37543899878a543c16319c3",
            "id": "87E64B61-7201-4C49-A772-CA17F682530C",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": null,
            "no": 91,
            "name": "B相电流20次谐波",
            "groupId": "7cb145e48bec44da9f8106e47a1f5bc7",
            "id": "CF9A85BC-BED4-4390-9321-5272D5EB0070",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": null,
            "no": 92,
            "name": "B相电流21次谐波",
            "groupId": "c268a034d37543899878a543c16319c3",
            "id": "A5C2645D-7C38-4D94-92C4-9940652B4266",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": null,
            "no": 93,
            "name": "B相电流22次谐波",
            "groupId": "7cb145e48bec44da9f8106e47a1f5bc7",
            "id": "67A37192-E75B-428C-8B97-6E2A2A4488C4",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": null,
            "no": 94,
            "name": "B相电流23次谐波",
            "groupId": "c268a034d37543899878a543c16319c3",
            "id": "876EA66B-12D6-434E-9F72-2C97A4ABF6BD",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": null,
            "no": 95,
            "name": "B相电流24次谐波",
            "groupId": "7cb145e48bec44da9f8106e47a1f5bc7",
            "id": "1192F7F1-EEE4-40A7-8E24-26978FC73F2F",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": null,
            "no": 96,
            "name": "B相电流25次谐波",
            "groupId": "c268a034d37543899878a543c16319c3",
            "id": "27C855E9-A29A-428A-9FEA-95E05CF07E0B",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": null,
            "no": 97,
            "name": "B相电流26次谐波",
            "groupId": "7cb145e48bec44da9f8106e47a1f5bc7",
            "id": "E2A39B29-D6E0-4881-8934-8C9E6E3A84E4",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": null,
            "no": 98,
            "name": "B相电流27次谐波",
            "groupId": "c268a034d37543899878a543c16319c3",
            "id": "8AD9FD51-B703-4203-880F-668D48FB9A29",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": null,
            "no": 99,
            "name": "B相电流28次谐波",
            "groupId": "7cb145e48bec44da9f8106e47a1f5bc7",
            "id": "C80318AF-2356-454F-A194-16E44430BBE1",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": null,
            "no": 100,
            "name": "B相电流29次谐波",
            "groupId": "c268a034d37543899878a543c16319c3",
            "id": "679333FF-E14A-4060-A00C-E2D83229BD2D",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": null,
            "no": 101,
            "name": "B相电流30次谐波",
            "groupId": "7cb145e48bec44da9f8106e47a1f5bc7",
            "id": "360C60B2-0BCC-4726-A6B7-4B20CB1CFE1A",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": null,
            "no": 102,
            "name": "B相电流31次谐波",
            "groupId": "c268a034d37543899878a543c16319c3",
            "id": "EF229CBF-E57B-4395-847B-EF4D32AE7E70",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": null,
            "no": 103,
            "name": "B相电流波形畸变率",
            "groupId": "5f0330d6ea404867b1277b701c103aa3",
            "id": "29739C25-F91C-4AD4-B870-7D2A1175B257",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": null,
            "no": 104,
            "name": "C相电流基波值",
            "groupId": "c268a034d37543899878a543c16319c3",
            "id": "12874DF0-2EB4-4A6C-A575-C11F07179EE6",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": null,
            "no": 105,
            "name": "C相电流2次谐波",
            "groupId": "5aeb354075454843bc6507f31744627e",
            "id": "832086F8-1047-4672-BE9F-07BC8BD48535",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": null,
            "no": 106,
            "name": "C相电流3次谐波",
            "groupId": "8d878a039a354c2cacd5aaea86c04f04",
            "id": "2DC81525-F5FD-4091-A9EA-EE217C298DF3",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": null,
            "no": 107,
            "name": "C相电流4次谐波",
            "groupId": "5aeb354075454843bc6507f31744627e",
            "id": "EED7E413-F969-493A-8FAE-9FBB5796F887",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": null,
            "no": 108,
            "name": "C相电流5次谐波",
            "groupId": "8d878a039a354c2cacd5aaea86c04f04",
            "id": "0625AF02-A78D-41E9-AA42-3B47987B6D32",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": null,
            "no": 109,
            "name": "C相电流6次谐波",
            "groupId": "5aeb354075454843bc6507f31744627e",
            "id": "BF1BF732-6887-477E-9C85-5110ADA02076",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": null,
            "no": 110,
            "name": "C相电流7次谐波",
            "groupId": "8d878a039a354c2cacd5aaea86c04f04",
            "id": "245716E2-8E19-4D62-96C9-F6E1A082DA13",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": null,
            "no": 111,
            "name": "C相电流8次谐波",
            "groupId": "5aeb354075454843bc6507f31744627e",
            "id": "FB68DEDA-AFBF-4089-B248-8E670D56EDDE",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": null,
            "no": 112,
            "name": "C相电流9次谐波",
            "groupId": "8d878a039a354c2cacd5aaea86c04f04",
            "id": "B6CE4BA1-2A52-4E9C-9851-F3E7ABCD24C0",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": null,
            "no": 113,
            "name": "C相电流10次谐波",
            "groupId": "5aeb354075454843bc6507f31744627e",
            "id": "CAB1E36B-17B4-4390-8899-3C662825EF45",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": null,
            "no": 114,
            "name": "C相电流11次谐波",
            "groupId": "8d878a039a354c2cacd5aaea86c04f04",
            "id": "630336E2-5F67-4F70-87E3-6B3ED030944F",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": null,
            "no": 115,
            "name": "C相电流12次谐波",
            "groupId": "5aeb354075454843bc6507f31744627e",
            "id": "04C3FEC4-46D9-4D28-AD38-640048F479A1",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": null,
            "no": 116,
            "name": "C相电流13次谐波",
            "groupId": "8d878a039a354c2cacd5aaea86c04f04",
            "id": "D40920CF-6DE0-4269-AA13-E2CB206AC748",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": null,
            "no": 117,
            "name": "C相电流14次谐波",
            "groupId": "5aeb354075454843bc6507f31744627e",
            "id": "5EC1FFBD-DE4E-43F5-989A-1B729BD939EA",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": null,
            "no": 118,
            "name": "C相电流15次谐波",
            "groupId": "8d878a039a354c2cacd5aaea86c04f04",
            "id": "B1E8AB15-0272-44AB-8652-9EB933E92D45",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": null,
            "no": 119,
            "name": "C相电流16次谐波",
            "groupId": "5aeb354075454843bc6507f31744627e",
            "id": "2DF9B8BF-5BEA-4952-A3FF-2CC9A2F105D5",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": null,
            "no": 120,
            "name": "C相电流17次谐波",
            "groupId": "8d878a039a354c2cacd5aaea86c04f04",
            "id": "46111965-24D3-4607-8D83-E29661C9DFB0",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": null,
            "no": 121,
            "name": "C相电流18次谐波",
            "groupId": "5aeb354075454843bc6507f31744627e",
            "id": "3524A75D-5A79-4A4A-A5DB-DCD5DA95E361",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": null,
            "no": 122,
            "name": "C相电流19次谐波",
            "groupId": "8d878a039a354c2cacd5aaea86c04f04",
            "id": "C6728AAE-FBE7-4C3C-A5F6-1EF59BE8EF8E",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": null,
            "no": 123,
            "name": "C相电流20次谐波",
            "groupId": "5aeb354075454843bc6507f31744627e",
            "id": "E75E6ABE-EA17-48B6-AEE0-DBFEC666D242",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": null,
            "no": 124,
            "name": "C相电流21次谐波",
            "groupId": "8d878a039a354c2cacd5aaea86c04f04",
            "id": "85129551-3F05-45E0-8FB1-BD3725AD86D1",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": null,
            "no": 125,
            "name": "C相电流22次谐波",
            "groupId": "5aeb354075454843bc6507f31744627e",
            "id": "8404F2D0-F98C-46A1-A1B9-8A54912D2634",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": null,
            "no": 126,
            "name": "C相电流23次谐波",
            "groupId": "8d878a039a354c2cacd5aaea86c04f04",
            "id": "4DE4F408-FEB6-4BB9-A825-AC407FB83363",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": null,
            "no": 127,
            "name": "C相电流24次谐波",
            "groupId": "5aeb354075454843bc6507f31744627e",
            "id": "280DD5B9-5537-4CD6-BA01-288D8B5CA806",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": null,
            "no": 128,
            "name": "C相电流25次谐波",
            "groupId": "8d878a039a354c2cacd5aaea86c04f04",
            "id": "F226D496-9810-4E89-AF9A-6B884A2FC8A2",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": null,
            "no": 129,
            "name": "C相电流26次谐波",
            "groupId": "5aeb354075454843bc6507f31744627e",
            "id": "8487E092-3AC1-42B9-BE56-3C2C2660416F",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": null,
            "no": 130,
            "name": "C相电流27次谐波",
            "groupId": "8d878a039a354c2cacd5aaea86c04f04",
            "id": "E02C4C1E-C8CA-4C0E-802A-B3CB847A92ED",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": null,
            "no": 131,
            "name": "C相电流28次谐波",
            "groupId": "5aeb354075454843bc6507f31744627e",
            "id": "47BB5055-C2D3-457D-9CB3-C9D8113C675B",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": null,
            "no": 132,
            "name": "C相电流29次谐波",
            "groupId": "8d878a039a354c2cacd5aaea86c04f04",
            "id": "607C55D4-BE0A-4438-8A4E-11BA60558694",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": null,
            "no": 133,
            "name": "C相电流30次谐波",
            "groupId": "5aeb354075454843bc6507f31744627e",
            "id": "ECE410C3-6FFC-4475-8217-5C48833E0597",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": null,
            "no": 134,
            "name": "C相电流31次谐波",
            "groupId": "8d878a039a354c2cacd5aaea86c04f04",
            "id": "CF44B365-A6F1-4DAB-B4E9-90A4B4FA03F5",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": null,
            "no": 135,
            "name": "C相电流波形畸变率",
            "groupId": "5f0330d6ea404867b1277b701c103aa3",
            "id": "3D0BA9E5-86CB-47E3-A490-814A7FE40512",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": null,
            "no": 136,
            "name": "A相电压基波值",
            "groupId": "7d71e18ff67b4ef08f351755b49fa7e9",
            "id": "B1C0F7B9-7CD3-4D20-BC97-8927F8C0A064",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": null,
            "no": 137,
            "name": "A相电压2次谐波",
            "groupId": "a45c4b96899448d6bdd4300c019f048e",
            "id": "1325B1E8-83D8-4AB6-908A-436A523C3423",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": null,
            "no": 138,
            "name": "A相电压3次谐波",
            "groupId": "7d71e18ff67b4ef08f351755b49fa7e9",
            "id": "77565D60-C8F3-4630-98B3-80BF6DFC659C",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": null,
            "no": 139,
            "name": "A相电压4次谐波",
            "groupId": "a45c4b96899448d6bdd4300c019f048e",
            "id": "D19B9C71-3F62-4194-A9E3-5CA8BF382349",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": null,
            "no": 140,
            "name": "A相电压5次谐波",
            "groupId": "7d71e18ff67b4ef08f351755b49fa7e9",
            "id": "10A8B52C-B513-4568-9129-61DF91534BBD",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": null,
            "no": 141,
            "name": "A相电压6次谐波",
            "groupId": "a45c4b96899448d6bdd4300c019f048e",
            "id": "35421B09-1F5E-4EE3-BA95-13A445C8148C",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": null,
            "no": 142,
            "name": "A相电压7次谐波",
            "groupId": "7d71e18ff67b4ef08f351755b49fa7e9",
            "id": "FBFD5581-F8A6-4211-B249-FD19E1CFA544",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": null,
            "no": 143,
            "name": "A相电压8次谐波",
            "groupId": "a45c4b96899448d6bdd4300c019f048e",
            "id": "7C16DB9B-D0AA-4895-88D8-50B4C0AD5B9B",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": null,
            "no": 144,
            "name": "A相电压9次谐波",
            "groupId": "7d71e18ff67b4ef08f351755b49fa7e9",
            "id": "2DAFD2BA-7335-4B87-8E98-D9777AC32886",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": null,
            "no": 145,
            "name": "A相电压10次谐波",
            "groupId": "a45c4b96899448d6bdd4300c019f048e",
            "id": "A758734F-BA8D-444D-B272-2DAD2287D9B1",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": null,
            "no": 146,
            "name": "A相电压11次谐波",
            "groupId": "7d71e18ff67b4ef08f351755b49fa7e9",
            "id": "4ED8C1B3-CD1B-4ED5-8063-EA8040B01333",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": null,
            "no": 147,
            "name": "A相电压12次谐波",
            "groupId": "a45c4b96899448d6bdd4300c019f048e",
            "id": "926D0556-5A7D-43B0-BFCB-4333E4EBF52D",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": null,
            "no": 148,
            "name": "A相电压13次谐波",
            "groupId": "7d71e18ff67b4ef08f351755b49fa7e9",
            "id": "72929AC1-A9C4-49B6-9C8D-B487195C5898",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": null,
            "no": 149,
            "name": "A相电压14次谐波",
            "groupId": "a45c4b96899448d6bdd4300c019f048e",
            "id": "F7E40FC5-4215-4A98-8F2B-9E01381D8AF4",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": null,
            "no": 150,
            "name": "A相电压15次谐波",
            "groupId": "7d71e18ff67b4ef08f351755b49fa7e9",
            "id": "75DC0218-1B6D-4C06-930B-E46790666711",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": null,
            "no": 151,
            "name": "A相电压16次谐波",
            "groupId": "a45c4b96899448d6bdd4300c019f048e",
            "id": "B25E8EA9-EA76-4FD3-A355-8592632C4BB6",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": null,
            "no": 152,
            "name": "A相电压17次谐波",
            "groupId": "7d71e18ff67b4ef08f351755b49fa7e9",
            "id": "B24AFF04-6E22-4651-9E51-E8E32CE9D1C2",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": null,
            "no": 153,
            "name": "A相电压18次谐波",
            "groupId": "a45c4b96899448d6bdd4300c019f048e",
            "id": "9CEA6804-CCDE-4C31-9825-07CB78B0C1B9",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": null,
            "no": 154,
            "name": "A相电压19次谐波",
            "groupId": "7d71e18ff67b4ef08f351755b49fa7e9",
            "id": "BBBB57CF-3975-4AD3-BE92-30A202F223A1",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": null,
            "no": 155,
            "name": "A相电压20次谐波",
            "groupId": "a45c4b96899448d6bdd4300c019f048e",
            "id": "263DE370-EC43-48C1-ADAA-07764CBADE1D",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": null,
            "no": 156,
            "name": "A相电压21次谐波",
            "groupId": "7d71e18ff67b4ef08f351755b49fa7e9",
            "id": "8DA6150A-0CBF-4769-9666-328C2D97AB03",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": null,
            "no": 157,
            "name": "A相电压22次谐波",
            "groupId": "a45c4b96899448d6bdd4300c019f048e",
            "id": "4D31400D-B1DC-4392-9D94-EBE8D7659DFC",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": null,
            "no": 158,
            "name": "A相电压23次谐波",
            "groupId": "7d71e18ff67b4ef08f351755b49fa7e9",
            "id": "783F5D5C-4F32-4E8F-88BC-446E84878E51",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": null,
            "no": 159,
            "name": "A相电压24次谐波",
            "groupId": "a45c4b96899448d6bdd4300c019f048e",
            "id": "9E278016-1EE1-41D4-A325-88F27702AFD2",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": null,
            "no": 160,
            "name": "A相电压25次谐波",
            "groupId": "7d71e18ff67b4ef08f351755b49fa7e9",
            "id": "9D70652C-B4E0-4BF0-A35F-CBAE065B7F99",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": null,
            "no": 161,
            "name": "A相电压26次谐波",
            "groupId": "a45c4b96899448d6bdd4300c019f048e",
            "id": "583A1726-A36C-4808-9B9D-7DAE4DFFBA7A",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": null,
            "no": 162,
            "name": "A相电压27次谐波",
            "groupId": "7d71e18ff67b4ef08f351755b49fa7e9",
            "id": "12BDACCD-C6CB-4A66-BD81-347240699DF5",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": null,
            "no": 163,
            "name": "A相电压28次谐波",
            "groupId": "a45c4b96899448d6bdd4300c019f048e",
            "id": "44B47459-DA72-4DC6-BB66-CB9BF5D55D94",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": null,
            "no": 164,
            "name": "A相电压29次谐波",
            "groupId": "7d71e18ff67b4ef08f351755b49fa7e9",
            "id": "1535A86E-F7E9-4C22-BD84-2637AABBE9DD",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": null,
            "no": 165,
            "name": "A相电压30次谐波",
            "groupId": "a45c4b96899448d6bdd4300c019f048e",
            "id": "03C5D98C-0B4C-418A-A157-826915DB4B37",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": null,
            "no": 166,
            "name": "A相电压31次谐波",
            "groupId": "7d71e18ff67b4ef08f351755b49fa7e9",
            "id": "9979FF1A-B936-430D-900E-F8503B5F460C",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": null,
            "no": 167,
            "name": "A相电压波形畸变率",
            "groupId": "4f1506f4-3aba-4bdd-a631-8cd194bc5773",
            "id": "3C77B24B-A45C-4832-8A2D-B8E856280899",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": null,
            "no": 168,
            "name": "B相电压基波值",
            "groupId": "db8a02ae83054dc1ba4a60f51c8a2338",
            "id": "9BB01612-8E17-44D6-83C1-D0CFA8CB40A3",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": null,
            "no": 169,
            "name": "B相电压2次谐波",
            "groupId": "51ed3b95f4734825acfe55cf80a28256",
            "id": "E9ECF0A6-3B94-4B2A-99FE-58C3A6710CE3",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": null,
            "no": 170,
            "name": "B相电压3次谐波",
            "groupId": "db8a02ae83054dc1ba4a60f51c8a2338",
            "id": "596989FB-1209-4282-8ACE-DBC7C3E40A1D",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": null,
            "no": 171,
            "name": "B相电压4次谐波",
            "groupId": "51ed3b95f4734825acfe55cf80a28256",
            "id": "BF344899-04FA-4FFD-9193-8E2D345F8A0B",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": null,
            "no": 172,
            "name": "B相电压5次谐波",
            "groupId": "db8a02ae83054dc1ba4a60f51c8a2338",
            "id": "AA2182DE-7B51-43E9-9B5E-100E38972A60",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": null,
            "no": 173,
            "name": "B相电压6次谐波",
            "groupId": "51ed3b95f4734825acfe55cf80a28256",
            "id": "C02F0FB1-26D6-4E9E-A98B-1A91D9EF879D",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": null,
            "no": 174,
            "name": "B相电压7次谐波",
            "groupId": "db8a02ae83054dc1ba4a60f51c8a2338",
            "id": "7769DA15-4961-4F26-B47B-C80494467A1D",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": null,
            "no": 175,
            "name": "B相电压8次谐波",
            "groupId": "51ed3b95f4734825acfe55cf80a28256",
            "id": "307A0DB0-9BD5-4531-936A-768A62CB0A15",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": null,
            "no": 176,
            "name": "B相电压9次谐波",
            "groupId": "db8a02ae83054dc1ba4a60f51c8a2338",
            "id": "90F4B02E-D41F-4852-B73A-021FEB35C6BF",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": null,
            "no": 177,
            "name": "B相电压10次谐波",
            "groupId": "51ed3b95f4734825acfe55cf80a28256",
            "id": "4370AEAA-D4DA-497B-B26D-19A24A703D21",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": null,
            "no": 178,
            "name": "B相电压11次谐波",
            "groupId": "db8a02ae83054dc1ba4a60f51c8a2338",
            "id": "F93F27DC-2F32-4D7D-ABD8-E1B2D6230557",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": null,
            "no": 179,
            "name": "B相电压12次谐波",
            "groupId": "51ed3b95f4734825acfe55cf80a28256",
            "id": "D506EB27-5A7E-4EC7-9868-FE8137E218BF",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": null,
            "no": 180,
            "name": "B相电压13次谐波",
            "groupId": "db8a02ae83054dc1ba4a60f51c8a2338",
            "id": "8620F344-77FC-4580-9581-E01972B31619",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": null,
            "no": 181,
            "name": "B相电压14次谐波",
            "groupId": "51ed3b95f4734825acfe55cf80a28256",
            "id": "E1887C17-74CC-416E-A371-52C58C4B350B",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": null,
            "no": 182,
            "name": "B相电压15次谐波",
            "groupId": "db8a02ae83054dc1ba4a60f51c8a2338",
            "id": "F48E8F55-4DD0-46DB-BC31-84D8FD314892",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": null,
            "no": 183,
            "name": "B相电压16次谐波",
            "groupId": "51ed3b95f4734825acfe55cf80a28256",
            "id": "297B5E17-9813-4FF2-81B8-23423D23C4FF",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": null,
            "no": 184,
            "name": "B相电压17次谐波",
            "groupId": "db8a02ae83054dc1ba4a60f51c8a2338",
            "id": "0EE11951-5E21-44DC-A513-D575D3D9288D",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": null,
            "no": 185,
            "name": "B相电压18次谐波",
            "groupId": "51ed3b95f4734825acfe55cf80a28256",
            "id": "B837337A-C7C9-4715-A2ED-B31FC2A4B628",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": null,
            "no": 186,
            "name": "B相电压19次谐波",
            "groupId": "db8a02ae83054dc1ba4a60f51c8a2338",
            "id": "8B2E5C73-120E-4B55-ACAF-F2C2BB73E80E",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": null,
            "no": 187,
            "name": "B相电压20次谐波",
            "groupId": "51ed3b95f4734825acfe55cf80a28256",
            "id": "D8C6FD11-63B9-42F1-9370-C2B451EC135F",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": null,
            "no": 188,
            "name": "B相电压21次谐波",
            "groupId": "db8a02ae83054dc1ba4a60f51c8a2338",
            "id": "BE9DBC89-2B09-4F3C-9A1E-D5458EDA15A8",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": null,
            "no": 189,
            "name": "B相电压22次谐波",
            "groupId": "51ed3b95f4734825acfe55cf80a28256",
            "id": "754CBBEE-8218-440D-8348-BAF8195B6AD1",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": null,
            "no": 190,
            "name": "B相电压23次谐波",
            "groupId": "db8a02ae83054dc1ba4a60f51c8a2338",
            "id": "235B4D1A-E5A0-45C8-A7BC-4F10981D8220",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": null,
            "no": 191,
            "name": "B相电压24次谐波",
            "groupId": "51ed3b95f4734825acfe55cf80a28256",
            "id": "909F751F-1CEB-4570-B7B4-FEE2F24E3451",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": null,
            "no": 192,
            "name": "B相电压25次谐波",
            "groupId": "db8a02ae83054dc1ba4a60f51c8a2338",
            "id": "6E25F9D8-0DA0-44EC-BDAD-85A29DF01DEC",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": null,
            "no": 193,
            "name": "B相电压26次谐波",
            "groupId": "51ed3b95f4734825acfe55cf80a28256",
            "id": "A932105F-48B8-4B0B-81B8-08A3026EA76E",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": null,
            "no": 194,
            "name": "B相电压27次谐波",
            "groupId": "db8a02ae83054dc1ba4a60f51c8a2338",
            "id": "94FA29A7-4765-4F3F-9753-67493BC817B5",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": null,
            "no": 195,
            "name": "B相电压28次谐波",
            "groupId": "51ed3b95f4734825acfe55cf80a28256",
            "id": "EABD3D1D-67D6-49F4-827B-9FFC1B82E7E7",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": null,
            "no": 196,
            "name": "B相电压29次谐波",
            "groupId": "db8a02ae83054dc1ba4a60f51c8a2338",
            "id": "4ADD8FED-61A3-4169-BCAA-93550460F573",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": null,
            "no": 197,
            "name": "B相电压30次谐波",
            "groupId": "51ed3b95f4734825acfe55cf80a28256",
            "id": "9B816D16-9D41-4D78-8142-58200C5356D0",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": null,
            "no": 198,
            "name": "B相电压31次谐波",
            "groupId": "db8a02ae83054dc1ba4a60f51c8a2338",
            "id": "5748E294-E12E-4E33-B5BE-AB3F68793A65",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": null,
            "no": 199,
            "name": "B相电压波形畸变率",
            "groupId": "4f1506f4-3aba-4bdd-a631-8cd194bc5773",
            "id": "97CC2370-E59D-4515-8B7B-72F6992B15AB",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": null,
            "no": 200,
            "name": "C相电压基波值",
            "groupId": "9b1f5445f7f54702899327d31b3ca00d",
            "id": "4E51E6A0-DBC0-4104-A6EC-AD8284A27BD3",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": null,
            "no": 201,
            "name": "C相电压2次谐波",
            "groupId": "43dda3a9f9e34bc0a45b434263862565",
            "id": "73E20B81-FEAA-4130-87BD-1EE5687DBE01",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": null,
            "no": 202,
            "name": "C相电压3次谐波",
            "groupId": "9b1f5445f7f54702899327d31b3ca00d",
            "id": "C6E0F8B7-768F-46EC-B146-E152D8B24D1B",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": null,
            "no": 203,
            "name": "C相电压4次谐波",
            "groupId": "43dda3a9f9e34bc0a45b434263862565",
            "id": "0E176DA7-E1B2-45EE-BAD8-EC66168A7E6A",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": null,
            "no": 204,
            "name": "C相电压5次谐波",
            "groupId": "9b1f5445f7f54702899327d31b3ca00d",
            "id": "AB9DF1C6-F354-4DCD-9F6D-E3B8DB91DDB2",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": null,
            "no": 205,
            "name": "C相电压6次谐波",
            "groupId": "43dda3a9f9e34bc0a45b434263862565",
            "id": "861E035E-E757-49B2-9AC1-BE0D2A60DDD0",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": null,
            "no": 206,
            "name": "C相电压7次谐波",
            "groupId": "9b1f5445f7f54702899327d31b3ca00d",
            "id": "A8683CE3-F04F-4FC6-896E-AD39DC91A3EB",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": null,
            "no": 207,
            "name": "C相电压8次谐波",
            "groupId": "43dda3a9f9e34bc0a45b434263862565",
            "id": "2DE3809D-BEC9-4898-8E46-05FAAA60E3FB",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": null,
            "no": 208,
            "name": "C相电压9次谐波",
            "groupId": "9b1f5445f7f54702899327d31b3ca00d",
            "id": "F70786A9-B173-4C7E-AF31-67D67A75FB37",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": null,
            "no": 209,
            "name": "C相电压10次谐波",
            "groupId": "43dda3a9f9e34bc0a45b434263862565",
            "id": "54A1B01B-2023-4535-9D17-9FD04AE99104",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": null,
            "no": 210,
            "name": "C相电压11次谐波",
            "groupId": "9b1f5445f7f54702899327d31b3ca00d",
            "id": "C7F413B2-5BD9-46E2-B618-2456BB0E2962",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": null,
            "no": 211,
            "name": "C相电压12次谐波",
            "groupId": "43dda3a9f9e34bc0a45b434263862565",
            "id": "BE811E84-59DF-4C73-BD51-7B104112A790",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": null,
            "no": 212,
            "name": "C相电压13次谐波",
            "groupId": "9b1f5445f7f54702899327d31b3ca00d",
            "id": "2C6F5A07-063C-4BC4-BC9D-A006FBBC1BF7",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": null,
            "no": 213,
            "name": "C相电压14次谐波",
            "groupId": "43dda3a9f9e34bc0a45b434263862565",
            "id": "1AD588B5-3A94-493F-872B-F8B661A57CA0",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": null,
            "no": 214,
            "name": "C相电压15次谐波",
            "groupId": "9b1f5445f7f54702899327d31b3ca00d",
            "id": "134203DB-9E65-45CD-871D-171DC7D3AFE6",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": null,
            "no": 215,
            "name": "C相电压16次谐波",
            "groupId": "43dda3a9f9e34bc0a45b434263862565",
            "id": "672897AF-6C67-4B98-A349-F6E8BF9E93D2",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": null,
            "no": 216,
            "name": "C相电压17次谐波",
            "groupId": "9b1f5445f7f54702899327d31b3ca00d",
            "id": "7FC1F5D5-08DD-4A4C-992A-1207982E97A2",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": null,
            "no": 217,
            "name": "C相电压18次谐波",
            "groupId": "43dda3a9f9e34bc0a45b434263862565",
            "id": "C32771DC-6782-4DC3-A3A1-EC53CD82AEB5",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": null,
            "no": 218,
            "name": "C相电压19次谐波",
            "groupId": "9b1f5445f7f54702899327d31b3ca00d",
            "id": "A7F6E81E-24D4-44AC-889A-9BA963B25C2C",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": null,
            "no": 219,
            "name": "C相电压20次谐波",
            "groupId": "43dda3a9f9e34bc0a45b434263862565",
            "id": "C6D1DCFC-4D5D-48D6-843A-DF71640790DA",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": null,
            "no": 220,
            "name": "C相电压21次谐波",
            "groupId": "9b1f5445f7f54702899327d31b3ca00d",
            "id": "817DE272-E885-4109-A961-8037537B73C7",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": null,
            "no": 221,
            "name": "C相电压22次谐波",
            "groupId": "43dda3a9f9e34bc0a45b434263862565",
            "id": "2D786796-1B12-436D-9B31-99A6400B3337",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": null,
            "no": 222,
            "name": "C相电压23次谐波",
            "groupId": "9b1f5445f7f54702899327d31b3ca00d",
            "id": "28A5030F-BE0B-4586-B60F-80E3099C48EE",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": null,
            "no": 223,
            "name": "C相电压24次谐波",
            "groupId": "43dda3a9f9e34bc0a45b434263862565",
            "id": "B20031FC-3765-430F-A480-43A8D92D062F",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": null,
            "no": 224,
            "name": "C相电压25次谐波",
            "groupId": "9b1f5445f7f54702899327d31b3ca00d",
            "id": "F5510591-E29D-42A2-8CFD-88889FF1156D",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": null,
            "no": 225,
            "name": "C相电压26次谐波",
            "groupId": "43dda3a9f9e34bc0a45b434263862565",
            "id": "0E79AD82-D9D5-465A-9863-6D8EF05A02D4",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": null,
            "no": 226,
            "name": "C相电压27次谐波",
            "groupId": "9b1f5445f7f54702899327d31b3ca00d",
            "id": "A526D749-AAE5-4FB4-A1CE-7EC10FBFB01E",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": null,
            "no": 227,
            "name": "C相电压28次谐波",
            "groupId": "43dda3a9f9e34bc0a45b434263862565",
            "id": "C12A5791-1B40-42D7-A9AC-1073D66E2AF6",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": null,
            "no": 228,
            "name": "C相电压29次谐波",
            "groupId": "9b1f5445f7f54702899327d31b3ca00d",
            "id": "CE714C69-47CF-48E2-9F80-619A2C5A597E",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": null,
            "no": 229,
            "name": "C相电压30次谐波",
            "groupId": "43dda3a9f9e34bc0a45b434263862565",
            "id": "1DFE7BCE-F660-41BB-9150-C8ECB5B54412",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": null,
            "no": 230,
            "name": "C相电压31次谐波",
            "groupId": "9b1f5445f7f54702899327d31b3ca00d",
            "id": "AF55E85C-0B32-43C7-896D-7516CEC14B7C",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": null,
            "no": 231,
            "name": "C相电压波形畸变率",
            "groupId": "4f1506f4-3aba-4bdd-a631-8cd194bc5773",
            "id": "3B606D0B-1792-4478-8DB0-6B88AACC6F71",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": null,
            "no": 232,
            "name": "开关量",
            "groupId": "a08fdbfa38ef4126a8471f0934bc2fe9",
            "id": "718D2EA8-FBF8-480F-A73D-6A19DA713184",
            "energyType": 0,
            "useDifference": 0,
            "enable": 0,
            "entityName": "AppType"
          },
          {
            "createTime": null,
            "no": 233,
            "name": "时间",
            "groupId": "a731f816411e4125a76c49c6ac16951d",
            "id": "0EEBBC77-AB06-4340-989A-E914826565B8",
            "energyType": 0,
            "useDifference": 1,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": null,
            "no": 234,
            "name": "温度",
            "groupId": "e2c6256b-ab82-4690-b8cb-a4a33b1ad8c4",
            "id": "DC566651-8993-4996-9CE8-1055B4A0348C",
            "energyType": null,
            "useDifference": null,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": null,
            "no": 235,
            "name": "湿度",
            "groupId": "dcaef86b54924477894b573d935ee6e9",
            "id": "3D1CB4C5-088C-4079-BC3F-DD714B194501",
            "energyType": null,
            "useDifference": null,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": null,
            "no": 236,
            "name": "压力",
            "groupId": "b31af6844f9243098793ca779f139fe9",
            "id": "33343CF9-0920-4252-A78B-19E2E2989ADA",
            "energyType": null,
            "useDifference": null,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": null,
            "no": 237,
            "name": "累计流量",
            "groupId": "2666a9ca4520424a9e4c521bd0f35b48",
            "id": "5A42F166-4145-45A0-96AD-2D3C875E7341",
            "energyType": 0,
            "useDifference": 0,
            "enable": 0,
            "entityName": "AppType"
          },
          {
            "createTime": null,
            "no": 238,
            "name": "相角",
            "groupId": "931b9e3cc6b54b328a8111f82cc613a4",
            "id": "52C634AE-7854-45F8-ADEE-BFF8BDC8CE90",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": null,
            "no": 239,
            "name": "K因数",
            "groupId": "2be1be84e97c4ccfa913ae3dcaf259cd",
            "id": "C84528FD-BADD-4275-82CE-45D676A1047D",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": null,
            "no": 240,
            "name": "频率偏差",
            "groupId": "2127db0372654a6e803645a7daeb48fd",
            "id": "2c7a1259-d851-4a6e-b3de-629df400aba6",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": null,
            "no": 241,
            "name": "三相电压不平衡度",
            "groupId": "6ba41729fae7410983f25aff22cc8cbb",
            "id": "04e0bb4a-d338-4c0a-a98f-300e106c6fa1",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": null,
            "no": 242,
            "name": "三相电流不平衡度",
            "groupId": "61e72559e3c641bb8a3bdbb852a0997b",
            "id": "7c038b8d-0011-493c-a215-54a83cad702f",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": null,
            "no": 243,
            "name": "A相电压偏差",
            "groupId": "7b093983e8d84d768de4fdf4bf0766af",
            "id": "fc427c70-21f8-45c8-aec5-e403ab484045",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": null,
            "no": 244,
            "name": "B相电压偏差",
            "groupId": "7b093983e8d84d768de4fdf4bf0766af",
            "id": "f92264ad-9b57-4588-84fe-03f4de521cc7",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": null,
            "no": 245,
            "name": "C相电压偏差",
            "groupId": "7b093983e8d84d768de4fdf4bf0766af",
            "id": "e0eeb22e-62af-4649-b7ce-b0b6fcf6a6d7",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": null,
            "no": 246,
            "name": "瞬时流量",
            "groupId": "2812a71f43cd4fd1ac5404b4d42f9385",
            "id": "50a5bf13-da12-4c4a-9669-2f8c20e2a364",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": null,
            "no": 247,
            "name": "亮度",
            "groupId": "f28f41719a104a8a8d0e0aadfb516363",
            "id": "9d2068c3-2506-4328-ad19-4241c53f0b8e",
            "energyType": null,
            "useDifference": null,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": null,
            "no": 248,
            "name": "调光度",
            "groupId": "12472bd435744ed8b8ffb302c2b9e235",
            "id": "78d489d4-ae83-4400-9729-2da204dea02d",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": null,
            "no": 249,
            "name": "A相电流总偶次畸变率",
            "groupId": "5f0330d6ea404867b1277b701c103aa3",
            "id": "0C0D80D9-87BA-4E2B-9DB3-FCF9643372E1",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": null,
            "no": 250,
            "name": "A相电流总奇次畸变率",
            "groupId": "5f0330d6ea404867b1277b701c103aa3",
            "id": "02BE024D-4870-40C3-BA15-94849978B117",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": null,
            "no": 251,
            "name": "B相电流总偶次畸变率",
            "groupId": "5f0330d6ea404867b1277b701c103aa3",
            "id": "833C323F-076F-4050-801C-F75ACF304536",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": null,
            "no": 252,
            "name": "B相电流总奇次畸变率",
            "groupId": "5f0330d6ea404867b1277b701c103aa3",
            "id": "46DD2A96-C6F6-4588-8C00-9E4B09C068EB",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": null,
            "no": 253,
            "name": "C相电流总偶次畸变率",
            "groupId": "5f0330d6ea404867b1277b701c103aa3",
            "id": "99F837D3-8797-41A6-967A-20EE93640DF7",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": null,
            "no": 254,
            "name": "C相电流总奇次畸变率",
            "groupId": "5f0330d6ea404867b1277b701c103aa3",
            "id": "6E0C642E-4F2E-483D-BEA2-9FC64F22EF06",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": null,
            "no": 255,
            "name": "A相电压总偶次畸变率",
            "groupId": "4f1506f4-3aba-4bdd-a631-8cd194bc5773",
            "id": "E5ED1DC8-4297-45BF-8ADC-2A6C1F3E703E",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": null,
            "no": 256,
            "name": "A相电压总奇次畸变率",
            "groupId": "4f1506f4-3aba-4bdd-a631-8cd194bc5773",
            "id": "251D4FA5-B10E-43B2-AEF4-027C3CB55CE5",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": null,
            "no": 257,
            "name": "B相电压总偶次畸变率",
            "groupId": "4f1506f4-3aba-4bdd-a631-8cd194bc5773",
            "id": "5C449868-A79C-4905-9379-1F3638365EDA",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": null,
            "no": 258,
            "name": "B相电压总奇次畸变率",
            "groupId": "4f1506f4-3aba-4bdd-a631-8cd194bc5773",
            "id": "3B0009CF-35E0-4C3A-9D67-E289C0FE935E",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": null,
            "no": 259,
            "name": "C相电压总偶次畸变率",
            "groupId": "4f1506f4-3aba-4bdd-a631-8cd194bc5773",
            "id": "41433D24-E64A-46CA-92E3-5E489EF05450",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": null,
            "no": 260,
            "name": "C相电压总奇次畸变率",
            "groupId": "4f1506f4-3aba-4bdd-a631-8cd194bc5773",
            "id": "C0A84EF1-9EB8-49E7-8D0D-6FEB0330F646",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": null,
            "no": 261,
            "name": "状态量",
            "groupId": "a08fdbfa38ef4126a8471f0934bc2fe9",
            "id": "0753ED56-522E-46CA-8CF9-EA72840892F4",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": null,
            "no": 262,
            "name": "西门子充电桩合开关",
            "groupId": "ce01ac4c1fc74753b18591f038d765ce",
            "id": "ce01ac4c1fc74753b18591f038d765ce",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": null,
            "no": 263,
            "name": "西门子充电桩分开关",
            "groupId": "ce01ac4c1fc74753b18591f038d765ce",
            "id": "321ac4c1fc74753b18591f038d765ce",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": null,
            "no": 264,
            "name": "有功功率需量",
            "groupId": "4c20865ac7ec49208fdcf004abee9a8b",
            "id": "afedea87daaa4257924cbec8e47f8800",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": null,
            "no": 265,
            "name": "无功功率需量",
            "groupId": "4e57970f96f74245b09464962f09e2a0",
            "id": "4c11b611f5fb40dbbcfff5c01ed2f004",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": null,
            "no": 266,
            "name": "视在功率需量",
            "groupId": "4330cc707b3d4dce9ac07a5fbc2cde80",
            "id": "d3b5156faab84a4e9e267400407901df",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": null,
            "no": 267,
            "name": "A相电流需量",
            "groupId": "700b5db9564c42bd97a1d2d16f725d73",
            "id": "fa0e3d074ba74f429a8784affadc64ca",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": null,
            "no": 268,
            "name": "B相电流需量",
            "groupId": "700b5db9564c42bd97a1d2d16f725d73",
            "id": "1ff1c480862944fc9ff5cdf345bfab1f",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": null,
            "no": 269,
            "name": "C相电流需量",
            "groupId": "700b5db9564c42bd97a1d2d16f725d73",
            "id": "0d2ff4ed92224c7e8a20f6ad98b57fe4",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": null,
            "no": 270,
            "name": "当前有功功率最大需量",
            "groupId": "4c20865ac7ec49208fdcf004abee9a8b",
            "id": "87f682f92ffb426ab7eaf7d528645046",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": null,
            "no": 271,
            "name": "当前无功功率最大需量",
            "groupId": "4e57970f96f74245b09464962f09e2a0",
            "id": "1e557ffded99432e9f3f48cad9de3219",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": null,
            "no": 272,
            "name": "当前视在功率最大需量",
            "groupId": "4330cc707b3d4dce9ac07a5fbc2cde80",
            "id": "6793891a0a6541e7b3e56d0df20b8e98",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": null,
            "no": 273,
            "name": "上次有功功率最大需量",
            "groupId": "4c20865ac7ec49208fdcf004abee9a8b",
            "id": "6d0428a82137454ea9b7b25511bb5045",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": null,
            "no": 274,
            "name": "上次无功功率最大需量",
            "groupId": "4e57970f96f74245b09464962f09e2a0",
            "id": "42fa65b3af42492c981d6f771fed05f3",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": null,
            "no": 275,
            "name": "上次视在功率最大需量",
            "groupId": "4330cc707b3d4dce9ac07a5fbc2cde80",
            "id": "54e84424eaab438c98fdd8d451083917",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": null,
            "no": 280,
            "name": "空调设定温度",
            "groupId": "a42b3ea9dfd24bb6ab7f548a8a78db7a",
            "id": "b8d396e8e2c9493582ce9d5fc5fcc1c4",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": null,
            "no": 281,
            "name": "空调运行模式",
            "groupId": "1831f085abfa435ea5f51b9a01839b6f",
            "id": "64b9e65722a24c63a80fdbe596d3c794",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": null,
            "no": 282,
            "name": "空调风速",
            "groupId": "1831f085abfa435ea5f51b9a01839b6f",
            "id": "f31108af36bd46b7931d8700cc7d0a17",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": null,
            "no": 283,
            "name": "空调垂直风摆",
            "groupId": "1831f085abfa435ea5f51b9a01839b6f",
            "id": "4714dc08c2bb4982851590da5a7155ef",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": null,
            "no": 284,
            "name": "空调水平风摆",
            "groupId": "1831f085abfa435ea5f51b9a01839b6f",
            "id": "6b8a6188fecf4c798c820dd65c231c44",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": null,
            "no": 285,
            "name": "最高温度权限",
            "groupId": "ee7926d51c734f9f8de891b1a87b4863",
            "id": "35cdc55a179b44998ae1fd4cca80f25e",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": null,
            "no": 286,
            "name": "最低温度权限",
            "groupId": "ee7926d51c734f9f8de891b1a87b4863",
            "id": "5411ed9ed8e54afea855232093e59e88",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": null,
            "no": 287,
            "name": "运行模式权限",
            "groupId": "ee7926d51c734f9f8de891b1a87b4863",
            "id": "872af7141adf499992a96442c312e63e",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": null,
            "no": 288,
            "name": "风速权限",
            "groupId": "ee7926d51c734f9f8de891b1a87b4863",
            "id": "db970274f3a94b279109aa52db313fdd",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": null,
            "no": 289,
            "name": "垂直风摆权限",
            "groupId": "ee7926d51c734f9f8de891b1a87b4863",
            "id": "3f83438b8ec64890bfa232d611b2305a",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": null,
            "no": 290,
            "name": "水平风摆权限",
            "groupId": "ee7926d51c734f9f8de891b1a87b4863",
            "id": "01d5e9e7c729434aaeb3e4bbf28244dd",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": null,
            "no": 291,
            "name": "人体红外状态",
            "groupId": "345a9d750d2a4009adf0d2f9f909b98c",
            "id": "71fdfb2d253d434ca5013850d3eeb5fa",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": null,
            "no": 292,
            "name": "电量百分比",
            "groupId": "345a9d750d2a4009adf0d2f9f909b98c",
            "id": "118912013e93473e85c4c7cb071ed05e",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": null,
            "no": 293,
            "name": "电池电压",
            "groupId": "345a9d750d2a4009adf0d2f9f909b98c",
            "id": "baef7e55415f49d3b9081653fb210252",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": null,
            "no": 295,
            "name": "信号强度",
            "groupId": "294c9e9706c84897bac436dc20274307",
            "id": "ef1ca6471b07400a9c97edfa29a87a44",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": null,
            "no": 296,
            "name": "联网状态",
            "groupId": "da2c71d085704b7eb61c5a891fd574ba",
            "id": "9968612e326e417f90a54fc178f4f97d",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": null,
            "no": 297,
            "name": "漏电流",
            "groupId": "aec119cd-245d-4432-b97d-1a11646377c0",
            "id": "0aa82b5e4420480aadce8a3012c58617",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": null,
            "no": 298,
            "name": "短路报警",
            "groupId": "da2c71d085704b7eb61c5a891fd574ba",
            "id": "354eaa47ed434edf9446341954dd3976",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": null,
            "no": 299,
            "name": "浪涌报警",
            "groupId": "da2c71d085704b7eb61c5a891fd574ba",
            "id": "c0b2f683018d4d599c0b6d1754f10d6c",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": null,
            "no": 300,
            "name": "过载报警",
            "groupId": "da2c71d085704b7eb61c5a891fd574ba",
            "id": "35663908558a443791a250780165b231",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": null,
            "no": 301,
            "name": "温度报警",
            "groupId": "da2c71d085704b7eb61c5a891fd574ba",
            "id": "8dffa1dc5a37422c8c776bcf0f7b126f",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": null,
            "no": 302,
            "name": "漏电报警",
            "groupId": "da2c71d085704b7eb61c5a891fd574ba",
            "id": "00c452629a474ccdbbfaa2562e48f99c",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": null,
            "no": 303,
            "name": "过流报警",
            "groupId": "da2c71d085704b7eb61c5a891fd574ba",
            "id": "134243995c6d4cafa715aa999c41861d",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": null,
            "no": 304,
            "name": "过压报警",
            "groupId": "da2c71d085704b7eb61c5a891fd574ba",
            "id": "74d274e2d3f4499cb7c8062a5deb6980",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": null,
            "no": 305,
            "name": "漏电保护功能正常",
            "groupId": "da2c71d085704b7eb61c5a891fd574ba",
            "id": "836da95a41964605a6f95a7424a247c5",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": null,
            "no": 306,
            "name": "漏电保护自检未完成",
            "groupId": "da2c71d085704b7eb61c5a891fd574ba",
            "id": "0c4dc1da46344995b7c43b979de7eb9a",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": null,
            "no": 307,
            "name": "输入缺相(380)",
            "groupId": "da2c71d085704b7eb61c5a891fd574ba",
            "id": "63d64b95921448fd82b8a1907baf9940",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": null,
            "no": 308,
            "name": "打火报警",
            "groupId": "da2c71d085704b7eb61c5a891fd574ba",
            "id": "9bd2e5ca502d426faab30d865e2667a2",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": null,
            "no": 309,
            "name": "欠压报警",
            "groupId": "da2c71d085704b7eb61c5a891fd574ba",
            "id": "fe7701d639234e5ea7ac622dfd99557b",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": null,
            "no": 310,
            "name": "过压预警",
            "groupId": "da2c71d085704b7eb61c5a891fd574ba",
            "id": "7ba3221ed7694c7eb9be6f1e5ef79073",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": null,
            "no": 311,
            "name": "欠压预警",
            "groupId": "da2c71d085704b7eb61c5a891fd574ba",
            "id": "57fd6230e1b04a5c96662d875048fb4f",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": null,
            "no": 312,
            "name": "漏电预警",
            "groupId": "da2c71d085704b7eb61c5a891fd574ba",
            "id": "e9dcc4043e7649c4904f58cd38f2dab0",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": null,
            "no": 313,
            "name": "电流预警",
            "groupId": "da2c71d085704b7eb61c5a891fd574ba",
            "id": "d28bad5050f348e489183ab8d56ac134",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": null,
            "no": 314,
            "name": "远程合闸禁止",
            "groupId": "da2c71d085704b7eb61c5a891fd574ba",
            "id": "4f8dd91276b94996a0f3486442eda06c",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": null,
            "no": 315,
            "name": "禁止缺相保护",
            "groupId": "da2c71d085704b7eb61c5a891fd574ba",
            "id": "5abdd3f415bb4a5eb3c32a796d1b1936",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": null,
            "no": 316,
            "name": "禁止不平衡保护",
            "groupId": "da2c71d085704b7eb61c5a891fd574ba",
            "id": "cef6b10602b64db8968c9645eebc2300",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": null,
            "no": 317,
            "name": "禁止相序保护",
            "groupId": "da2c71d085704b7eb61c5a891fd574ba",
            "id": "883775a0ee6e4395ba8a345fbdff248e",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": null,
            "no": 318,
            "name": "不平衡报警",
            "groupId": "da2c71d085704b7eb61c5a891fd574ba",
            "id": "3efaecd2d6af43f5bd9be8d7beaf7cff",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": null,
            "no": 319,
            "name": "相序ACB",
            "groupId": "da2c71d085704b7eb61c5a891fd574ba",
            "id": "8220fda2968a42d8870416ca348b60f2",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": null,
            "no": 320,
            "name": "开关开合状态",
            "groupId": "da2c71d085704b7eb61c5a891fd574ba",
            "id": "336074114dbe4af7b740a42525351aa7",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": null,
            "no": 321,
            "name": "开关在线状态",
            "groupId": "da2c71d085704b7eb61c5a891fd574ba",
            "id": "30c01d7ac0db4c82983dda1e0b8bec3a",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": null,
            "no": 322,
            "name": "N相电流值",
            "groupId": "aec119cd-245d-4432-b97d-1a11646377c0",
            "id": "125d562dc33f4a16a287fd112e29bae3",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": null,
            "no": 330,
            "name": "照明开关操作",
            "groupId": "26ed8f078fa9404bbbe4165106b22820",
            "id": "73d22d620f52410b9d3963ad5b669d42",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": null,
            "no": 331,
            "name": "照明调光设置",
            "groupId": "26ed8f078fa9404bbbe4165106b22820",
            "id": "35be2fe7117543a2a4744eb3cdc0e301",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": null,
            "no": 332,
            "name": "照明空调开关",
            "groupId": "26ed8f078fa9404bbbe4165106b22820",
            "id": "114297d876484797b5d7ad8c2b8e1e0e",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": null,
            "no": 333,
            "name": "照明空调风速",
            "groupId": "26ed8f078fa9404bbbe4165106b22820",
            "id": "e8485ee9eced43f78adf3358add235c6",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": null,
            "no": 334,
            "name": "照明空调模式",
            "groupId": "26ed8f078fa9404bbbe4165106b22820",
            "id": "a7589794c3144ec0bd6360bdb43a1eee",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": null,
            "no": 335,
            "name": "照明空调温度",
            "groupId": "26ed8f078fa9404bbbe4165106b22820",
            "id": "6621fe8e49de4a1bb60f0c061295d786",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": null,
            "no": 336,
            "name": "照明窗帘开关",
            "groupId": "26ed8f078fa9404bbbe4165106b22820",
            "id": "ed5ab44fc97a4dfb90a9951a5d6bce90",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": null,
            "no": 337,
            "name": "照明窗帘高度",
            "groupId": "26ed8f078fa9404bbbe4165106b22820",
            "id": "9de03923a2924bdeb53c06d407257e65",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": null,
            "no": 338,
            "name": "照明新风开关",
            "groupId": "26ed8f078fa9404bbbe4165106b22820",
            "id": "3b79675cfcae46ea950034701c20c992",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": null,
            "no": 339,
            "name": "照明新风档位",
            "groupId": "26ed8f078fa9404bbbe4165106b22820",
            "id": "16018490b4f94f4a969ac8e336e7307b",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": null,
            "no": 340,
            "name": "照明地暖开关",
            "groupId": "26ed8f078fa9404bbbe4165106b22820",
            "id": "02ac3029a59d42d087a8741ec77144fa",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": null,
            "no": 341,
            "name": "照明地暖温度",
            "groupId": "26ed8f078fa9404bbbe4165106b22820",
            "id": "396967680c844eb4b05f7997a1ae426f",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": null,
            "no": 342,
            "name": "照明地暖风速",
            "groupId": "26ed8f078fa9404bbbe4165106b22820",
            "id": "34f12772567448c0addc3422a1adb14c",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": null,
            "no": 343,
            "name": "照明相对调光",
            "groupId": "26ed8f078fa9404bbbe4165106b22820",
            "id": "63c0c35858e043beb987e5c859ced047",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": null,
            "no": 344,
            "name": "照明绝对调光",
            "groupId": "26ed8f078fa9404bbbe4165106b22820",
            "id": "f090679424e8484e80538cb025b47806",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": null,
            "no": 350,
            "name": "总",
            "groupId": "fb851bbfd23b44cea50ac7cbb62ddd5d",
            "id": "33e5be1d4e2b4e399f2fbf8916e40ba0",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": null,
            "no": 351,
            "name": "尖",
            "groupId": "fb851bbfd23b44cea50ac7cbb62ddd5d",
            "id": "2b742f3b2538482c95588855cd754d7b",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": null,
            "no": 352,
            "name": "峰",
            "groupId": "fb851bbfd23b44cea50ac7cbb62ddd5d",
            "id": "60f48d960ee1483286bf7949b67f1e2f",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": null,
            "no": 353,
            "name": "平",
            "groupId": "fb851bbfd23b44cea50ac7cbb62ddd5d",
            "id": "2f217207991d4cf4bdbfd9089c80f4f2",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": null,
            "no": 354,
            "name": "谷",
            "groupId": "fb851bbfd23b44cea50ac7cbb62ddd5d",
            "id": "3c7fd03f0a2941fd8c8c36424e8963c2",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": null,
            "no": 361,
            "name": "天然气累计流量",
            "groupId": "2666a9ca4520424a9e4c521bd0f35b48",
            "id": "87f358d1d2994a79bae40ee8374bdbc2",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": null,
            "no": 362,
            "name": "蒸汽累计流量",
            "groupId": "2666a9ca4520424a9e4c521bd0f35b48",
            "id": "4cbafc45d7bd4cb7bd23963127ab548b",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": null,
            "no": 370,
            "name": "当日尖",
            "groupId": "fb851bbfd23b44cea50ac7cbb62ddd5d",
            "id": "f65496629cb6469aa62cdfabba696d05",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": null,
            "no": 371,
            "name": "当日峰",
            "groupId": "fb851bbfd23b44cea50ac7cbb62ddd5d",
            "id": "bed394f10eb4432fad63caf98549ca51",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": null,
            "no": 372,
            "name": "当日平",
            "groupId": "fb851bbfd23b44cea50ac7cbb62ddd5d",
            "id": "d65590b375fb4a67b4aaf63d2a35a28b",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": null,
            "no": 373,
            "name": "当日谷",
            "groupId": "fb851bbfd23b44cea50ac7cbb62ddd5d",
            "id": "297c51509ca74ed99414916b36801268",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": null,
            "no": 374,
            "name": "昨日尖",
            "groupId": "fb851bbfd23b44cea50ac7cbb62ddd5d",
            "id": "e64c4a8a79e04483977f70e483830eb2",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": null,
            "no": 375,
            "name": "昨日峰",
            "groupId": "fb851bbfd23b44cea50ac7cbb62ddd5d",
            "id": "8dea1fa7be1c421cae25d24637cc5262",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": null,
            "no": 376,
            "name": "昨日平",
            "groupId": "fb851bbfd23b44cea50ac7cbb62ddd5d",
            "id": "2012204307d04f669d15bad30bf96b06",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": null,
            "no": 377,
            "name": "昨日谷",
            "groupId": "fb851bbfd23b44cea50ac7cbb62ddd5d",
            "id": "3bb8491df0214898a1dada63a94e5fd2",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": null,
            "no": 378,
            "name": "前日尖",
            "groupId": "fb851bbfd23b44cea50ac7cbb62ddd5d",
            "id": "67017e7cd3f84c7699c5327e36356716",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": null,
            "no": 379,
            "name": "前日峰",
            "groupId": "fb851bbfd23b44cea50ac7cbb62ddd5d",
            "id": "06ef047f8ad54ab99a8e9295fb7e6122",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": null,
            "no": 380,
            "name": "前日平",
            "groupId": "fb851bbfd23b44cea50ac7cbb62ddd5d",
            "id": "c5cd9041ee4945238b43903d774d641e",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": null,
            "no": 381,
            "name": "前日谷",
            "groupId": "fb851bbfd23b44cea50ac7cbb62ddd5d",
            "id": "82a90fac364c403a9867dec9bf70cd96",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": null,
            "no": 382,
            "name": "当月尖",
            "groupId": "fb851bbfd23b44cea50ac7cbb62ddd5d",
            "id": "324a14bf73524daba78bd09d0d3dbd9d",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": null,
            "no": 383,
            "name": "当月峰",
            "groupId": "fb851bbfd23b44cea50ac7cbb62ddd5d",
            "id": "c2b7cb388216459c90dfeef6127d62b9",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": null,
            "no": 384,
            "name": "当月平",
            "groupId": "fb851bbfd23b44cea50ac7cbb62ddd5d",
            "id": "80bf51e186104a64ac217847637482fb",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": null,
            "no": 385,
            "name": "当月谷",
            "groupId": "fb851bbfd23b44cea50ac7cbb62ddd5d",
            "id": "378494de6f744820be415a1b35f6adeb",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": null,
            "no": 386,
            "name": "上月尖",
            "groupId": "fb851bbfd23b44cea50ac7cbb62ddd5d",
            "id": "904dd70e8a974c1dade1ca8cc572519e",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": null,
            "no": 387,
            "name": "上月峰",
            "groupId": "fb851bbfd23b44cea50ac7cbb62ddd5d",
            "id": "143f829a8f71483f991d58fecf11cc5d",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": null,
            "no": 388,
            "name": "上月平",
            "groupId": "fb851bbfd23b44cea50ac7cbb62ddd5d",
            "id": "af8abc31fdb94b3bb3915a6d68b5777a",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": null,
            "no": 389,
            "name": "上月谷",
            "groupId": "fb851bbfd23b44cea50ac7cbb62ddd5d",
            "id": "aef29dd32ca3476babbb9d3f2b378aec",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": null,
            "no": 390,
            "name": "前月尖",
            "groupId": "fb851bbfd23b44cea50ac7cbb62ddd5d",
            "id": "bf7bc2427c0c4953ba2e051815149844",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": null,
            "no": 391,
            "name": "前月峰",
            "groupId": "fb851bbfd23b44cea50ac7cbb62ddd5d",
            "id": "619bd97f47314b8aa065cc9db72450bd",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": null,
            "no": 392,
            "name": "前月平",
            "groupId": "fb851bbfd23b44cea50ac7cbb62ddd5d",
            "id": "7c214b55621c409d8dad8db939e84415",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": null,
            "no": 393,
            "name": "前月谷",
            "groupId": "fb851bbfd23b44cea50ac7cbb62ddd5d",
            "id": "d2c2ab4e6bef4f0b98e79801d9c1454c",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": null,
            "no": 394,
            "name": "当年尖",
            "groupId": "fb851bbfd23b44cea50ac7cbb62ddd5d",
            "id": "62ef1385a1c145739d0d205ffe27d0dd",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": null,
            "no": 395,
            "name": "当年峰",
            "groupId": "fb851bbfd23b44cea50ac7cbb62ddd5d",
            "id": "ec45b6864d8640fda1f10bf8c3995939",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": null,
            "no": 396,
            "name": "当年平",
            "groupId": "fb851bbfd23b44cea50ac7cbb62ddd5d",
            "id": "d0d85160ac3e47f2808c3fa78e292755",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": null,
            "no": 397,
            "name": "当年谷",
            "groupId": "fb851bbfd23b44cea50ac7cbb62ddd5d",
            "id": "cb3a8196f3f74939a2060bcdd88a0e18",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": null,
            "no": 398,
            "name": "上年尖",
            "groupId": "fb851bbfd23b44cea50ac7cbb62ddd5d",
            "id": "3f19202e0ecb4ae4b1b3931a2b397487",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": null,
            "no": 399,
            "name": "上年峰",
            "groupId": "fb851bbfd23b44cea50ac7cbb62ddd5d",
            "id": "5e41a3f822e6467d8fc04e6e1a3099ec",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": null,
            "no": 400,
            "name": "上年平",
            "groupId": "fb851bbfd23b44cea50ac7cbb62ddd5d",
            "id": "e2eec61e129b48f28b667d711d368a7f",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": null,
            "no": 401,
            "name": "上年谷",
            "groupId": "fb851bbfd23b44cea50ac7cbb62ddd5d",
            "id": "7b4953aef77a4b9b9cea4d7208e742e3",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": null,
            "no": 402,
            "name": "前年尖",
            "groupId": "fb851bbfd23b44cea50ac7cbb62ddd5d",
            "id": "bccd385589dc425580907d97cd811761",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": null,
            "no": 403,
            "name": "前年峰",
            "groupId": "fb851bbfd23b44cea50ac7cbb62ddd5d",
            "id": "bbb361826287475fa1c97367d3ca6ebe",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": null,
            "no": 404,
            "name": "前年平",
            "groupId": "fb851bbfd23b44cea50ac7cbb62ddd5d",
            "id": "3e801e974c25419b836f445737bcc573",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": null,
            "no": 405,
            "name": "前年谷",
            "groupId": "fb851bbfd23b44cea50ac7cbb62ddd5d",
            "id": "08b8a4f0f33049f7a44e9cf93c32b745",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": null,
            "no": 410,
            "name": "剩余电量",
            "groupId": "cec535339e794783b932f764d9ee12a9",
            "id": "297fd9a720224b9a98c3a8acca8577de",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": null,
            "no": 411,
            "name": "过零电量",
            "groupId": "cec535339e794783b932f764d9ee12a9",
            "id": "5885681bc2884d41af1279a627abf746",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": null,
            "no": 412,
            "name": "透支电量",
            "groupId": "cec535339e794783b932f764d9ee12a9",
            "id": "74da93c7f52d4ca78a2bde3bcb28fd9b",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": null,
            "no": 413,
            "name": "接触磨损",
            "groupId": "5fcd7ac541a24967af64539b40ce1648",
            "id": "48720fec8d68449988d5dcef40c579f8",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": null,
            "no": 414,
            "name": "跳匝次数",
            "groupId": "5fcd7ac541a24967af64539b40ce1648",
            "id": "2637e3ca9d17410c94343c2bcedb7f9a",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": null,
            "no": 415,
            "name": "健康指数",
            "groupId": "5738a003d7ce49dfb0873cc22f162642",
            "id": "f5b4a6ca46024d5cb2381d5dfd44bc62",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": null,
            "no": 416,
            "name": "剩余寿命",
            "groupId": "5738a003d7ce49dfb0873cc22f162642",
            "id": "2de4a8de86fa47a19fb2ad181f152ca3",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": null,
            "no": 417,
            "name": "剩余保养天数",
            "groupId": "5738a003d7ce49dfb0873cc22f162642",
            "id": "d76f0aa23d464d5ca6059b7a56b0d8dc",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": null,
            "no": 1001,
            "name": "上月需量",
            "groupId": "c70627186f0b40bcb54e409687f60b5d",
            "id": "542bfa88df184adcb66d5a48cfdb12aa",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": null,
            "no": 1002,
            "name": "本月需量",
            "groupId": "c70627186f0b40bcb54e409687f60b5d",
            "id": "80676065d14d4fa7a01f497c1a1b2a8d",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": 1689729289000,
            "no": 1003,
            "name": "煤炭",
            "groupId": "0125e86ea9734aca8ad0980fa057d702",
            "id": "fa84a27eccd948dd8be4859ac6eb3e0e",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": 1689729297000,
            "no": 1004,
            "name": "汽油",
            "groupId": "0125e86ea9734aca8ad0980fa057d702",
            "id": "d0aa47e143c441669f0b703808cff28d",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": 1689729320000,
            "no": 1005,
            "name": "液化石油气",
            "groupId": "0125e86ea9734aca8ad0980fa057d702",
            "id": "8041e98b68a545f2bd2549e2b361ba60",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": 1689729358000,
            "no": 1006,
            "name": "热力",
            "groupId": "0125e86ea9734aca8ad0980fa057d702",
            "id": "2b7a4ee5d96646a1bf9e7c80239d44a5",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": 1689729367000,
            "no": 1007,
            "name": "其他能源",
            "groupId": "0125e86ea9734aca8ad0980fa057d702",
            "id": "98df0e39c7e24e9ea55af6f498746642",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": 1689729596000,
            "no": 1008,
            "name": "柴油",
            "groupId": "0125e86ea9734aca8ad0980fa057d702",
            "id": "b6d99266f51b451584df106bcc38710d",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": 1696669138000,
            "no": 1009,
            "name": "A相电压谐波含有率",
            "groupId": "8fd4a17e00cb4d69ab590270ed64774a",
            "id": "fabbf58974a34770aee3ffae1342dd31",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": 1696669164000,
            "no": 1010,
            "name": "B相电压谐波含有率",
            "groupId": "8fd4a17e00cb4d69ab590270ed64774a",
            "id": "feae7b209603457bba555161e4c473b7",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": 1696669173000,
            "no": 1011,
            "name": "C相电压谐波含有率",
            "groupId": "8fd4a17e00cb4d69ab590270ed64774a",
            "id": "c53b1a11d48d4936b54195b5cc31e4e3",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": 1696669230000,
            "no": 1012,
            "name": "A相电流谐波含有率",
            "groupId": "1d7b3624d9ed43968fafbb2f07a46ddd",
            "id": "7b6d1e034405495095da0053e09e80ba",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": 1696669238000,
            "no": 1013,
            "name": "B相电流谐波含有率",
            "groupId": "1d7b3624d9ed43968fafbb2f07a46ddd",
            "id": "578d5723412641eab3d7f5318ebff244",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": 1696669245000,
            "no": 1014,
            "name": "C相电流谐波含有率",
            "groupId": "1d7b3624d9ed43968fafbb2f07a46ddd",
            "id": "d8211d728f6e4f218890523b83aefb56",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": 1696671123000,
            "no": 1015,
            "name": "A相电压基波",
            "groupId": "c976398a97fc457bb7181f2af08f00e3",
            "id": "68603b86271441aeb58cb6437e18518d",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": 1696671132000,
            "no": 1016,
            "name": "B相电压基波",
            "groupId": "c976398a97fc457bb7181f2af08f00e3",
            "id": "387f3651a5b149df9537a2a798c178e6",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": 1696671139000,
            "no": 1017,
            "name": "C相电压基波",
            "groupId": "c976398a97fc457bb7181f2af08f00e3",
            "id": "3eb4d2b4c90345bb81dd0c5de964c873",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": 1696671149000,
            "no": 1018,
            "name": "A相电流基波",
            "groupId": "b6524d5e0424454dbc0f349eec5b0fd6",
            "id": "8c21613d92ad4b9c9c54674f3c88f4dd",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": 1696671156000,
            "no": 1019,
            "name": "B相电流基波",
            "groupId": "b6524d5e0424454dbc0f349eec5b0fd6",
            "id": "7ad4de36f3d340668fa5bd08d3b1f3cf",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": 1696671162000,
            "no": 1020,
            "name": "C相电流基波",
            "groupId": "b6524d5e0424454dbc0f349eec5b0fd6",
            "id": "38f67d681ea44d87af1d03758e2dbf92",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": 1696671921000,
            "no": 1021,
            "name": "电压A相2次谐波",
            "groupId": "1861b8d271314793a72be5252f386766",
            "id": "09c2b32a4e5f4bbfaa00aca2858299c9",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": 1696671928000,
            "no": 1022,
            "name": "电压A相3次谐波",
            "groupId": "1861b8d271314793a72be5252f386766",
            "id": "add660200d7245e0b4ec5ea719e58ccc",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": 1696671946000,
            "no": 1023,
            "name": "电压A相4次谐波",
            "groupId": "1861b8d271314793a72be5252f386766",
            "id": "c9a92e128469401e834174c64eef6448",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": 1696672017000,
            "no": 1024,
            "name": "电压A相5次谐波",
            "groupId": "1861b8d271314793a72be5252f386766",
            "id": "713a316232f543948f32e6011492e699",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": 1696673116000,
            "no": 1025,
            "name": "电压A相6次谐波",
            "groupId": "1861b8d271314793a72be5252f386766",
            "id": "1c833262747a4fe8be34c590e7761ac3",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": 1696673116000,
            "no": 1026,
            "name": "电压A相7次谐波",
            "groupId": "1861b8d271314793a72be5252f386766",
            "id": "5a131c5161cd42da82c5f81c7d5c4172",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": 1696673116000,
            "no": 1027,
            "name": "电压A相8次谐波",
            "groupId": "1861b8d271314793a72be5252f386766",
            "id": "28e7378e4d07416b935c7d0ebb1f7551",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": 1696673117000,
            "no": 1028,
            "name": "电压A相9次谐波",
            "groupId": "1861b8d271314793a72be5252f386766",
            "id": "f407add40fa342f880242df51b4d5691",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": 1696673117000,
            "no": 1029,
            "name": "电压A相10次谐波",
            "groupId": "1861b8d271314793a72be5252f386766",
            "id": "5d64bcb54efa471fb15656c8f0316a97",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": 1696673117000,
            "no": 1030,
            "name": "电压A相11次谐波",
            "groupId": "1861b8d271314793a72be5252f386766",
            "id": "3e9eb9eca59845e6972ef06bb3e03d76",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": 1696673117000,
            "no": 1031,
            "name": "电压A相12次谐波",
            "groupId": "1861b8d271314793a72be5252f386766",
            "id": "72d0ff7556b54a5c88a7eee6e9cf7665",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": 1696673117000,
            "no": 1032,
            "name": "电压A相13次谐波",
            "groupId": "1861b8d271314793a72be5252f386766",
            "id": "fc5771c81fdf46c988d89a5dea6f924f",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": 1696673117000,
            "no": 1033,
            "name": "电压A相14次谐波",
            "groupId": "1861b8d271314793a72be5252f386766",
            "id": "d9fe2e3f885e4406b75ef52a0094acd2",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": 1696673117000,
            "no": 1034,
            "name": "电压A相15次谐波",
            "groupId": "1861b8d271314793a72be5252f386766",
            "id": "6c786aed69e849baad305bf641e13b6b",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": 1696673117000,
            "no": 1035,
            "name": "电压A相16次谐波",
            "groupId": "1861b8d271314793a72be5252f386766",
            "id": "d22efa1e853b4e92ac0ae083b408a6db",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": 1696673117000,
            "no": 1036,
            "name": "电压A相17次谐波",
            "groupId": "1861b8d271314793a72be5252f386766",
            "id": "6a5f9a088cac416b8665a8ff2a24ef09",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": 1696673118000,
            "no": 1037,
            "name": "电压A相18次谐波",
            "groupId": "1861b8d271314793a72be5252f386766",
            "id": "178da1561b0d45549b4f77cdca708e30",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": 1696673118000,
            "no": 1038,
            "name": "电压A相19次谐波",
            "groupId": "1861b8d271314793a72be5252f386766",
            "id": "5fe8b42c624b4886a3491e954abd1ba1",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": 1696673118000,
            "no": 1039,
            "name": "电压A相20次谐波",
            "groupId": "1861b8d271314793a72be5252f386766",
            "id": "b7273f6ba22a4d7290e3ac0a76ef7659",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": 1696673118000,
            "no": 1040,
            "name": "电压A相21次谐波",
            "groupId": "1861b8d271314793a72be5252f386766",
            "id": "121746c3f3b04048a7dd2b57d6421a2c",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": 1696673118000,
            "no": 1041,
            "name": "电压A相22次谐波",
            "groupId": "1861b8d271314793a72be5252f386766",
            "id": "3e3acec5957044afadc55e74600ccf4d",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": 1696673118000,
            "no": 1042,
            "name": "电压A相23次谐波",
            "groupId": "1861b8d271314793a72be5252f386766",
            "id": "1801b404554d403aa8a35a588bce606f",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": 1696673118000,
            "no": 1043,
            "name": "电压A相24次谐波",
            "groupId": "1861b8d271314793a72be5252f386766",
            "id": "b159162fb64f42d1bb6a95f9154d8d4d",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": 1696673118000,
            "no": 1044,
            "name": "电压A相25次谐波",
            "groupId": "1861b8d271314793a72be5252f386766",
            "id": "22be383e46514b188d0caa124400d5ce",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": 1696673118000,
            "no": 1045,
            "name": "电压A相26次谐波",
            "groupId": "1861b8d271314793a72be5252f386766",
            "id": "6157fea55e2442edac684d6974d4ac37",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": 1696673118000,
            "no": 1046,
            "name": "电压A相27次谐波",
            "groupId": "1861b8d271314793a72be5252f386766",
            "id": "13ba46804742469694876e0464ed3ab5",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": 1696673118000,
            "no": 1047,
            "name": "电压A相28次谐波",
            "groupId": "1861b8d271314793a72be5252f386766",
            "id": "6a372006998746cdbc347552cb78dd83",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": 1696673118000,
            "no": 1048,
            "name": "电压A相29次谐波",
            "groupId": "1861b8d271314793a72be5252f386766",
            "id": "4388e1d37a764f509c09581dea2b8a4c",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": 1696673118000,
            "no": 1049,
            "name": "电压A相30次谐波",
            "groupId": "1861b8d271314793a72be5252f386766",
            "id": "45b93e1f64254e53a507e2b2b49c3c40",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": 1696673118000,
            "no": 1050,
            "name": "电压A相31次谐波",
            "groupId": "1861b8d271314793a72be5252f386766",
            "id": "cec7cd23b6ef4ad9a63b585353be0702",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": 1696673118000,
            "no": 1051,
            "name": "电压A相32次谐波",
            "groupId": "1861b8d271314793a72be5252f386766",
            "id": "9c13c00c38e84d1988a623eab9ecba37",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": 1696673118000,
            "no": 1052,
            "name": "电压A相33次谐波",
            "groupId": "1861b8d271314793a72be5252f386766",
            "id": "28d03128f1974bd886b9584c31e3995d",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": 1696673119000,
            "no": 1053,
            "name": "电压A相34次谐波",
            "groupId": "1861b8d271314793a72be5252f386766",
            "id": "0469608d243243678c10034eeb78a37d",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": 1696673119000,
            "no": 1054,
            "name": "电压A相35次谐波",
            "groupId": "1861b8d271314793a72be5252f386766",
            "id": "f43fbbdc737b4683a51c0023374a5435",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": 1696673119000,
            "no": 1055,
            "name": "电压A相36次谐波",
            "groupId": "1861b8d271314793a72be5252f386766",
            "id": "2443bec31c7f4819baedd1303a35a019",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": 1696673119000,
            "no": 1056,
            "name": "电压A相37次谐波",
            "groupId": "1861b8d271314793a72be5252f386766",
            "id": "e8ded48234e14945971839e06d43fc79",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": 1696673119000,
            "no": 1057,
            "name": "电压A相38次谐波",
            "groupId": "1861b8d271314793a72be5252f386766",
            "id": "c70b3f01c0cc4cc0bc863a41c5404a9b",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": 1696673119000,
            "no": 1058,
            "name": "电压A相39次谐波",
            "groupId": "1861b8d271314793a72be5252f386766",
            "id": "0ef7ee90f9174260988728949f6cee85",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": 1696673119000,
            "no": 1059,
            "name": "电压A相40次谐波",
            "groupId": "1861b8d271314793a72be5252f386766",
            "id": "08e30118b73a400d899034c2143a191b",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": 1696673119000,
            "no": 1060,
            "name": "电压A相41次谐波",
            "groupId": "1861b8d271314793a72be5252f386766",
            "id": "478af2a864854f6599ee67a0911c2d6c",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": 1696673119000,
            "no": 1061,
            "name": "电压A相42次谐波",
            "groupId": "1861b8d271314793a72be5252f386766",
            "id": "ce1767af6a88423c8f369c9b7eabd071",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": 1696673119000,
            "no": 1062,
            "name": "电压A相43次谐波",
            "groupId": "1861b8d271314793a72be5252f386766",
            "id": "a2de3030006846acae6bdd4de36569f7",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": 1696673119000,
            "no": 1063,
            "name": "电压A相44次谐波",
            "groupId": "1861b8d271314793a72be5252f386766",
            "id": "e968fa584095416f8d001e167268e3d1",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": 1696673119000,
            "no": 1064,
            "name": "电压A相45次谐波",
            "groupId": "1861b8d271314793a72be5252f386766",
            "id": "29a5deb783804db8811b8cfdf43e3856",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": 1696673119000,
            "no": 1065,
            "name": "电压A相46次谐波",
            "groupId": "1861b8d271314793a72be5252f386766",
            "id": "6a9958254f914d8c95154ef430e5af1d",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": 1696673119000,
            "no": 1066,
            "name": "电压A相47次谐波",
            "groupId": "1861b8d271314793a72be5252f386766",
            "id": "831976595124414d8b2a03256293608f",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": 1696673119000,
            "no": 1067,
            "name": "电压A相48次谐波",
            "groupId": "1861b8d271314793a72be5252f386766",
            "id": "8897c82e5e634d20bd5662ec11b0d9fa",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": 1696673119000,
            "no": 1068,
            "name": "电压A相49次谐波",
            "groupId": "1861b8d271314793a72be5252f386766",
            "id": "08b154371f794e299ad9f2750414979b",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": 1696673253000,
            "no": 1069,
            "name": "电压A相50次谐波",
            "groupId": "1861b8d271314793a72be5252f386766",
            "id": "ffa780a79c7b4d8aa6bc91d52064c04a",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": 1696673396000,
            "no": 1070,
            "name": "电压B相2次谐波",
            "groupId": "d504fbb6930546e2984f86bc5896a2db",
            "id": "05f31da3d6d3423eb28406a0e8a9c2b3",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": 1696673396000,
            "no": 1071,
            "name": "电压B相3次谐波",
            "groupId": "d504fbb6930546e2984f86bc5896a2db",
            "id": "e5c8bb9782c5458eba8589029406d482",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": 1696673396000,
            "no": 1072,
            "name": "电压B相4次谐波",
            "groupId": "d504fbb6930546e2984f86bc5896a2db",
            "id": "bb18c67431034cabbe75b90cd9c1eb16",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": 1696673396000,
            "no": 1073,
            "name": "电压B相5次谐波",
            "groupId": "d504fbb6930546e2984f86bc5896a2db",
            "id": "e342da5819d1492e9855329661dffef4",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": 1696673396000,
            "no": 1074,
            "name": "电压B相6次谐波",
            "groupId": "d504fbb6930546e2984f86bc5896a2db",
            "id": "da0eeaab6c294018a2023e9ddff0c87a",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": 1696673396000,
            "no": 1075,
            "name": "电压B相7次谐波",
            "groupId": "d504fbb6930546e2984f86bc5896a2db",
            "id": "fb505adf5ca441eead5ed363f59ebc23",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": 1696673396000,
            "no": 1076,
            "name": "电压B相8次谐波",
            "groupId": "d504fbb6930546e2984f86bc5896a2db",
            "id": "6dd51de33f8244fc9c2b5d6e7cfe9d38",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": 1696673396000,
            "no": 1077,
            "name": "电压B相9次谐波",
            "groupId": "d504fbb6930546e2984f86bc5896a2db",
            "id": "2b4d26f20f1a49918bcf4a7fa00b4b7c",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": 1696673396000,
            "no": 1078,
            "name": "电压B相10次谐波",
            "groupId": "d504fbb6930546e2984f86bc5896a2db",
            "id": "4b0fb7100edf4f7ea5c2fe5eabef81ca",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": 1696673397000,
            "no": 1079,
            "name": "电压B相11次谐波",
            "groupId": "d504fbb6930546e2984f86bc5896a2db",
            "id": "ec5692c32c2b43ebba13437abe7c84b6",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": 1696673397000,
            "no": 1080,
            "name": "电压B相12次谐波",
            "groupId": "d504fbb6930546e2984f86bc5896a2db",
            "id": "d46a75063d414319990578e9c67567ca",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": 1696673397000,
            "no": 1081,
            "name": "电压B相13次谐波",
            "groupId": "d504fbb6930546e2984f86bc5896a2db",
            "id": "2b3c2b20b9444edfa1f1e94c9a6c63ba",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": 1696673397000,
            "no": 1082,
            "name": "电压B相14次谐波",
            "groupId": "d504fbb6930546e2984f86bc5896a2db",
            "id": "1517ee38fb34476e8a17e12a38508974",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": 1696673397000,
            "no": 1083,
            "name": "电压B相15次谐波",
            "groupId": "d504fbb6930546e2984f86bc5896a2db",
            "id": "e991ef85fa5345c0aecc0003f3eb98b7",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": 1696673397000,
            "no": 1084,
            "name": "电压B相16次谐波",
            "groupId": "d504fbb6930546e2984f86bc5896a2db",
            "id": "ea076ac654bb43aabfdb0d5dc911429e",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": 1696673397000,
            "no": 1085,
            "name": "电压B相17次谐波",
            "groupId": "d504fbb6930546e2984f86bc5896a2db",
            "id": "e71d21b657be459f842b5bedd6d17bc6",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": 1696673397000,
            "no": 1086,
            "name": "电压B相18次谐波",
            "groupId": "d504fbb6930546e2984f86bc5896a2db",
            "id": "54b5308005a0478e9c03b5f81640d336",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": 1696673397000,
            "no": 1087,
            "name": "电压B相19次谐波",
            "groupId": "d504fbb6930546e2984f86bc5896a2db",
            "id": "129fca9530354c6a94198dfe884d13f4",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": 1696673397000,
            "no": 1088,
            "name": "电压B相20次谐波",
            "groupId": "d504fbb6930546e2984f86bc5896a2db",
            "id": "546e9634c03b43b8ab70bbe80f23d598",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": 1696673397000,
            "no": 1089,
            "name": "电压B相21次谐波",
            "groupId": "d504fbb6930546e2984f86bc5896a2db",
            "id": "adfacc9e1c104c418d8e90bc722a159f",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": 1696673397000,
            "no": 1090,
            "name": "电压B相22次谐波",
            "groupId": "d504fbb6930546e2984f86bc5896a2db",
            "id": "213c474d1d9d492ab1eee002d955b344",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": 1696673397000,
            "no": 1091,
            "name": "电压B相23次谐波",
            "groupId": "d504fbb6930546e2984f86bc5896a2db",
            "id": "f0a9a500c4f44c53abc14af4c3cf0917",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": 1696673397000,
            "no": 1092,
            "name": "电压B相24次谐波",
            "groupId": "d504fbb6930546e2984f86bc5896a2db",
            "id": "996c73d3bd9b44228ddffd52187983c4",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": 1696673397000,
            "no": 1093,
            "name": "电压B相25次谐波",
            "groupId": "d504fbb6930546e2984f86bc5896a2db",
            "id": "470946a7362945839cf4908f31ff6660",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": 1696673397000,
            "no": 1094,
            "name": "电压B相26次谐波",
            "groupId": "d504fbb6930546e2984f86bc5896a2db",
            "id": "95c451277a01480fbb0d2854bc4365e9",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": 1696673397000,
            "no": 1095,
            "name": "电压B相27次谐波",
            "groupId": "d504fbb6930546e2984f86bc5896a2db",
            "id": "65cb0447b2594db7bc7aefd235240d56",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": 1696673398000,
            "no": 1096,
            "name": "电压B相28次谐波",
            "groupId": "d504fbb6930546e2984f86bc5896a2db",
            "id": "a1f4248d69b84e77a79b617fdccb2a38",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": 1696673398000,
            "no": 1097,
            "name": "电压B相29次谐波",
            "groupId": "d504fbb6930546e2984f86bc5896a2db",
            "id": "41c4724c5c4a4d84845a08918786ac36",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": 1696673398000,
            "no": 1098,
            "name": "电压B相30次谐波",
            "groupId": "d504fbb6930546e2984f86bc5896a2db",
            "id": "b3abff0c87a34178a0a02b4964cc49d4",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": 1696673398000,
            "no": 1099,
            "name": "电压B相31次谐波",
            "groupId": "d504fbb6930546e2984f86bc5896a2db",
            "id": "1199cb90b71c470da34364f08412c8ca",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": 1696673398000,
            "no": 1100,
            "name": "电压B相32次谐波",
            "groupId": "d504fbb6930546e2984f86bc5896a2db",
            "id": "10cc9b5fc9f54ca6990dec5fb16eb3f0",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": 1696673398000,
            "no": 1101,
            "name": "电压B相33次谐波",
            "groupId": "d504fbb6930546e2984f86bc5896a2db",
            "id": "b6bdec76f1ae41129abdc483920deb1f",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": 1696673398000,
            "no": 1102,
            "name": "电压B相34次谐波",
            "groupId": "d504fbb6930546e2984f86bc5896a2db",
            "id": "372f9d650cc14b1596e3aae0d1dc4f7a",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": 1696673398000,
            "no": 1103,
            "name": "电压B相35次谐波",
            "groupId": "d504fbb6930546e2984f86bc5896a2db",
            "id": "5749a346617c4722b6fe7fedc5f5be56",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": 1696673398000,
            "no": 1104,
            "name": "电压B相36次谐波",
            "groupId": "d504fbb6930546e2984f86bc5896a2db",
            "id": "a2ef4ff7aea848499600920487f7b61f",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": 1696673398000,
            "no": 1105,
            "name": "电压B相37次谐波",
            "groupId": "d504fbb6930546e2984f86bc5896a2db",
            "id": "fa0d46f1722f4345a4bdd0b6ac4105ff",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": 1696673398000,
            "no": 1106,
            "name": "电压B相38次谐波",
            "groupId": "d504fbb6930546e2984f86bc5896a2db",
            "id": "40e7874a0f3041e9ab7864592af72fc1",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": 1696673398000,
            "no": 1107,
            "name": "电压B相39次谐波",
            "groupId": "d504fbb6930546e2984f86bc5896a2db",
            "id": "f0ff3247f31140d192756a6865b1d882",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": 1696673398000,
            "no": 1108,
            "name": "电压B相40次谐波",
            "groupId": "d504fbb6930546e2984f86bc5896a2db",
            "id": "63b37e7a608d4ccab1ada73a73409ee3",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": 1696673398000,
            "no": 1109,
            "name": "电压B相41次谐波",
            "groupId": "d504fbb6930546e2984f86bc5896a2db",
            "id": "608bcaa7a9df4d0aa16ba07a850da6bc",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": 1696673398000,
            "no": 1110,
            "name": "电压B相42次谐波",
            "groupId": "d504fbb6930546e2984f86bc5896a2db",
            "id": "e578547dc9324703a0f51bb397878316",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": 1696673399000,
            "no": 1111,
            "name": "电压B相43次谐波",
            "groupId": "d504fbb6930546e2984f86bc5896a2db",
            "id": "8a8e499206c3413aa6cf0f1c6c6b28db",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": 1696673399000,
            "no": 1112,
            "name": "电压B相44次谐波",
            "groupId": "d504fbb6930546e2984f86bc5896a2db",
            "id": "961b1fcec078497385b81a2e9f392f1d",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": 1696673399000,
            "no": 1113,
            "name": "电压B相45次谐波",
            "groupId": "d504fbb6930546e2984f86bc5896a2db",
            "id": "84eda566e9d84cee88ab1297d410ab6b",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": 1696673399000,
            "no": 1114,
            "name": "电压B相46次谐波",
            "groupId": "d504fbb6930546e2984f86bc5896a2db",
            "id": "036650001e0d4243a9f69fca25d7d091",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": 1696673399000,
            "no": 1115,
            "name": "电压B相47次谐波",
            "groupId": "d504fbb6930546e2984f86bc5896a2db",
            "id": "194cf19278e247a9813092e3e88656db",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": 1696673399000,
            "no": 1116,
            "name": "电压B相48次谐波",
            "groupId": "d504fbb6930546e2984f86bc5896a2db",
            "id": "3379e812e4194c12b040782fc978576a",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": 1696673399000,
            "no": 1117,
            "name": "电压B相49次谐波",
            "groupId": "d504fbb6930546e2984f86bc5896a2db",
            "id": "39be10ffe7d0430580d181507687189f",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": 1696673399000,
            "no": 1118,
            "name": "电压B相50次谐波",
            "groupId": "d504fbb6930546e2984f86bc5896a2db",
            "id": "596c33ed38d84e68a8dc61320b90e485",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": 1696673471000,
            "no": 1119,
            "name": "电压C相2次谐波",
            "groupId": "4d1674e52604433b95b3ada0db0aef29",
            "id": "3733b4f589fd4ea0b64d2966359977c4",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": 1696673471000,
            "no": 1120,
            "name": "电压C相3次谐波",
            "groupId": "4d1674e52604433b95b3ada0db0aef29",
            "id": "3e354ae392214d3bbd41800abf74aa34",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": 1696673471000,
            "no": 1121,
            "name": "电压C相4次谐波",
            "groupId": "4d1674e52604433b95b3ada0db0aef29",
            "id": "0b72baf98bf74c9c9609af1f6cb30508",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": 1696673471000,
            "no": 1122,
            "name": "电压C相5次谐波",
            "groupId": "4d1674e52604433b95b3ada0db0aef29",
            "id": "2df648de8f6e4c36b0613416ce9b2a24",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": 1696673471000,
            "no": 1123,
            "name": "电压C相6次谐波",
            "groupId": "4d1674e52604433b95b3ada0db0aef29",
            "id": "fa4e326f6d794d2fb275c9568e27bdcf",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": 1696673471000,
            "no": 1124,
            "name": "电压C相7次谐波",
            "groupId": "4d1674e52604433b95b3ada0db0aef29",
            "id": "9f396dec672241bc9ba1917ef95dc608",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": 1696673472000,
            "no": 1125,
            "name": "电压C相8次谐波",
            "groupId": "4d1674e52604433b95b3ada0db0aef29",
            "id": "33ce71ac705442ae999ce693156a37ec",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": 1696673472000,
            "no": 1126,
            "name": "电压C相9次谐波",
            "groupId": "4d1674e52604433b95b3ada0db0aef29",
            "id": "b0053eb35542422583428f2d754ec7ea",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": 1696673472000,
            "no": 1127,
            "name": "电压C相10次谐波",
            "groupId": "4d1674e52604433b95b3ada0db0aef29",
            "id": "43af5f80106c48638cc859fe1a85b74a",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": 1696673472000,
            "no": 1128,
            "name": "电压C相11次谐波",
            "groupId": "4d1674e52604433b95b3ada0db0aef29",
            "id": "7ec0a4992f564d3d9918c9de659c21f0",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": 1696673472000,
            "no": 1129,
            "name": "电压C相12次谐波",
            "groupId": "4d1674e52604433b95b3ada0db0aef29",
            "id": "7db6dcc62e03490eb57d69477a14405e",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": 1696673472000,
            "no": 1130,
            "name": "电压C相13次谐波",
            "groupId": "4d1674e52604433b95b3ada0db0aef29",
            "id": "e50df3c7e450499c8887a93c7f181f5d",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": 1696673472000,
            "no": 1131,
            "name": "电压C相14次谐波",
            "groupId": "4d1674e52604433b95b3ada0db0aef29",
            "id": "f9420907968f40768e8a8e3a387525c0",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": 1696673472000,
            "no": 1132,
            "name": "电压C相15次谐波",
            "groupId": "4d1674e52604433b95b3ada0db0aef29",
            "id": "fac439034ac44fe3b09a44cb9d9084c3",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": 1696673472000,
            "no": 1133,
            "name": "电压C相16次谐波",
            "groupId": "4d1674e52604433b95b3ada0db0aef29",
            "id": "bdb278d41014483294a97a1aa4d6bca1",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": 1696673472000,
            "no": 1134,
            "name": "电压C相17次谐波",
            "groupId": "4d1674e52604433b95b3ada0db0aef29",
            "id": "cb8e63edbea34d459e40d776f0c9d641",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": 1696673472000,
            "no": 1135,
            "name": "电压C相18次谐波",
            "groupId": "4d1674e52604433b95b3ada0db0aef29",
            "id": "a635447b984445649073fc3a494725d5",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": 1696673472000,
            "no": 1136,
            "name": "电压C相19次谐波",
            "groupId": "4d1674e52604433b95b3ada0db0aef29",
            "id": "507f92da7b1347ef88129a7e63185b88",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": 1696673472000,
            "no": 1137,
            "name": "电压C相20次谐波",
            "groupId": "4d1674e52604433b95b3ada0db0aef29",
            "id": "533cf2c6df60454ea4499973472e7a1e",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": 1696673472000,
            "no": 1138,
            "name": "电压C相21次谐波",
            "groupId": "4d1674e52604433b95b3ada0db0aef29",
            "id": "c865daa9d99343f68019e12e1458d2ca",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": 1696673473000,
            "no": 1139,
            "name": "电压C相22次谐波",
            "groupId": "4d1674e52604433b95b3ada0db0aef29",
            "id": "5701c1a0d48a4cbca54d6e4708ff6ed3",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": 1696673473000,
            "no": 1140,
            "name": "电压C相23次谐波",
            "groupId": "4d1674e52604433b95b3ada0db0aef29",
            "id": "d9401d9b15f046f9915dd6d6c9e24c63",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": 1696673473000,
            "no": 1141,
            "name": "电压C相24次谐波",
            "groupId": "4d1674e52604433b95b3ada0db0aef29",
            "id": "69fc9584b89f4d57a352b46c9cf66afb",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": 1696673473000,
            "no": 1142,
            "name": "电压C相25次谐波",
            "groupId": "4d1674e52604433b95b3ada0db0aef29",
            "id": "6a4c523492174d12a8982fe5949a16c9",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": 1696673473000,
            "no": 1143,
            "name": "电压C相26次谐波",
            "groupId": "4d1674e52604433b95b3ada0db0aef29",
            "id": "17715fc590ce4906b21093cfa1ead77b",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": 1696673473000,
            "no": 1144,
            "name": "电压C相27次谐波",
            "groupId": "4d1674e52604433b95b3ada0db0aef29",
            "id": "06ead131968049429d9a5f36bd9cd944",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": 1696673473000,
            "no": 1145,
            "name": "电压C相28次谐波",
            "groupId": "4d1674e52604433b95b3ada0db0aef29",
            "id": "1fa936b1de254262b0e49dc737374500",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": 1696673473000,
            "no": 1146,
            "name": "电压C相29次谐波",
            "groupId": "4d1674e52604433b95b3ada0db0aef29",
            "id": "a4aa5b28a2cf452a972fbb3680691540",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": 1696673473000,
            "no": 1147,
            "name": "电压C相30次谐波",
            "groupId": "4d1674e52604433b95b3ada0db0aef29",
            "id": "5591e16416e04c15b758d3257a1f063d",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": 1696673473000,
            "no": 1148,
            "name": "电压C相31次谐波",
            "groupId": "4d1674e52604433b95b3ada0db0aef29",
            "id": "bd1f1a69b2974864bde8022167ecf208",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": 1696673473000,
            "no": 1149,
            "name": "电压C相32次谐波",
            "groupId": "4d1674e52604433b95b3ada0db0aef29",
            "id": "80164ce765af46b2a2832fd3240fa66f",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": 1696673473000,
            "no": 1150,
            "name": "电压C相33次谐波",
            "groupId": "4d1674e52604433b95b3ada0db0aef29",
            "id": "7342330617914fa5ab08151f75dcb6bd",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": 1696673473000,
            "no": 1151,
            "name": "电压C相34次谐波",
            "groupId": "4d1674e52604433b95b3ada0db0aef29",
            "id": "a209560c320a4a5685f72986057aba29",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": 1696673473000,
            "no": 1152,
            "name": "电压C相35次谐波",
            "groupId": "4d1674e52604433b95b3ada0db0aef29",
            "id": "7e96d934cf534c629bd579fbc05ec21f",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": 1696673473000,
            "no": 1153,
            "name": "电压C相36次谐波",
            "groupId": "4d1674e52604433b95b3ada0db0aef29",
            "id": "0eb92b5573194e2fa51f5d748b20caca",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": 1696673473000,
            "no": 1154,
            "name": "电压C相37次谐波",
            "groupId": "4d1674e52604433b95b3ada0db0aef29",
            "id": "97f5a55e6f064a81b0a5f9d0adce524f",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": 1696673473000,
            "no": 1155,
            "name": "电压C相38次谐波",
            "groupId": "4d1674e52604433b95b3ada0db0aef29",
            "id": "9a6059b739d248de8eb22195770772b3",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": 1696673473000,
            "no": 1156,
            "name": "电压C相39次谐波",
            "groupId": "4d1674e52604433b95b3ada0db0aef29",
            "id": "7ecbfcc7704a44548dfe2bf9daaa15f4",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": 1696673473000,
            "no": 1157,
            "name": "电压C相40次谐波",
            "groupId": "4d1674e52604433b95b3ada0db0aef29",
            "id": "aec14038d7544bdfaa1780fe7baaf98b",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": 1696673474000,
            "no": 1158,
            "name": "电压C相41次谐波",
            "groupId": "4d1674e52604433b95b3ada0db0aef29",
            "id": "fc99b5e0548f4899aed9c920390a2d20",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": 1696673474000,
            "no": 1159,
            "name": "电压C相42次谐波",
            "groupId": "4d1674e52604433b95b3ada0db0aef29",
            "id": "b3490aeba8d64c33aaaea686eee875c5",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": 1696673474000,
            "no": 1160,
            "name": "电压C相43次谐波",
            "groupId": "4d1674e52604433b95b3ada0db0aef29",
            "id": "d414e30c2fad469080ccf01a69cf38a7",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": 1696673474000,
            "no": 1161,
            "name": "电压C相44次谐波",
            "groupId": "4d1674e52604433b95b3ada0db0aef29",
            "id": "d73e78d32c6a4617b1eb25ef7fcad5d8",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": 1696673474000,
            "no": 1162,
            "name": "电压C相45次谐波",
            "groupId": "4d1674e52604433b95b3ada0db0aef29",
            "id": "f12f985e48b44f399ae74492ada949b3",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": 1696673474000,
            "no": 1163,
            "name": "电压C相46次谐波",
            "groupId": "4d1674e52604433b95b3ada0db0aef29",
            "id": "7d26864ab3164be398c5b562dfd16cfc",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": 1696673474000,
            "no": 1164,
            "name": "电压C相47次谐波",
            "groupId": "4d1674e52604433b95b3ada0db0aef29",
            "id": "81408036935543fab8afcfb54800f386",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": 1696673474000,
            "no": 1165,
            "name": "电压C相48次谐波",
            "groupId": "4d1674e52604433b95b3ada0db0aef29",
            "id": "a5c9bdde311c43038b85f09ab1ef88cf",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": 1696673474000,
            "no": 1166,
            "name": "电压C相49次谐波",
            "groupId": "4d1674e52604433b95b3ada0db0aef29",
            "id": "39da093277404f2ebb0a4be143c95f20",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": 1696673474000,
            "no": 1167,
            "name": "电压C相50次谐波",
            "groupId": "4d1674e52604433b95b3ada0db0aef29",
            "id": "d4b94fc0bbed47beb76dd0195ff148ef",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": 1696673573000,
            "no": 1168,
            "name": "电流A相2次谐波",
            "groupId": "65c7f6462ed84cda924220feeab96713",
            "id": "0ba9a7f5be0a46238d9c7f2454d68f28",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": 1696673573000,
            "no": 1169,
            "name": "电流A相3次谐波",
            "groupId": "65c7f6462ed84cda924220feeab96713",
            "id": "a3b3cae58d6842c3b7ac9be456aae921",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": 1696673573000,
            "no": 1170,
            "name": "电流A相4次谐波",
            "groupId": "65c7f6462ed84cda924220feeab96713",
            "id": "f84eaf5aba2e4c2c9bd2d686746ea316",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": 1696673573000,
            "no": 1171,
            "name": "电流A相5次谐波",
            "groupId": "65c7f6462ed84cda924220feeab96713",
            "id": "8e96e37fca9f4afbb9afa43c3ebd54b2",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": 1696673574000,
            "no": 1172,
            "name": "电流A相6次谐波",
            "groupId": "65c7f6462ed84cda924220feeab96713",
            "id": "d0134b44a7b548079ffc84fe5669300c",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": 1696673574000,
            "no": 1173,
            "name": "电流A相7次谐波",
            "groupId": "65c7f6462ed84cda924220feeab96713",
            "id": "891f0158b0a643439f843bd6780ac787",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": 1696673574000,
            "no": 1174,
            "name": "电流A相8次谐波",
            "groupId": "65c7f6462ed84cda924220feeab96713",
            "id": "123d84c5ce5646d9900772a854ff42b6",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": 1696673574000,
            "no": 1175,
            "name": "电流A相9次谐波",
            "groupId": "65c7f6462ed84cda924220feeab96713",
            "id": "368cf0d884ff422096fb9f529e2fc910",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": 1696673574000,
            "no": 1176,
            "name": "电流A相10次谐波",
            "groupId": "65c7f6462ed84cda924220feeab96713",
            "id": "35fa188093f642ada15360488f09ac3e",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": 1696673574000,
            "no": 1177,
            "name": "电流A相11次谐波",
            "groupId": "65c7f6462ed84cda924220feeab96713",
            "id": "dba8946eedaa4d1683f6e237244388bc",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": 1696673574000,
            "no": 1178,
            "name": "电流A相12次谐波",
            "groupId": "65c7f6462ed84cda924220feeab96713",
            "id": "349a662018de4f23b6818fdeaacba62b",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": 1696673574000,
            "no": 1179,
            "name": "电流A相13次谐波",
            "groupId": "65c7f6462ed84cda924220feeab96713",
            "id": "87cb4f613615417ba79d987866675bf2",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": 1696673574000,
            "no": 1180,
            "name": "电流A相14次谐波",
            "groupId": "65c7f6462ed84cda924220feeab96713",
            "id": "badb41438a294772acfc5b461f1a8fdd",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": 1696673574000,
            "no": 1181,
            "name": "电流A相15次谐波",
            "groupId": "65c7f6462ed84cda924220feeab96713",
            "id": "02efb1e5447049f09297cb908ca53fe3",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": 1696673574000,
            "no": 1182,
            "name": "电流A相16次谐波",
            "groupId": "65c7f6462ed84cda924220feeab96713",
            "id": "9fbca4d546ce4b40afdfafdb119e8cbc",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": 1696673574000,
            "no": 1183,
            "name": "电流A相17次谐波",
            "groupId": "65c7f6462ed84cda924220feeab96713",
            "id": "b8be2a8e676b4bc690c6c3056d91742e",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": 1696673574000,
            "no": 1184,
            "name": "电流A相18次谐波",
            "groupId": "65c7f6462ed84cda924220feeab96713",
            "id": "f59c72f48ed84eaeaa05f9cde0f8b079",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": 1696673574000,
            "no": 1185,
            "name": "电流A相19次谐波",
            "groupId": "65c7f6462ed84cda924220feeab96713",
            "id": "c0de20d2ca4c44dea0ac81a197383b7e",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": 1696673574000,
            "no": 1186,
            "name": "电流A相20次谐波",
            "groupId": "65c7f6462ed84cda924220feeab96713",
            "id": "48af3c7aac1b4d55a543e9b3c66edcb4",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": 1696673574000,
            "no": 1187,
            "name": "电流A相21次谐波",
            "groupId": "65c7f6462ed84cda924220feeab96713",
            "id": "9810de49657e44d89e1014779e5452ef",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": 1696673574000,
            "no": 1188,
            "name": "电流A相22次谐波",
            "groupId": "65c7f6462ed84cda924220feeab96713",
            "id": "52fcfa5244f84fdea30f7906eaab3865",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": 1696673575000,
            "no": 1189,
            "name": "电流A相23次谐波",
            "groupId": "65c7f6462ed84cda924220feeab96713",
            "id": "a7b90ffd5c184dcf9039d93b663b1583",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": 1696673575000,
            "no": 1190,
            "name": "电流A相24次谐波",
            "groupId": "65c7f6462ed84cda924220feeab96713",
            "id": "5508ab91466646589d17ab99edee3efe",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": 1696673575000,
            "no": 1191,
            "name": "电流A相25次谐波",
            "groupId": "65c7f6462ed84cda924220feeab96713",
            "id": "004f155559cd41828b55810dab3894aa",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": 1696673575000,
            "no": 1192,
            "name": "电流A相26次谐波",
            "groupId": "65c7f6462ed84cda924220feeab96713",
            "id": "93bd4046c5064c939fdac389fa78273f",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": 1696673575000,
            "no": 1193,
            "name": "电流A相27次谐波",
            "groupId": "65c7f6462ed84cda924220feeab96713",
            "id": "4c0bfb2620f248dc89d51ff2df42095a",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": 1696673575000,
            "no": 1194,
            "name": "电流A相28次谐波",
            "groupId": "65c7f6462ed84cda924220feeab96713",
            "id": "002971e0ef86438e86e7f5421109d7ca",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": 1696673575000,
            "no": 1195,
            "name": "电流A相29次谐波",
            "groupId": "65c7f6462ed84cda924220feeab96713",
            "id": "e45bc31e09274f9eac4a6b2674cd6520",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": 1696673575000,
            "no": 1196,
            "name": "电流A相30次谐波",
            "groupId": "65c7f6462ed84cda924220feeab96713",
            "id": "aaa51378b1414b1fb7ea794a71cac1f8",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": 1696673575000,
            "no": 1197,
            "name": "电流A相31次谐波",
            "groupId": "65c7f6462ed84cda924220feeab96713",
            "id": "49dda029669444b894cb006a2f28e08d",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": 1696673575000,
            "no": 1198,
            "name": "电流A相32次谐波",
            "groupId": "65c7f6462ed84cda924220feeab96713",
            "id": "b25f86253f984959953edd66d9c77594",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": 1696673575000,
            "no": 1199,
            "name": "电流A相33次谐波",
            "groupId": "65c7f6462ed84cda924220feeab96713",
            "id": "ef0199fe42c6410eb8816818307bf71a",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": 1696673575000,
            "no": 1200,
            "name": "电流A相34次谐波",
            "groupId": "65c7f6462ed84cda924220feeab96713",
            "id": "e0256beae7124996beacb5af1e518f96",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": 1696673575000,
            "no": 1201,
            "name": "电流A相35次谐波",
            "groupId": "65c7f6462ed84cda924220feeab96713",
            "id": "7c1c4f3c06064e9fb0f14abd2966924f",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": 1696673575000,
            "no": 1202,
            "name": "电流A相36次谐波",
            "groupId": "65c7f6462ed84cda924220feeab96713",
            "id": "0e3c82093167402ea2883e533eec90e9",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": 1696673575000,
            "no": 1203,
            "name": "电流A相37次谐波",
            "groupId": "65c7f6462ed84cda924220feeab96713",
            "id": "319dd863ecf849fb9046b9dfe332b23e",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": 1696673576000,
            "no": 1204,
            "name": "电流A相38次谐波",
            "groupId": "65c7f6462ed84cda924220feeab96713",
            "id": "0f91b7864ef04c16830dbcb756ea1c4d",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": 1696673576000,
            "no": 1205,
            "name": "电流A相39次谐波",
            "groupId": "65c7f6462ed84cda924220feeab96713",
            "id": "c1f4f1e001594a2e9a950ee5bd9c0d07",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": 1696673576000,
            "no": 1206,
            "name": "电流A相40次谐波",
            "groupId": "65c7f6462ed84cda924220feeab96713",
            "id": "2122cb9f96a14490a9a77b04cf4447bf",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": 1696673576000,
            "no": 1207,
            "name": "电流A相41次谐波",
            "groupId": "65c7f6462ed84cda924220feeab96713",
            "id": "25d9d4ffe3c44775bab9584632828d4a",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": 1696673576000,
            "no": 1208,
            "name": "电流A相42次谐波",
            "groupId": "65c7f6462ed84cda924220feeab96713",
            "id": "a2bcc0523b99489aa47eefb91738eff4",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": 1696673576000,
            "no": 1209,
            "name": "电流A相43次谐波",
            "groupId": "65c7f6462ed84cda924220feeab96713",
            "id": "444527d15ad34301a8e9136bb216cfb0",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": 1696673576000,
            "no": 1210,
            "name": "电流A相44次谐波",
            "groupId": "65c7f6462ed84cda924220feeab96713",
            "id": "00ff4e93fe944402bd2a5680f5f90d0e",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": 1696673576000,
            "no": 1211,
            "name": "电流A相45次谐波",
            "groupId": "65c7f6462ed84cda924220feeab96713",
            "id": "357789c2c6b944ef816fea41c8e2fada",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": 1696673576000,
            "no": 1212,
            "name": "电流A相46次谐波",
            "groupId": "65c7f6462ed84cda924220feeab96713",
            "id": "41ffde5b6e2c40d8979b4a38618c19e5",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": 1696673576000,
            "no": 1213,
            "name": "电流A相47次谐波",
            "groupId": "65c7f6462ed84cda924220feeab96713",
            "id": "67b1c746306c463ea51cd9e98c5b00bf",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": 1696673576000,
            "no": 1214,
            "name": "电流A相48次谐波",
            "groupId": "65c7f6462ed84cda924220feeab96713",
            "id": "4459f8aa132047fcb05100e2753ba31d",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": 1696673576000,
            "no": 1215,
            "name": "电流A相49次谐波",
            "groupId": "65c7f6462ed84cda924220feeab96713",
            "id": "feaba6aecfb94a1fa53b013c402a4bca",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": 1696673576000,
            "no": 1216,
            "name": "电流A相50次谐波",
            "groupId": "65c7f6462ed84cda924220feeab96713",
            "id": "a16f6f2b29084c6c9d1aa660550017db",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": 1696673627000,
            "no": 1217,
            "name": "电流B相2次谐波",
            "groupId": "0b4e1c9866f447bbb4367a83dc139d26",
            "id": "dd7a64e37d784ddb953cccdfba4fa40a",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": 1696673627000,
            "no": 1218,
            "name": "电流B相3次谐波",
            "groupId": "0b4e1c9866f447bbb4367a83dc139d26",
            "id": "cbaddc37b8254c5cbf3fd0e6a75f3cf4",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": 1696673627000,
            "no": 1219,
            "name": "电流B相4次谐波",
            "groupId": "0b4e1c9866f447bbb4367a83dc139d26",
            "id": "7b0b2f968d2c490582b7e7e26512e3b9",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": 1696673627000,
            "no": 1220,
            "name": "电流B相5次谐波",
            "groupId": "0b4e1c9866f447bbb4367a83dc139d26",
            "id": "ebdbdddccb464d1d93d71a754f99e5ba",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": 1696673627000,
            "no": 1221,
            "name": "电流B相6次谐波",
            "groupId": "0b4e1c9866f447bbb4367a83dc139d26",
            "id": "a2e60e3a5a094dd184035999214a51c8",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": 1696673627000,
            "no": 1222,
            "name": "电流B相7次谐波",
            "groupId": "0b4e1c9866f447bbb4367a83dc139d26",
            "id": "efc64d359b4a42dfb081597685d3ca63",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": 1696673627000,
            "no": 1223,
            "name": "电流B相8次谐波",
            "groupId": "0b4e1c9866f447bbb4367a83dc139d26",
            "id": "91d45bb3012d45d180f11480c4e58cbe",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": 1696673627000,
            "no": 1224,
            "name": "电流B相9次谐波",
            "groupId": "0b4e1c9866f447bbb4367a83dc139d26",
            "id": "febbff1a5a9f47cebc159f8bf5961294",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": 1696673627000,
            "no": 1225,
            "name": "电流B相10次谐波",
            "groupId": "0b4e1c9866f447bbb4367a83dc139d26",
            "id": "aa0a3da59a544611928be51c7c9bc79f",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": 1696673627000,
            "no": 1226,
            "name": "电流B相11次谐波",
            "groupId": "0b4e1c9866f447bbb4367a83dc139d26",
            "id": "c153fb3a53e149f9970c41f9ba8d4d68",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": 1696673627000,
            "no": 1227,
            "name": "电流B相12次谐波",
            "groupId": "0b4e1c9866f447bbb4367a83dc139d26",
            "id": "9774d140ed41422693ec258deef0c8bd",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": 1696673627000,
            "no": 1228,
            "name": "电流B相13次谐波",
            "groupId": "0b4e1c9866f447bbb4367a83dc139d26",
            "id": "25956810a64647e394416f94ab9dd2ab",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": 1696673627000,
            "no": 1229,
            "name": "电流B相14次谐波",
            "groupId": "0b4e1c9866f447bbb4367a83dc139d26",
            "id": "a29b57ca6b2b4a6d88707f7902766b67",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": 1696673627000,
            "no": 1230,
            "name": "电流B相15次谐波",
            "groupId": "0b4e1c9866f447bbb4367a83dc139d26",
            "id": "42edf9c4819044979694b27bacaef62b",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": 1696673627000,
            "no": 1231,
            "name": "电流B相16次谐波",
            "groupId": "0b4e1c9866f447bbb4367a83dc139d26",
            "id": "81c064f9ad4643a2b5ecb2071f4e4d66",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": 1696673627000,
            "no": 1232,
            "name": "电流B相17次谐波",
            "groupId": "0b4e1c9866f447bbb4367a83dc139d26",
            "id": "3b21f16758554580b059ded742a5f3ba",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": 1696673628000,
            "no": 1233,
            "name": "电流B相18次谐波",
            "groupId": "0b4e1c9866f447bbb4367a83dc139d26",
            "id": "a1845c4f191c4ff19a961aceeedb2248",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": 1696673628000,
            "no": 1234,
            "name": "电流B相19次谐波",
            "groupId": "0b4e1c9866f447bbb4367a83dc139d26",
            "id": "81945d3f344b4639a4f0e0a896624561",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": 1696673628000,
            "no": 1235,
            "name": "电流B相20次谐波",
            "groupId": "0b4e1c9866f447bbb4367a83dc139d26",
            "id": "8d9a1dc25aae4b789d14d8095a9bf0fb",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": 1696673628000,
            "no": 1236,
            "name": "电流B相21次谐波",
            "groupId": "0b4e1c9866f447bbb4367a83dc139d26",
            "id": "5560bab79d9c47a1a4e2f6219f6a7dbe",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": 1696673628000,
            "no": 1237,
            "name": "电流B相22次谐波",
            "groupId": "0b4e1c9866f447bbb4367a83dc139d26",
            "id": "ca035e17bc564d2d9d44d2c702d2e04d",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": 1696673628000,
            "no": 1238,
            "name": "电流B相23次谐波",
            "groupId": "0b4e1c9866f447bbb4367a83dc139d26",
            "id": "ee8cd382fd92404d97628aa501c734fe",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": 1696673628000,
            "no": 1239,
            "name": "电流B相24次谐波",
            "groupId": "0b4e1c9866f447bbb4367a83dc139d26",
            "id": "f27261a8666840089e62dd525faa0739",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": 1696673628000,
            "no": 1240,
            "name": "电流B相25次谐波",
            "groupId": "0b4e1c9866f447bbb4367a83dc139d26",
            "id": "1258e47c1eee42e1985e69fbbd16f037",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": 1696673628000,
            "no": 1241,
            "name": "电流B相26次谐波",
            "groupId": "0b4e1c9866f447bbb4367a83dc139d26",
            "id": "a8583c1e95314b168c3ecdcba016a514",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": 1696673628000,
            "no": 1242,
            "name": "电流B相27次谐波",
            "groupId": "0b4e1c9866f447bbb4367a83dc139d26",
            "id": "9ab82ffb5a7d4edb94b88d4d66233316",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": 1696673628000,
            "no": 1243,
            "name": "电流B相28次谐波",
            "groupId": "0b4e1c9866f447bbb4367a83dc139d26",
            "id": "1877ad36b3774b318710f7dd9e43ccfc",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": 1696673628000,
            "no": 1244,
            "name": "电流B相29次谐波",
            "groupId": "0b4e1c9866f447bbb4367a83dc139d26",
            "id": "adbed88f0ad64ca2abc10a9124a26140",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": 1696673628000,
            "no": 1245,
            "name": "电流B相30次谐波",
            "groupId": "0b4e1c9866f447bbb4367a83dc139d26",
            "id": "50e1e06854e64c3eb933b212429475df",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": 1696673628000,
            "no": 1246,
            "name": "电流B相31次谐波",
            "groupId": "0b4e1c9866f447bbb4367a83dc139d26",
            "id": "32617a22966c42b4bb5642a792b05861",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": 1696673628000,
            "no": 1247,
            "name": "电流B相32次谐波",
            "groupId": "0b4e1c9866f447bbb4367a83dc139d26",
            "id": "eda15290931f4c69a1cdcec694ce041a",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": 1696673628000,
            "no": 1248,
            "name": "电流B相33次谐波",
            "groupId": "0b4e1c9866f447bbb4367a83dc139d26",
            "id": "26de7b4e495c44e18583ab31b38305be",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": 1696673628000,
            "no": 1249,
            "name": "电流B相34次谐波",
            "groupId": "0b4e1c9866f447bbb4367a83dc139d26",
            "id": "cf83b84f0d384f5aac25849ef3233824",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": 1696673628000,
            "no": 1250,
            "name": "电流B相35次谐波",
            "groupId": "0b4e1c9866f447bbb4367a83dc139d26",
            "id": "bcdc7620fb2e47f0b698d5f84f1ce1cd",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": 1696673629000,
            "no": 1251,
            "name": "电流B相36次谐波",
            "groupId": "0b4e1c9866f447bbb4367a83dc139d26",
            "id": "f587215a2b574ea7b5e7eb85b527d172",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": 1696673629000,
            "no": 1252,
            "name": "电流B相37次谐波",
            "groupId": "0b4e1c9866f447bbb4367a83dc139d26",
            "id": "c44e941fa5424402b2bbb540581af8a6",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": 1696673629000,
            "no": 1253,
            "name": "电流B相38次谐波",
            "groupId": "0b4e1c9866f447bbb4367a83dc139d26",
            "id": "d7acb35c3fd3408786ab51609de2ad85",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": 1696673629000,
            "no": 1254,
            "name": "电流B相39次谐波",
            "groupId": "0b4e1c9866f447bbb4367a83dc139d26",
            "id": "96396dd3871948b5afe390ed61c5a4e0",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": 1696673629000,
            "no": 1255,
            "name": "电流B相40次谐波",
            "groupId": "0b4e1c9866f447bbb4367a83dc139d26",
            "id": "ba3ad7dd01984b6ab60237ba14040cf8",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": 1696673629000,
            "no": 1256,
            "name": "电流B相41次谐波",
            "groupId": "0b4e1c9866f447bbb4367a83dc139d26",
            "id": "fdb250ca61ec4550aa4e11eb5518d628",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": 1696673629000,
            "no": 1257,
            "name": "电流B相42次谐波",
            "groupId": "0b4e1c9866f447bbb4367a83dc139d26",
            "id": "f956ca2826fc4871a573864214ee9b96",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": 1696673629000,
            "no": 1258,
            "name": "电流B相43次谐波",
            "groupId": "0b4e1c9866f447bbb4367a83dc139d26",
            "id": "89ae7ffd68c74e80bd3305dfe9f33d15",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": 1696673629000,
            "no": 1259,
            "name": "电流B相44次谐波",
            "groupId": "0b4e1c9866f447bbb4367a83dc139d26",
            "id": "d6150fd5a15541afade3adb42c40a044",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": 1696673629000,
            "no": 1260,
            "name": "电流B相45次谐波",
            "groupId": "0b4e1c9866f447bbb4367a83dc139d26",
            "id": "13b2fcdeea764aca9ebe1cc2b4c8fc56",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": 1696673629000,
            "no": 1261,
            "name": "电流B相46次谐波",
            "groupId": "0b4e1c9866f447bbb4367a83dc139d26",
            "id": "56816849c5414ae390977eb2386967d1",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": 1696673629000,
            "no": 1262,
            "name": "电流B相47次谐波",
            "groupId": "0b4e1c9866f447bbb4367a83dc139d26",
            "id": "4aa885f39357455d8cc1b735b7793f78",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": 1696673629000,
            "no": 1263,
            "name": "电流B相48次谐波",
            "groupId": "0b4e1c9866f447bbb4367a83dc139d26",
            "id": "94fff7b064aa430cbcb3c6788d8f936f",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": 1696673629000,
            "no": 1264,
            "name": "电流B相49次谐波",
            "groupId": "0b4e1c9866f447bbb4367a83dc139d26",
            "id": "46fe8060e07a4a1494f8265a78de1fe9",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": 1696673629000,
            "no": 1265,
            "name": "电流B相50次谐波",
            "groupId": "0b4e1c9866f447bbb4367a83dc139d26",
            "id": "97c79c85e5ea44c090cd7271f93a52dc",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": 1696673677000,
            "no": 1266,
            "name": "电流C相2次谐波",
            "groupId": "4aa52b7fc17a461383880468cc46b4b4",
            "id": "ec5f5da9594b4098bcb44958dec8b691",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": 1696673677000,
            "no": 1267,
            "name": "电流C相3次谐波",
            "groupId": "4aa52b7fc17a461383880468cc46b4b4",
            "id": "013a8f82f47d4a9e8c35e1299f750c50",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": 1696673677000,
            "no": 1268,
            "name": "电流C相4次谐波",
            "groupId": "4aa52b7fc17a461383880468cc46b4b4",
            "id": "3fe050a7fadc487c9774f097ef8beba3",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": 1696673677000,
            "no": 1269,
            "name": "电流C相5次谐波",
            "groupId": "4aa52b7fc17a461383880468cc46b4b4",
            "id": "877c5339ab734dbb9a64f1a068681978",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": 1696673677000,
            "no": 1270,
            "name": "电流C相6次谐波",
            "groupId": "4aa52b7fc17a461383880468cc46b4b4",
            "id": "e9761cd48fbd45c6a448b09c4fb585d7",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": 1696673677000,
            "no": 1271,
            "name": "电流C相7次谐波",
            "groupId": "4aa52b7fc17a461383880468cc46b4b4",
            "id": "f76d0ceb793b4e3ba0a45a2aa53c01c5",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": 1696673677000,
            "no": 1272,
            "name": "电流C相8次谐波",
            "groupId": "4aa52b7fc17a461383880468cc46b4b4",
            "id": "f57bbb5383d546d6b31e5b2294adab9f",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": 1696673677000,
            "no": 1273,
            "name": "电流C相9次谐波",
            "groupId": "4aa52b7fc17a461383880468cc46b4b4",
            "id": "f244af782f5142c488aa5fd4aac31b30",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": 1696673677000,
            "no": 1274,
            "name": "电流C相10次谐波",
            "groupId": "4aa52b7fc17a461383880468cc46b4b4",
            "id": "94a3efef85d149be8e0480f5879912c6",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": 1696673677000,
            "no": 1275,
            "name": "电流C相11次谐波",
            "groupId": "4aa52b7fc17a461383880468cc46b4b4",
            "id": "b71bf594cfcd4f00909170c318b367e6",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": 1696673677000,
            "no": 1276,
            "name": "电流C相12次谐波",
            "groupId": "4aa52b7fc17a461383880468cc46b4b4",
            "id": "c28619aae33242d4b67f8add6db6643f",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": 1696673677000,
            "no": 1277,
            "name": "电流C相13次谐波",
            "groupId": "4aa52b7fc17a461383880468cc46b4b4",
            "id": "dfd7f444664a408697037407db92b48d",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": 1696673677000,
            "no": 1278,
            "name": "电流C相14次谐波",
            "groupId": "4aa52b7fc17a461383880468cc46b4b4",
            "id": "f5abc389ea7a4489a1225d1bf56c5b78",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": 1696673677000,
            "no": 1279,
            "name": "电流C相15次谐波",
            "groupId": "4aa52b7fc17a461383880468cc46b4b4",
            "id": "526ca5bcc7ef4a3089a7796a71a99985",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": 1696673678000,
            "no": 1280,
            "name": "电流C相16次谐波",
            "groupId": "4aa52b7fc17a461383880468cc46b4b4",
            "id": "d0c93771935c4303b69321cfd1d85fe8",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": 1696673678000,
            "no": 1281,
            "name": "电流C相17次谐波",
            "groupId": "4aa52b7fc17a461383880468cc46b4b4",
            "id": "6c6f01d9bb674e488dd5f13eb5149150",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": 1696673678000,
            "no": 1282,
            "name": "电流C相18次谐波",
            "groupId": "4aa52b7fc17a461383880468cc46b4b4",
            "id": "86d7b98d06e541dda45d78f27bec7910",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": 1696673678000,
            "no": 1283,
            "name": "电流C相19次谐波",
            "groupId": "4aa52b7fc17a461383880468cc46b4b4",
            "id": "2010ee41181649e7b2109da84622b697",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": 1696673678000,
            "no": 1284,
            "name": "电流C相20次谐波",
            "groupId": "4aa52b7fc17a461383880468cc46b4b4",
            "id": "10a24b2ee4994c3593a4c746d1b94f5f",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": 1696673678000,
            "no": 1285,
            "name": "电流C相21次谐波",
            "groupId": "4aa52b7fc17a461383880468cc46b4b4",
            "id": "74216c3d92ed44058504481dc2bd15ef",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": 1696673678000,
            "no": 1286,
            "name": "电流C相22次谐波",
            "groupId": "4aa52b7fc17a461383880468cc46b4b4",
            "id": "3148c7022eaf449ea847265f68da402c",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": 1696673678000,
            "no": 1287,
            "name": "电流C相23次谐波",
            "groupId": "4aa52b7fc17a461383880468cc46b4b4",
            "id": "8fa73d1fe80d4a3784f19bc4d2a6b1c7",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": 1696673678000,
            "no": 1288,
            "name": "电流C相24次谐波",
            "groupId": "4aa52b7fc17a461383880468cc46b4b4",
            "id": "b509a72b9ace460f8a6d65cd35c50365",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": 1696673678000,
            "no": 1289,
            "name": "电流C相25次谐波",
            "groupId": "4aa52b7fc17a461383880468cc46b4b4",
            "id": "bff0ea21e6184dfea9bffe7f7256fef4",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": 1696673678000,
            "no": 1290,
            "name": "电流C相26次谐波",
            "groupId": "4aa52b7fc17a461383880468cc46b4b4",
            "id": "f46b6302f2f443aca9450149ffd96495",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": 1696673678000,
            "no": 1291,
            "name": "电流C相27次谐波",
            "groupId": "4aa52b7fc17a461383880468cc46b4b4",
            "id": "b2e1744a6eda4341be367fe97b5ceeb3",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": 1696673678000,
            "no": 1292,
            "name": "电流C相28次谐波",
            "groupId": "4aa52b7fc17a461383880468cc46b4b4",
            "id": "1060a1c19085487f8572dfdef10ce675",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": 1696673678000,
            "no": 1293,
            "name": "电流C相29次谐波",
            "groupId": "4aa52b7fc17a461383880468cc46b4b4",
            "id": "ad8897900c8647b98a8724735ee1b736",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": 1696673678000,
            "no": 1294,
            "name": "电流C相30次谐波",
            "groupId": "4aa52b7fc17a461383880468cc46b4b4",
            "id": "cede99e3813d4de9b4412137e8d2dc42",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": 1696673678000,
            "no": 1295,
            "name": "电流C相31次谐波",
            "groupId": "4aa52b7fc17a461383880468cc46b4b4",
            "id": "e2030d4613234e388a5db7b9a0cd8afa",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": 1696673678000,
            "no": 1296,
            "name": "电流C相32次谐波",
            "groupId": "4aa52b7fc17a461383880468cc46b4b4",
            "id": "916c1686fd9d4ec99167d47723f4a343",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": 1696673678000,
            "no": 1297,
            "name": "电流C相33次谐波",
            "groupId": "4aa52b7fc17a461383880468cc46b4b4",
            "id": "fdc8076344674d9eb9ede7d1c3bc576b",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": 1696673679000,
            "no": 1298,
            "name": "电流C相34次谐波",
            "groupId": "4aa52b7fc17a461383880468cc46b4b4",
            "id": "f34e80e8680144919641e50114eca418",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": 1696673679000,
            "no": 1299,
            "name": "电流C相35次谐波",
            "groupId": "4aa52b7fc17a461383880468cc46b4b4",
            "id": "24ee13dd57a948da99207c8994d87e26",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": 1696673679000,
            "no": 1300,
            "name": "电流C相36次谐波",
            "groupId": "4aa52b7fc17a461383880468cc46b4b4",
            "id": "e9f9117e6e3e419cb1e0158c7a889273",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": 1696673679000,
            "no": 1301,
            "name": "电流C相37次谐波",
            "groupId": "4aa52b7fc17a461383880468cc46b4b4",
            "id": "bc8de19c719c4ef1a5ec2abaaed031e4",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": 1696673679000,
            "no": 1302,
            "name": "电流C相38次谐波",
            "groupId": "4aa52b7fc17a461383880468cc46b4b4",
            "id": "855c5fb93fff4f58916bf6c27ad9322b",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": 1696673679000,
            "no": 1303,
            "name": "电流C相39次谐波",
            "groupId": "4aa52b7fc17a461383880468cc46b4b4",
            "id": "9720c4e6e4c542ea8f41fa617338edba",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": 1696673679000,
            "no": 1304,
            "name": "电流C相40次谐波",
            "groupId": "4aa52b7fc17a461383880468cc46b4b4",
            "id": "d0b4f2f162134af69773b7f27073d0e2",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": 1696673679000,
            "no": 1305,
            "name": "电流C相41次谐波",
            "groupId": "4aa52b7fc17a461383880468cc46b4b4",
            "id": "293b36f000fe4f34b5b0433603e91e4d",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": 1696673679000,
            "no": 1306,
            "name": "电流C相42次谐波",
            "groupId": "4aa52b7fc17a461383880468cc46b4b4",
            "id": "e9d7cfd26409496d9159521aef919f3c",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": 1696673679000,
            "no": 1307,
            "name": "电流C相43次谐波",
            "groupId": "4aa52b7fc17a461383880468cc46b4b4",
            "id": "1a835def955344ed9b44b8656c09330f",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": 1696673679000,
            "no": 1308,
            "name": "电流C相44次谐波",
            "groupId": "4aa52b7fc17a461383880468cc46b4b4",
            "id": "1073f48298c3470ea105bbc802d75b4c",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": 1696673679000,
            "no": 1309,
            "name": "电流C相45次谐波",
            "groupId": "4aa52b7fc17a461383880468cc46b4b4",
            "id": "e996918ab43040bab9f8b6a2da44ca90",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": 1696673679000,
            "no": 1310,
            "name": "电流C相46次谐波",
            "groupId": "4aa52b7fc17a461383880468cc46b4b4",
            "id": "5613297d70164c86bca20af725d8dd9a",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": 1696673679000,
            "no": 1311,
            "name": "电流C相47次谐波",
            "groupId": "4aa52b7fc17a461383880468cc46b4b4",
            "id": "4852f7ede5a4465189b57ccaec81f0be",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": 1696673680000,
            "no": 1312,
            "name": "电流C相48次谐波",
            "groupId": "4aa52b7fc17a461383880468cc46b4b4",
            "id": "055b09bf6e564acebdf4d8461501a8be",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": 1696673680000,
            "no": 1313,
            "name": "电流C相49次谐波",
            "groupId": "4aa52b7fc17a461383880468cc46b4b4",
            "id": "ca9eccf214b449cf8cdc2ee4707f435c",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": 1696673680000,
            "no": 1314,
            "name": "电流C相50次谐波",
            "groupId": "4aa52b7fc17a461383880468cc46b4b4",
            "id": "20cd99c2157b4760bd372c4367e8876b",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          }
        ],
        tableDataCopy: [
          {
            "createTime": null,
            "no": 0,
            "name": "未定义",
            "groupId": "322b3084ed36478facef59016767d0cc",
            "id": "5FDFF98A-9C72-434C-B8BA-28340059BDA6",
            "energyType": null,
            "useDifference": null,
            "enable": 0,
            "entityName": "AppType"
          },
          {
            "createTime": null,
            "no": 1,
            "name": "A相电压",
            "groupId": "31ed13da-4c8d-4d80-8ada-a3713762a49d",
            "id": "F7C2BBAE-E12F-4AB3-957A-15EA261D6677",
            "energyType": null,
            "useDifference": null,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": null,
            "no": 2,
            "name": "B相电压",
            "groupId": "31ed13da-4c8d-4d80-8ada-a3713762a49d",
            "id": "2C488892-10FB-41B9-A170-31CA5563477D",
            "energyType": null,
            "useDifference": null,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": null,
            "no": 3,
            "name": "C相电压",
            "groupId": "31ed13da-4c8d-4d80-8ada-a3713762a49d",
            "id": "3C8785C3-15ED-444F-90EA-EAAFFC43C3AD",
            "energyType": null,
            "useDifference": null,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": null,
            "no": 4,
            "name": "三相平均电压",
            "groupId": "31ed13da-4c8d-4d80-8ada-a3713762a49d",
            "id": "386B4CAD-3C2B-493C-86E2-1A4A54BD90C1",
            "energyType": null,
            "useDifference": null,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": null,
            "no": 5,
            "name": "A相电流",
            "groupId": "aec119cd-245d-4432-b97d-1a11646377c0",
            "id": "C22E2981-3627-49EF-A93E-4A3AC1983994",
            "energyType": 0,
            "useDifference": 1,
            "enable": 0,
            "entityName": "AppType"
          },
          {
            "createTime": null,
            "no": 6,
            "name": "B相电流",
            "groupId": "aec119cd-245d-4432-b97d-1a11646377c0",
            "id": "6EC6E71D-3A7A-4C78-A044-6D8CF4B49ABA",
            "energyType": null,
            "useDifference": null,
            "enable": 0,
            "entityName": "AppType"
          },
          {
            "createTime": null,
            "no": 7,
            "name": "C相电流",
            "groupId": "aec119cd-245d-4432-b97d-1a11646377c0",
            "id": "412EAD66-2930-4AE8-BDAD-386D2B788A0F",
            "energyType": null,
            "useDifference": null,
            "enable": 0,
            "entityName": "AppType"
          },
          {
            "createTime": null,
            "no": 8,
            "name": "三相平均电流",
            "groupId": "aec119cd-245d-4432-b97d-1a11646377c0",
            "id": "32C1BB4E-0E09-4AF0-9D8A-2EA07D9BE786",
            "energyType": null,
            "useDifference": null,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": null,
            "no": 9,
            "name": "AB线电压",
            "groupId": "62aba95d8257461ebeeccc9a23527835",
            "id": "BBD32FC9-1981-4316-9621-FFFF2BBBD336",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": null,
            "no": 10,
            "name": "AC线电压",
            "groupId": "62aba95d8257461ebeeccc9a23527835",
            "id": "A153C0D0-687B-47D5-AB36-031747155BD8",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": null,
            "no": 11,
            "name": "BC线电压",
            "groupId": "62aba95d8257461ebeeccc9a23527835",
            "id": "5C380197-E8DA-429D-ACBE-A35C7ACE6E21",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": null,
            "no": 12,
            "name": "零序电压",
            "groupId": "5af3a0bd9ab44fcf8f5a8701f3e0fce7",
            "id": "6D068ED3-8DE6-4D6D-81B6-626AE19716C6",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": null,
            "no": 13,
            "name": "零序电流",
            "groupId": "6112b4ffa672403fa4fdfc740f0ff6b7",
            "id": "75B3D077-2210-4D85-9BD2-810C0ED82964",
            "energyType": 0,
            "useDifference": 0,
            "enable": 0,
            "entityName": "AppType"
          },
          {
            "createTime": null,
            "no": 14,
            "name": "正序电压",
            "groupId": "6ab82e01ce0245dcbd716c263203413a",
            "id": "44A9BBA3-CF1E-4803-98EE-F391597E5FC2",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": null,
            "no": 15,
            "name": "负序电压",
            "groupId": "99b9170fb1e14b368ab5472691036b8a",
            "id": "F925DFDB-D902-49AE-B326-AE84967391BF",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": null,
            "no": 16,
            "name": "正序电流",
            "groupId": "37e416b7505d483e83914de07891bf35",
            "id": "30F5C930-28CD-4A87-A1CC-4FA2CCCC26D9",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": null,
            "no": 17,
            "name": "负序电流",
            "groupId": "cd569d69dd734363824d699d36e8b5cd",
            "id": "FB6CCDA7-83AE-4721-8AA0-4521C56CFC43",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": null,
            "no": 18,
            "name": "频率",
            "groupId": "43e52f5c-cb53-49ed-a939-70305044eaa4",
            "id": "3E6FC81B-404A-4A82-8A65-B357C0CDB682",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": null,
            "no": 19,
            "name": "A相有功功率",
            "groupId": "cf19635a-e5b7-4aec-b0e3-b8acd85ba8ce",
            "id": "67DB5C00-79A2-4A6E-9C15-42CE6BE7A77B",
            "energyType": null,
            "useDifference": null,
            "enable": 0,
            "entityName": "AppType"
          },
          {
            "createTime": null,
            "no": 20,
            "name": "B相有功功率",
            "groupId": "cf19635a-e5b7-4aec-b0e3-b8acd85ba8ce",
            "id": "383C3657-D260-4A54-94E8-6C8998182118",
            "energyType": null,
            "useDifference": null,
            "enable": 0,
            "entityName": "AppType"
          },
          {
            "createTime": null,
            "no": 21,
            "name": "C相有功功率",
            "groupId": "cf19635a-e5b7-4aec-b0e3-b8acd85ba8ce",
            "id": "3349E75F-2BA1-4AA4-B67F-6761E78B986E",
            "energyType": null,
            "useDifference": null,
            "enable": 0,
            "entityName": "AppType"
          },
          {
            "createTime": null,
            "no": 22,
            "name": "A相无功功率",
            "groupId": "baf429044ce84086bea7cdaec8cbc819",
            "id": "728D59C6-8599-417C-AB52-CC633D591B61",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": null,
            "no": 23,
            "name": "B相无功功率",
            "groupId": "baf429044ce84086bea7cdaec8cbc819",
            "id": "AED6FB27-8382-4E84-A337-26148D5CC525",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": null,
            "no": 24,
            "name": "C相无功功率",
            "groupId": "baf429044ce84086bea7cdaec8cbc819",
            "id": "13F793E1-B98D-460A-9DB4-3CBD16C23369",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": null,
            "no": 25,
            "name": "A相视在功率",
            "groupId": "d9ea197686464ca792ecb41077fc1573",
            "id": "19D9A50B-9C4A-418F-A99B-C47DF14ACDD7",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": null,
            "no": 26,
            "name": "B相视在功率",
            "groupId": "d9ea197686464ca792ecb41077fc1573",
            "id": "E055CEB5-C0C4-4B0D-B1CA-1F02D48C0EF4",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": null,
            "no": 27,
            "name": "C相视在功率",
            "groupId": "d9ea197686464ca792ecb41077fc1573",
            "id": "E39392DC-4DC7-410C-A47D-203D7175A30C",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": null,
            "no": 28,
            "name": "A相功率因数",
            "groupId": "66bc34d4302f485b8a185cb1d4677592",
            "id": "29768F31-0BB4-49DE-AB01-4907B53F9A0B",
            "energyType": null,
            "useDifference": null,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": null,
            "no": 29,
            "name": "B相功率因数",
            "groupId": "66bc34d4302f485b8a185cb1d4677592",
            "id": "381F3606-26AC-4C78-8BDD-AE276C6A0ED8",
            "energyType": null,
            "useDifference": null,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": null,
            "no": 30,
            "name": "C相功率因数",
            "groupId": "66bc34d4302f485b8a185cb1d4677592",
            "id": "3B05C554-7C8D-4093-B56D-CF289166B7C6",
            "energyType": null,
            "useDifference": null,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": null,
            "no": 31,
            "name": "合相有功功率",
            "groupId": "cf19635a-e5b7-4aec-b0e3-b8acd85ba8ce",
            "id": "355F2620-E041-442C-80A5-EE5C1FFC576B",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": null,
            "no": 32,
            "name": "合相无功功率",
            "groupId": "baf429044ce84086bea7cdaec8cbc819",
            "id": "780B7997-FBFB-43F6-9611-17F4DDB4EE0F",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": null,
            "no": 33,
            "name": "合相视在功率",
            "groupId": "d9ea197686464ca792ecb41077fc1573",
            "id": "4C509362-2172-4C62-829E-071B6F8F4C96",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": null,
            "no": 34,
            "name": "合相功率因数",
            "groupId": "66bc34d4302f485b8a185cb1d4677592",
            "id": "F3F7C528-F229-4499-BE6B-9FC1A707BB2D",
            "energyType": null,
            "useDifference": null,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": null,
            "no": 36,
            "name": "总正向有功电量",
            "groupId": "d9624af6-c056-48d9-aedc-56c08a5d173d",
            "id": "C8A3319C-8300-46E4-A98F-A26C2A010CA2",
            "energyType": 1,
            "useDifference": 1,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": null,
            "no": 37,
            "name": "总反向有功电量",
            "groupId": "d9624af6-c056-48d9-aedc-56c08a5d173d",
            "id": "5266277E-6D00-43DF-AB0F-DA75834793B2",
            "energyType": null,
            "useDifference": null,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": null,
            "no": 38,
            "name": "总正向无功电量",
            "groupId": "fd01ac4c1fc74753b18591f038d765f4",
            "id": "B7B1E1AA-B53D-4C87-B5CB-8DCE7396D4C3",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": null,
            "no": 39,
            "name": "总反向无功电量",
            "groupId": "fd01ac4c1fc74753b18591f038d765f4",
            "id": "6DA62F12-0E90-4017-8B02-06F18BCC1A62",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": null,
            "no": 40,
            "name": "A相电流基波值",
            "groupId": "31264cc78cb24e2cbd96f877a3fc050f",
            "id": "2A150DC4-F0E1-4974-AE2C-C262052BCF41",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": null,
            "no": 41,
            "name": "A相电流2次谐波",
            "groupId": "c787166a171d4dd4bd0b8e42f7f8f822",
            "id": "BFC9CB5C-8383-410B-95A3-4DBD6F872CD4",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": null,
            "no": 42,
            "name": "A相电流3次谐波",
            "groupId": "31264cc78cb24e2cbd96f877a3fc050f",
            "id": "F0F0062E-15BC-4087-BC53-E2661272166C",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": null,
            "no": 43,
            "name": "A相电流4次谐波",
            "groupId": "c787166a171d4dd4bd0b8e42f7f8f822",
            "id": "C06B8CBB-A56F-432E-9082-B07E36A2F216",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": null,
            "no": 44,
            "name": "A相电流5次谐波",
            "groupId": "31264cc78cb24e2cbd96f877a3fc050f",
            "id": "5E848B76-30D2-47F7-B6C2-2D3CC62F6EDD",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": null,
            "no": 45,
            "name": "A相电流6次谐波",
            "groupId": "c787166a171d4dd4bd0b8e42f7f8f822",
            "id": "574DA37D-9D39-41EB-8656-741606C30DE1",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": null,
            "no": 46,
            "name": "A相电流7次谐波",
            "groupId": "31264cc78cb24e2cbd96f877a3fc050f",
            "id": "46449195-EB12-47BA-AF6E-DE3007997A96",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": null,
            "no": 47,
            "name": "A相电流8次谐波",
            "groupId": "c787166a171d4dd4bd0b8e42f7f8f822",
            "id": "6D8E1392-81CA-4D53-B35C-EA12A53B2A6E",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": null,
            "no": 48,
            "name": "A相电流9次谐波",
            "groupId": "31264cc78cb24e2cbd96f877a3fc050f",
            "id": "28C03C3A-D163-4F17-B186-7D86415BFF56",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": null,
            "no": 49,
            "name": "A相电流10次谐波",
            "groupId": "c787166a171d4dd4bd0b8e42f7f8f822",
            "id": "396F1C72-0CF8-43B4-858F-11787E20A013",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": null,
            "no": 50,
            "name": "A相电流11次谐波",
            "groupId": "31264cc78cb24e2cbd96f877a3fc050f",
            "id": "1F3C1F86-C10B-485E-BE88-A05D3258D54D",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": null,
            "no": 51,
            "name": "A相电流12次谐波",
            "groupId": "c787166a171d4dd4bd0b8e42f7f8f822",
            "id": "F5B1DEAB-E072-477E-87EC-371F781B60CC",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": null,
            "no": 52,
            "name": "A相电流13次谐波",
            "groupId": "31264cc78cb24e2cbd96f877a3fc050f",
            "id": "D9F8B440-7DDD-4844-8714-0EC994324792",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": null,
            "no": 53,
            "name": "A相电流14次谐波",
            "groupId": "c787166a171d4dd4bd0b8e42f7f8f822",
            "id": "BB1FA517-59D2-4DB1-9D60-CC485FEAB728",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": null,
            "no": 54,
            "name": "A相电流15次谐波",
            "groupId": "31264cc78cb24e2cbd96f877a3fc050f",
            "id": "E78FEBCE-B284-4B8E-B457-86FB3CB81D81",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": null,
            "no": 55,
            "name": "A相电流16次谐波",
            "groupId": "c787166a171d4dd4bd0b8e42f7f8f822",
            "id": "C9162212-489C-450A-BCFF-D767951DBBA8",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": null,
            "no": 56,
            "name": "A相电流17次谐波",
            "groupId": "31264cc78cb24e2cbd96f877a3fc050f",
            "id": "399CAF82-20D0-4C73-8C20-75101369FA59",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": null,
            "no": 57,
            "name": "A相电流18次谐波",
            "groupId": "c787166a171d4dd4bd0b8e42f7f8f822",
            "id": "19BE557B-56BB-4470-8F10-CE828445A05F",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": null,
            "no": 58,
            "name": "A相电流19次谐波",
            "groupId": "31264cc78cb24e2cbd96f877a3fc050f",
            "id": "A6CBF9CD-D283-4EB1-A01F-2D9C74D69092",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": null,
            "no": 59,
            "name": "A相电流20次谐波",
            "groupId": "c787166a171d4dd4bd0b8e42f7f8f822",
            "id": "739D3404-A170-4585-9FE7-F3EC4E4267A8",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": null,
            "no": 60,
            "name": "A相电流21次谐波",
            "groupId": "31264cc78cb24e2cbd96f877a3fc050f",
            "id": "45A4B667-AE6C-4185-BA9D-335D29FC2B4E",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": null,
            "no": 61,
            "name": "A相电流22次谐波",
            "groupId": "c787166a171d4dd4bd0b8e42f7f8f822",
            "id": "2E3E5DBC-E245-43AF-B423-B64CEA549462",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": null,
            "no": 62,
            "name": "A相电流23次谐波",
            "groupId": "31264cc78cb24e2cbd96f877a3fc050f",
            "id": "3EE7AD02-84FF-41D8-A410-5FC1B8F61BC9",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": null,
            "no": 63,
            "name": "A相电流24次谐波",
            "groupId": "c787166a171d4dd4bd0b8e42f7f8f822",
            "id": "0E4EDD96-584D-4950-BC31-5236BAAEE9FC",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": null,
            "no": 64,
            "name": "A相电流25次谐波",
            "groupId": "31264cc78cb24e2cbd96f877a3fc050f",
            "id": "5C7D4101-79AE-4D13-A705-3986F65D0550",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": null,
            "no": 65,
            "name": "A相电流26次谐波",
            "groupId": "c787166a171d4dd4bd0b8e42f7f8f822",
            "id": "B6B047CD-8D26-4F46-9931-99BBB47000C9",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": null,
            "no": 66,
            "name": "A相电流27次谐波",
            "groupId": "31264cc78cb24e2cbd96f877a3fc050f",
            "id": "D3D67BC5-4C44-4FC6-9BB9-D4C479B9B61B",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": null,
            "no": 67,
            "name": "A相电流28次谐波",
            "groupId": "c787166a171d4dd4bd0b8e42f7f8f822",
            "id": "3D2989E6-6111-41EE-901C-733CD83B0BA0",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": null,
            "no": 68,
            "name": "A相电流29次谐波",
            "groupId": "31264cc78cb24e2cbd96f877a3fc050f",
            "id": "A75EC29B-7126-4285-A2DB-E69B74256223",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": null,
            "no": 69,
            "name": "A相电流30次谐波",
            "groupId": "c787166a171d4dd4bd0b8e42f7f8f822",
            "id": "3D3DDA5E-6C54-4BFE-9056-1F501019978C",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": null,
            "no": 70,
            "name": "A相电流31次谐波",
            "groupId": "31264cc78cb24e2cbd96f877a3fc050f",
            "id": "F66AD7A8-98DF-4F87-A9FA-EFBEF1D7E27B",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": null,
            "no": 71,
            "name": "A相电流波形畸变率",
            "groupId": "5f0330d6ea404867b1277b701c103aa3",
            "id": "79B98E0C-25F7-4416-80DA-0BD9A83B0494",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": null,
            "no": 72,
            "name": "B相电流基波值",
            "groupId": "c268a034d37543899878a543c16319c3",
            "id": "EE0E549C-D613-44B0-A05C-913CFC40786E",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": null,
            "no": 73,
            "name": "B相电流2次谐波",
            "groupId": "7cb145e48bec44da9f8106e47a1f5bc7",
            "id": "9B76F69D-89A2-4E05-9949-D8A5E1A4B40E",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": null,
            "no": 74,
            "name": "B相电流3次谐波",
            "groupId": "c268a034d37543899878a543c16319c3",
            "id": "81D8AD49-55E7-43E6-8279-470A662A4A7F",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": null,
            "no": 75,
            "name": "B相电流4次谐波",
            "groupId": "7cb145e48bec44da9f8106e47a1f5bc7",
            "id": "B6B6CDF7-7ED3-47E2-84E1-8691749B4B8E",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": null,
            "no": 76,
            "name": "B相电流5次谐波",
            "groupId": "c268a034d37543899878a543c16319c3",
            "id": "2ECAD7C9-0BE5-452F-9BB7-FFCCE7EDBBC2",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": null,
            "no": 77,
            "name": "B相电流6次谐波",
            "groupId": "7cb145e48bec44da9f8106e47a1f5bc7",
            "id": "71936AE7-2BEC-46C2-8875-1FC0B8ABCEE1",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": null,
            "no": 78,
            "name": "B相电流7次谐波",
            "groupId": "c268a034d37543899878a543c16319c3",
            "id": "1454AADA-775E-4DF1-AB56-280D6B9AB29C",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": null,
            "no": 79,
            "name": "B相电流8次谐波",
            "groupId": "7cb145e48bec44da9f8106e47a1f5bc7",
            "id": "CD192A99-DC2F-48B9-A03D-7DCCA4BB5340",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": null,
            "no": 80,
            "name": "B相电流9次谐波",
            "groupId": "c268a034d37543899878a543c16319c3",
            "id": "3E9FABC9-7D61-41D3-B209-267DE4DDA49F",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": null,
            "no": 81,
            "name": "B相电流10次谐波",
            "groupId": "7cb145e48bec44da9f8106e47a1f5bc7",
            "id": "03EBC024-4FBB-4855-81E3-9D90747577A0",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": null,
            "no": 82,
            "name": "B相电流11次谐波",
            "groupId": "c268a034d37543899878a543c16319c3",
            "id": "2C8AF5F8-B512-47A9-A8E6-0C9D8732F1CB",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": null,
            "no": 83,
            "name": "B相电流12次谐波",
            "groupId": "7cb145e48bec44da9f8106e47a1f5bc7",
            "id": "860B6CC6-E928-40E7-89BD-E61F9390B33A",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": null,
            "no": 84,
            "name": "B相电流13次谐波",
            "groupId": "c268a034d37543899878a543c16319c3",
            "id": "2281CD03-C35F-4755-A4A3-0DFC199CB2CB",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": null,
            "no": 85,
            "name": "B相电流14次谐波",
            "groupId": "7cb145e48bec44da9f8106e47a1f5bc7",
            "id": "390289C6-CFB5-47CC-BCFE-6887D95017A6",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": null,
            "no": 86,
            "name": "B相电流15次谐波",
            "groupId": "c268a034d37543899878a543c16319c3",
            "id": "34DD35F5-81D1-4262-AE5E-93E0E30724ED",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": null,
            "no": 87,
            "name": "B相电流16次谐波",
            "groupId": "7cb145e48bec44da9f8106e47a1f5bc7",
            "id": "BF67491E-76BC-42EF-A335-839C635C0A64",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": null,
            "no": 88,
            "name": "B相电流17次谐波",
            "groupId": "c268a034d37543899878a543c16319c3",
            "id": "25E9F559-653E-4369-9A6E-7DBD22D485FC",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": null,
            "no": 89,
            "name": "B相电流18次谐波",
            "groupId": "7cb145e48bec44da9f8106e47a1f5bc7",
            "id": "CA301D00-E374-437F-BA94-7DE2AEF444A5",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": null,
            "no": 90,
            "name": "B相电流19次谐波",
            "groupId": "c268a034d37543899878a543c16319c3",
            "id": "87E64B61-7201-4C49-A772-CA17F682530C",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": null,
            "no": 91,
            "name": "B相电流20次谐波",
            "groupId": "7cb145e48bec44da9f8106e47a1f5bc7",
            "id": "CF9A85BC-BED4-4390-9321-5272D5EB0070",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": null,
            "no": 92,
            "name": "B相电流21次谐波",
            "groupId": "c268a034d37543899878a543c16319c3",
            "id": "A5C2645D-7C38-4D94-92C4-9940652B4266",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": null,
            "no": 93,
            "name": "B相电流22次谐波",
            "groupId": "7cb145e48bec44da9f8106e47a1f5bc7",
            "id": "67A37192-E75B-428C-8B97-6E2A2A4488C4",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": null,
            "no": 94,
            "name": "B相电流23次谐波",
            "groupId": "c268a034d37543899878a543c16319c3",
            "id": "876EA66B-12D6-434E-9F72-2C97A4ABF6BD",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": null,
            "no": 95,
            "name": "B相电流24次谐波",
            "groupId": "7cb145e48bec44da9f8106e47a1f5bc7",
            "id": "1192F7F1-EEE4-40A7-8E24-26978FC73F2F",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": null,
            "no": 96,
            "name": "B相电流25次谐波",
            "groupId": "c268a034d37543899878a543c16319c3",
            "id": "27C855E9-A29A-428A-9FEA-95E05CF07E0B",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": null,
            "no": 97,
            "name": "B相电流26次谐波",
            "groupId": "7cb145e48bec44da9f8106e47a1f5bc7",
            "id": "E2A39B29-D6E0-4881-8934-8C9E6E3A84E4",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": null,
            "no": 98,
            "name": "B相电流27次谐波",
            "groupId": "c268a034d37543899878a543c16319c3",
            "id": "8AD9FD51-B703-4203-880F-668D48FB9A29",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": null,
            "no": 99,
            "name": "B相电流28次谐波",
            "groupId": "7cb145e48bec44da9f8106e47a1f5bc7",
            "id": "C80318AF-2356-454F-A194-16E44430BBE1",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": null,
            "no": 100,
            "name": "B相电流29次谐波",
            "groupId": "c268a034d37543899878a543c16319c3",
            "id": "679333FF-E14A-4060-A00C-E2D83229BD2D",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": null,
            "no": 101,
            "name": "B相电流30次谐波",
            "groupId": "7cb145e48bec44da9f8106e47a1f5bc7",
            "id": "360C60B2-0BCC-4726-A6B7-4B20CB1CFE1A",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": null,
            "no": 102,
            "name": "B相电流31次谐波",
            "groupId": "c268a034d37543899878a543c16319c3",
            "id": "EF229CBF-E57B-4395-847B-EF4D32AE7E70",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": null,
            "no": 103,
            "name": "B相电流波形畸变率",
            "groupId": "5f0330d6ea404867b1277b701c103aa3",
            "id": "29739C25-F91C-4AD4-B870-7D2A1175B257",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": null,
            "no": 104,
            "name": "C相电流基波值",
            "groupId": "c268a034d37543899878a543c16319c3",
            "id": "12874DF0-2EB4-4A6C-A575-C11F07179EE6",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": null,
            "no": 105,
            "name": "C相电流2次谐波",
            "groupId": "5aeb354075454843bc6507f31744627e",
            "id": "832086F8-1047-4672-BE9F-07BC8BD48535",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": null,
            "no": 106,
            "name": "C相电流3次谐波",
            "groupId": "8d878a039a354c2cacd5aaea86c04f04",
            "id": "2DC81525-F5FD-4091-A9EA-EE217C298DF3",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": null,
            "no": 107,
            "name": "C相电流4次谐波",
            "groupId": "5aeb354075454843bc6507f31744627e",
            "id": "EED7E413-F969-493A-8FAE-9FBB5796F887",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": null,
            "no": 108,
            "name": "C相电流5次谐波",
            "groupId": "8d878a039a354c2cacd5aaea86c04f04",
            "id": "0625AF02-A78D-41E9-AA42-3B47987B6D32",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": null,
            "no": 109,
            "name": "C相电流6次谐波",
            "groupId": "5aeb354075454843bc6507f31744627e",
            "id": "BF1BF732-6887-477E-9C85-5110ADA02076",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": null,
            "no": 110,
            "name": "C相电流7次谐波",
            "groupId": "8d878a039a354c2cacd5aaea86c04f04",
            "id": "245716E2-8E19-4D62-96C9-F6E1A082DA13",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": null,
            "no": 111,
            "name": "C相电流8次谐波",
            "groupId": "5aeb354075454843bc6507f31744627e",
            "id": "FB68DEDA-AFBF-4089-B248-8E670D56EDDE",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": null,
            "no": 112,
            "name": "C相电流9次谐波",
            "groupId": "8d878a039a354c2cacd5aaea86c04f04",
            "id": "B6CE4BA1-2A52-4E9C-9851-F3E7ABCD24C0",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": null,
            "no": 113,
            "name": "C相电流10次谐波",
            "groupId": "5aeb354075454843bc6507f31744627e",
            "id": "CAB1E36B-17B4-4390-8899-3C662825EF45",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": null,
            "no": 114,
            "name": "C相电流11次谐波",
            "groupId": "8d878a039a354c2cacd5aaea86c04f04",
            "id": "630336E2-5F67-4F70-87E3-6B3ED030944F",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": null,
            "no": 115,
            "name": "C相电流12次谐波",
            "groupId": "5aeb354075454843bc6507f31744627e",
            "id": "04C3FEC4-46D9-4D28-AD38-640048F479A1",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": null,
            "no": 116,
            "name": "C相电流13次谐波",
            "groupId": "8d878a039a354c2cacd5aaea86c04f04",
            "id": "D40920CF-6DE0-4269-AA13-E2CB206AC748",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": null,
            "no": 117,
            "name": "C相电流14次谐波",
            "groupId": "5aeb354075454843bc6507f31744627e",
            "id": "5EC1FFBD-DE4E-43F5-989A-1B729BD939EA",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": null,
            "no": 118,
            "name": "C相电流15次谐波",
            "groupId": "8d878a039a354c2cacd5aaea86c04f04",
            "id": "B1E8AB15-0272-44AB-8652-9EB933E92D45",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": null,
            "no": 119,
            "name": "C相电流16次谐波",
            "groupId": "5aeb354075454843bc6507f31744627e",
            "id": "2DF9B8BF-5BEA-4952-A3FF-2CC9A2F105D5",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": null,
            "no": 120,
            "name": "C相电流17次谐波",
            "groupId": "8d878a039a354c2cacd5aaea86c04f04",
            "id": "46111965-24D3-4607-8D83-E29661C9DFB0",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": null,
            "no": 121,
            "name": "C相电流18次谐波",
            "groupId": "5aeb354075454843bc6507f31744627e",
            "id": "3524A75D-5A79-4A4A-A5DB-DCD5DA95E361",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": null,
            "no": 122,
            "name": "C相电流19次谐波",
            "groupId": "8d878a039a354c2cacd5aaea86c04f04",
            "id": "C6728AAE-FBE7-4C3C-A5F6-1EF59BE8EF8E",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": null,
            "no": 123,
            "name": "C相电流20次谐波",
            "groupId": "5aeb354075454843bc6507f31744627e",
            "id": "E75E6ABE-EA17-48B6-AEE0-DBFEC666D242",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": null,
            "no": 124,
            "name": "C相电流21次谐波",
            "groupId": "8d878a039a354c2cacd5aaea86c04f04",
            "id": "85129551-3F05-45E0-8FB1-BD3725AD86D1",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": null,
            "no": 125,
            "name": "C相电流22次谐波",
            "groupId": "5aeb354075454843bc6507f31744627e",
            "id": "8404F2D0-F98C-46A1-A1B9-8A54912D2634",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": null,
            "no": 126,
            "name": "C相电流23次谐波",
            "groupId": "8d878a039a354c2cacd5aaea86c04f04",
            "id": "4DE4F408-FEB6-4BB9-A825-AC407FB83363",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": null,
            "no": 127,
            "name": "C相电流24次谐波",
            "groupId": "5aeb354075454843bc6507f31744627e",
            "id": "280DD5B9-5537-4CD6-BA01-288D8B5CA806",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": null,
            "no": 128,
            "name": "C相电流25次谐波",
            "groupId": "8d878a039a354c2cacd5aaea86c04f04",
            "id": "F226D496-9810-4E89-AF9A-6B884A2FC8A2",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": null,
            "no": 129,
            "name": "C相电流26次谐波",
            "groupId": "5aeb354075454843bc6507f31744627e",
            "id": "8487E092-3AC1-42B9-BE56-3C2C2660416F",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": null,
            "no": 130,
            "name": "C相电流27次谐波",
            "groupId": "8d878a039a354c2cacd5aaea86c04f04",
            "id": "E02C4C1E-C8CA-4C0E-802A-B3CB847A92ED",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": null,
            "no": 131,
            "name": "C相电流28次谐波",
            "groupId": "5aeb354075454843bc6507f31744627e",
            "id": "47BB5055-C2D3-457D-9CB3-C9D8113C675B",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": null,
            "no": 132,
            "name": "C相电流29次谐波",
            "groupId": "8d878a039a354c2cacd5aaea86c04f04",
            "id": "607C55D4-BE0A-4438-8A4E-11BA60558694",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": null,
            "no": 133,
            "name": "C相电流30次谐波",
            "groupId": "5aeb354075454843bc6507f31744627e",
            "id": "ECE410C3-6FFC-4475-8217-5C48833E0597",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": null,
            "no": 134,
            "name": "C相电流31次谐波",
            "groupId": "8d878a039a354c2cacd5aaea86c04f04",
            "id": "CF44B365-A6F1-4DAB-B4E9-90A4B4FA03F5",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": null,
            "no": 135,
            "name": "C相电流波形畸变率",
            "groupId": "5f0330d6ea404867b1277b701c103aa3",
            "id": "3D0BA9E5-86CB-47E3-A490-814A7FE40512",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": null,
            "no": 136,
            "name": "A相电压基波值",
            "groupId": "7d71e18ff67b4ef08f351755b49fa7e9",
            "id": "B1C0F7B9-7CD3-4D20-BC97-8927F8C0A064",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": null,
            "no": 137,
            "name": "A相电压2次谐波",
            "groupId": "a45c4b96899448d6bdd4300c019f048e",
            "id": "1325B1E8-83D8-4AB6-908A-436A523C3423",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": null,
            "no": 138,
            "name": "A相电压3次谐波",
            "groupId": "7d71e18ff67b4ef08f351755b49fa7e9",
            "id": "77565D60-C8F3-4630-98B3-80BF6DFC659C",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": null,
            "no": 139,
            "name": "A相电压4次谐波",
            "groupId": "a45c4b96899448d6bdd4300c019f048e",
            "id": "D19B9C71-3F62-4194-A9E3-5CA8BF382349",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": null,
            "no": 140,
            "name": "A相电压5次谐波",
            "groupId": "7d71e18ff67b4ef08f351755b49fa7e9",
            "id": "10A8B52C-B513-4568-9129-61DF91534BBD",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": null,
            "no": 141,
            "name": "A相电压6次谐波",
            "groupId": "a45c4b96899448d6bdd4300c019f048e",
            "id": "35421B09-1F5E-4EE3-BA95-13A445C8148C",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": null,
            "no": 142,
            "name": "A相电压7次谐波",
            "groupId": "7d71e18ff67b4ef08f351755b49fa7e9",
            "id": "FBFD5581-F8A6-4211-B249-FD19E1CFA544",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": null,
            "no": 143,
            "name": "A相电压8次谐波",
            "groupId": "a45c4b96899448d6bdd4300c019f048e",
            "id": "7C16DB9B-D0AA-4895-88D8-50B4C0AD5B9B",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": null,
            "no": 144,
            "name": "A相电压9次谐波",
            "groupId": "7d71e18ff67b4ef08f351755b49fa7e9",
            "id": "2DAFD2BA-7335-4B87-8E98-D9777AC32886",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": null,
            "no": 145,
            "name": "A相电压10次谐波",
            "groupId": "a45c4b96899448d6bdd4300c019f048e",
            "id": "A758734F-BA8D-444D-B272-2DAD2287D9B1",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": null,
            "no": 146,
            "name": "A相电压11次谐波",
            "groupId": "7d71e18ff67b4ef08f351755b49fa7e9",
            "id": "4ED8C1B3-CD1B-4ED5-8063-EA8040B01333",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": null,
            "no": 147,
            "name": "A相电压12次谐波",
            "groupId": "a45c4b96899448d6bdd4300c019f048e",
            "id": "926D0556-5A7D-43B0-BFCB-4333E4EBF52D",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": null,
            "no": 148,
            "name": "A相电压13次谐波",
            "groupId": "7d71e18ff67b4ef08f351755b49fa7e9",
            "id": "72929AC1-A9C4-49B6-9C8D-B487195C5898",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": null,
            "no": 149,
            "name": "A相电压14次谐波",
            "groupId": "a45c4b96899448d6bdd4300c019f048e",
            "id": "F7E40FC5-4215-4A98-8F2B-9E01381D8AF4",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": null,
            "no": 150,
            "name": "A相电压15次谐波",
            "groupId": "7d71e18ff67b4ef08f351755b49fa7e9",
            "id": "75DC0218-1B6D-4C06-930B-E46790666711",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": null,
            "no": 151,
            "name": "A相电压16次谐波",
            "groupId": "a45c4b96899448d6bdd4300c019f048e",
            "id": "B25E8EA9-EA76-4FD3-A355-8592632C4BB6",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": null,
            "no": 152,
            "name": "A相电压17次谐波",
            "groupId": "7d71e18ff67b4ef08f351755b49fa7e9",
            "id": "B24AFF04-6E22-4651-9E51-E8E32CE9D1C2",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": null,
            "no": 153,
            "name": "A相电压18次谐波",
            "groupId": "a45c4b96899448d6bdd4300c019f048e",
            "id": "9CEA6804-CCDE-4C31-9825-07CB78B0C1B9",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": null,
            "no": 154,
            "name": "A相电压19次谐波",
            "groupId": "7d71e18ff67b4ef08f351755b49fa7e9",
            "id": "BBBB57CF-3975-4AD3-BE92-30A202F223A1",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": null,
            "no": 155,
            "name": "A相电压20次谐波",
            "groupId": "a45c4b96899448d6bdd4300c019f048e",
            "id": "263DE370-EC43-48C1-ADAA-07764CBADE1D",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": null,
            "no": 156,
            "name": "A相电压21次谐波",
            "groupId": "7d71e18ff67b4ef08f351755b49fa7e9",
            "id": "8DA6150A-0CBF-4769-9666-328C2D97AB03",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": null,
            "no": 157,
            "name": "A相电压22次谐波",
            "groupId": "a45c4b96899448d6bdd4300c019f048e",
            "id": "4D31400D-B1DC-4392-9D94-EBE8D7659DFC",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": null,
            "no": 158,
            "name": "A相电压23次谐波",
            "groupId": "7d71e18ff67b4ef08f351755b49fa7e9",
            "id": "783F5D5C-4F32-4E8F-88BC-446E84878E51",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": null,
            "no": 159,
            "name": "A相电压24次谐波",
            "groupId": "a45c4b96899448d6bdd4300c019f048e",
            "id": "9E278016-1EE1-41D4-A325-88F27702AFD2",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": null,
            "no": 160,
            "name": "A相电压25次谐波",
            "groupId": "7d71e18ff67b4ef08f351755b49fa7e9",
            "id": "9D70652C-B4E0-4BF0-A35F-CBAE065B7F99",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": null,
            "no": 161,
            "name": "A相电压26次谐波",
            "groupId": "a45c4b96899448d6bdd4300c019f048e",
            "id": "583A1726-A36C-4808-9B9D-7DAE4DFFBA7A",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": null,
            "no": 162,
            "name": "A相电压27次谐波",
            "groupId": "7d71e18ff67b4ef08f351755b49fa7e9",
            "id": "12BDACCD-C6CB-4A66-BD81-347240699DF5",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": null,
            "no": 163,
            "name": "A相电压28次谐波",
            "groupId": "a45c4b96899448d6bdd4300c019f048e",
            "id": "44B47459-DA72-4DC6-BB66-CB9BF5D55D94",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": null,
            "no": 164,
            "name": "A相电压29次谐波",
            "groupId": "7d71e18ff67b4ef08f351755b49fa7e9",
            "id": "1535A86E-F7E9-4C22-BD84-2637AABBE9DD",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": null,
            "no": 165,
            "name": "A相电压30次谐波",
            "groupId": "a45c4b96899448d6bdd4300c019f048e",
            "id": "03C5D98C-0B4C-418A-A157-826915DB4B37",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": null,
            "no": 166,
            "name": "A相电压31次谐波",
            "groupId": "7d71e18ff67b4ef08f351755b49fa7e9",
            "id": "9979FF1A-B936-430D-900E-F8503B5F460C",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": null,
            "no": 167,
            "name": "A相电压波形畸变率",
            "groupId": "4f1506f4-3aba-4bdd-a631-8cd194bc5773",
            "id": "3C77B24B-A45C-4832-8A2D-B8E856280899",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": null,
            "no": 168,
            "name": "B相电压基波值",
            "groupId": "db8a02ae83054dc1ba4a60f51c8a2338",
            "id": "9BB01612-8E17-44D6-83C1-D0CFA8CB40A3",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": null,
            "no": 169,
            "name": "B相电压2次谐波",
            "groupId": "51ed3b95f4734825acfe55cf80a28256",
            "id": "E9ECF0A6-3B94-4B2A-99FE-58C3A6710CE3",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": null,
            "no": 170,
            "name": "B相电压3次谐波",
            "groupId": "db8a02ae83054dc1ba4a60f51c8a2338",
            "id": "596989FB-1209-4282-8ACE-DBC7C3E40A1D",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": null,
            "no": 171,
            "name": "B相电压4次谐波",
            "groupId": "51ed3b95f4734825acfe55cf80a28256",
            "id": "BF344899-04FA-4FFD-9193-8E2D345F8A0B",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": null,
            "no": 172,
            "name": "B相电压5次谐波",
            "groupId": "db8a02ae83054dc1ba4a60f51c8a2338",
            "id": "AA2182DE-7B51-43E9-9B5E-100E38972A60",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": null,
            "no": 173,
            "name": "B相电压6次谐波",
            "groupId": "51ed3b95f4734825acfe55cf80a28256",
            "id": "C02F0FB1-26D6-4E9E-A98B-1A91D9EF879D",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": null,
            "no": 174,
            "name": "B相电压7次谐波",
            "groupId": "db8a02ae83054dc1ba4a60f51c8a2338",
            "id": "7769DA15-4961-4F26-B47B-C80494467A1D",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": null,
            "no": 175,
            "name": "B相电压8次谐波",
            "groupId": "51ed3b95f4734825acfe55cf80a28256",
            "id": "307A0DB0-9BD5-4531-936A-768A62CB0A15",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": null,
            "no": 176,
            "name": "B相电压9次谐波",
            "groupId": "db8a02ae83054dc1ba4a60f51c8a2338",
            "id": "90F4B02E-D41F-4852-B73A-021FEB35C6BF",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": null,
            "no": 177,
            "name": "B相电压10次谐波",
            "groupId": "51ed3b95f4734825acfe55cf80a28256",
            "id": "4370AEAA-D4DA-497B-B26D-19A24A703D21",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": null,
            "no": 178,
            "name": "B相电压11次谐波",
            "groupId": "db8a02ae83054dc1ba4a60f51c8a2338",
            "id": "F93F27DC-2F32-4D7D-ABD8-E1B2D6230557",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": null,
            "no": 179,
            "name": "B相电压12次谐波",
            "groupId": "51ed3b95f4734825acfe55cf80a28256",
            "id": "D506EB27-5A7E-4EC7-9868-FE8137E218BF",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": null,
            "no": 180,
            "name": "B相电压13次谐波",
            "groupId": "db8a02ae83054dc1ba4a60f51c8a2338",
            "id": "8620F344-77FC-4580-9581-E01972B31619",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": null,
            "no": 181,
            "name": "B相电压14次谐波",
            "groupId": "51ed3b95f4734825acfe55cf80a28256",
            "id": "E1887C17-74CC-416E-A371-52C58C4B350B",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": null,
            "no": 182,
            "name": "B相电压15次谐波",
            "groupId": "db8a02ae83054dc1ba4a60f51c8a2338",
            "id": "F48E8F55-4DD0-46DB-BC31-84D8FD314892",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": null,
            "no": 183,
            "name": "B相电压16次谐波",
            "groupId": "51ed3b95f4734825acfe55cf80a28256",
            "id": "297B5E17-9813-4FF2-81B8-23423D23C4FF",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": null,
            "no": 184,
            "name": "B相电压17次谐波",
            "groupId": "db8a02ae83054dc1ba4a60f51c8a2338",
            "id": "0EE11951-5E21-44DC-A513-D575D3D9288D",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": null,
            "no": 185,
            "name": "B相电压18次谐波",
            "groupId": "51ed3b95f4734825acfe55cf80a28256",
            "id": "B837337A-C7C9-4715-A2ED-B31FC2A4B628",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": null,
            "no": 186,
            "name": "B相电压19次谐波",
            "groupId": "db8a02ae83054dc1ba4a60f51c8a2338",
            "id": "8B2E5C73-120E-4B55-ACAF-F2C2BB73E80E",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": null,
            "no": 187,
            "name": "B相电压20次谐波",
            "groupId": "51ed3b95f4734825acfe55cf80a28256",
            "id": "D8C6FD11-63B9-42F1-9370-C2B451EC135F",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": null,
            "no": 188,
            "name": "B相电压21次谐波",
            "groupId": "db8a02ae83054dc1ba4a60f51c8a2338",
            "id": "BE9DBC89-2B09-4F3C-9A1E-D5458EDA15A8",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": null,
            "no": 189,
            "name": "B相电压22次谐波",
            "groupId": "51ed3b95f4734825acfe55cf80a28256",
            "id": "754CBBEE-8218-440D-8348-BAF8195B6AD1",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": null,
            "no": 190,
            "name": "B相电压23次谐波",
            "groupId": "db8a02ae83054dc1ba4a60f51c8a2338",
            "id": "235B4D1A-E5A0-45C8-A7BC-4F10981D8220",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": null,
            "no": 191,
            "name": "B相电压24次谐波",
            "groupId": "51ed3b95f4734825acfe55cf80a28256",
            "id": "909F751F-1CEB-4570-B7B4-FEE2F24E3451",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": null,
            "no": 192,
            "name": "B相电压25次谐波",
            "groupId": "db8a02ae83054dc1ba4a60f51c8a2338",
            "id": "6E25F9D8-0DA0-44EC-BDAD-85A29DF01DEC",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": null,
            "no": 193,
            "name": "B相电压26次谐波",
            "groupId": "51ed3b95f4734825acfe55cf80a28256",
            "id": "A932105F-48B8-4B0B-81B8-08A3026EA76E",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": null,
            "no": 194,
            "name": "B相电压27次谐波",
            "groupId": "db8a02ae83054dc1ba4a60f51c8a2338",
            "id": "94FA29A7-4765-4F3F-9753-67493BC817B5",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": null,
            "no": 195,
            "name": "B相电压28次谐波",
            "groupId": "51ed3b95f4734825acfe55cf80a28256",
            "id": "EABD3D1D-67D6-49F4-827B-9FFC1B82E7E7",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": null,
            "no": 196,
            "name": "B相电压29次谐波",
            "groupId": "db8a02ae83054dc1ba4a60f51c8a2338",
            "id": "4ADD8FED-61A3-4169-BCAA-93550460F573",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": null,
            "no": 197,
            "name": "B相电压30次谐波",
            "groupId": "51ed3b95f4734825acfe55cf80a28256",
            "id": "9B816D16-9D41-4D78-8142-58200C5356D0",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": null,
            "no": 198,
            "name": "B相电压31次谐波",
            "groupId": "db8a02ae83054dc1ba4a60f51c8a2338",
            "id": "5748E294-E12E-4E33-B5BE-AB3F68793A65",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": null,
            "no": 199,
            "name": "B相电压波形畸变率",
            "groupId": "4f1506f4-3aba-4bdd-a631-8cd194bc5773",
            "id": "97CC2370-E59D-4515-8B7B-72F6992B15AB",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": null,
            "no": 200,
            "name": "C相电压基波值",
            "groupId": "9b1f5445f7f54702899327d31b3ca00d",
            "id": "4E51E6A0-DBC0-4104-A6EC-AD8284A27BD3",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": null,
            "no": 201,
            "name": "C相电压2次谐波",
            "groupId": "43dda3a9f9e34bc0a45b434263862565",
            "id": "73E20B81-FEAA-4130-87BD-1EE5687DBE01",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": null,
            "no": 202,
            "name": "C相电压3次谐波",
            "groupId": "9b1f5445f7f54702899327d31b3ca00d",
            "id": "C6E0F8B7-768F-46EC-B146-E152D8B24D1B",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": null,
            "no": 203,
            "name": "C相电压4次谐波",
            "groupId": "43dda3a9f9e34bc0a45b434263862565",
            "id": "0E176DA7-E1B2-45EE-BAD8-EC66168A7E6A",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": null,
            "no": 204,
            "name": "C相电压5次谐波",
            "groupId": "9b1f5445f7f54702899327d31b3ca00d",
            "id": "AB9DF1C6-F354-4DCD-9F6D-E3B8DB91DDB2",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": null,
            "no": 205,
            "name": "C相电压6次谐波",
            "groupId": "43dda3a9f9e34bc0a45b434263862565",
            "id": "861E035E-E757-49B2-9AC1-BE0D2A60DDD0",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": null,
            "no": 206,
            "name": "C相电压7次谐波",
            "groupId": "9b1f5445f7f54702899327d31b3ca00d",
            "id": "A8683CE3-F04F-4FC6-896E-AD39DC91A3EB",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": null,
            "no": 207,
            "name": "C相电压8次谐波",
            "groupId": "43dda3a9f9e34bc0a45b434263862565",
            "id": "2DE3809D-BEC9-4898-8E46-05FAAA60E3FB",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": null,
            "no": 208,
            "name": "C相电压9次谐波",
            "groupId": "9b1f5445f7f54702899327d31b3ca00d",
            "id": "F70786A9-B173-4C7E-AF31-67D67A75FB37",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": null,
            "no": 209,
            "name": "C相电压10次谐波",
            "groupId": "43dda3a9f9e34bc0a45b434263862565",
            "id": "54A1B01B-2023-4535-9D17-9FD04AE99104",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": null,
            "no": 210,
            "name": "C相电压11次谐波",
            "groupId": "9b1f5445f7f54702899327d31b3ca00d",
            "id": "C7F413B2-5BD9-46E2-B618-2456BB0E2962",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": null,
            "no": 211,
            "name": "C相电压12次谐波",
            "groupId": "43dda3a9f9e34bc0a45b434263862565",
            "id": "BE811E84-59DF-4C73-BD51-7B104112A790",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": null,
            "no": 212,
            "name": "C相电压13次谐波",
            "groupId": "9b1f5445f7f54702899327d31b3ca00d",
            "id": "2C6F5A07-063C-4BC4-BC9D-A006FBBC1BF7",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": null,
            "no": 213,
            "name": "C相电压14次谐波",
            "groupId": "43dda3a9f9e34bc0a45b434263862565",
            "id": "1AD588B5-3A94-493F-872B-F8B661A57CA0",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": null,
            "no": 214,
            "name": "C相电压15次谐波",
            "groupId": "9b1f5445f7f54702899327d31b3ca00d",
            "id": "134203DB-9E65-45CD-871D-171DC7D3AFE6",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": null,
            "no": 215,
            "name": "C相电压16次谐波",
            "groupId": "43dda3a9f9e34bc0a45b434263862565",
            "id": "672897AF-6C67-4B98-A349-F6E8BF9E93D2",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": null,
            "no": 216,
            "name": "C相电压17次谐波",
            "groupId": "9b1f5445f7f54702899327d31b3ca00d",
            "id": "7FC1F5D5-08DD-4A4C-992A-1207982E97A2",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": null,
            "no": 217,
            "name": "C相电压18次谐波",
            "groupId": "43dda3a9f9e34bc0a45b434263862565",
            "id": "C32771DC-6782-4DC3-A3A1-EC53CD82AEB5",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": null,
            "no": 218,
            "name": "C相电压19次谐波",
            "groupId": "9b1f5445f7f54702899327d31b3ca00d",
            "id": "A7F6E81E-24D4-44AC-889A-9BA963B25C2C",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": null,
            "no": 219,
            "name": "C相电压20次谐波",
            "groupId": "43dda3a9f9e34bc0a45b434263862565",
            "id": "C6D1DCFC-4D5D-48D6-843A-DF71640790DA",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": null,
            "no": 220,
            "name": "C相电压21次谐波",
            "groupId": "9b1f5445f7f54702899327d31b3ca00d",
            "id": "817DE272-E885-4109-A961-8037537B73C7",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": null,
            "no": 221,
            "name": "C相电压22次谐波",
            "groupId": "43dda3a9f9e34bc0a45b434263862565",
            "id": "2D786796-1B12-436D-9B31-99A6400B3337",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": null,
            "no": 222,
            "name": "C相电压23次谐波",
            "groupId": "9b1f5445f7f54702899327d31b3ca00d",
            "id": "28A5030F-BE0B-4586-B60F-80E3099C48EE",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": null,
            "no": 223,
            "name": "C相电压24次谐波",
            "groupId": "43dda3a9f9e34bc0a45b434263862565",
            "id": "B20031FC-3765-430F-A480-43A8D92D062F",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": null,
            "no": 224,
            "name": "C相电压25次谐波",
            "groupId": "9b1f5445f7f54702899327d31b3ca00d",
            "id": "F5510591-E29D-42A2-8CFD-88889FF1156D",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": null,
            "no": 225,
            "name": "C相电压26次谐波",
            "groupId": "43dda3a9f9e34bc0a45b434263862565",
            "id": "0E79AD82-D9D5-465A-9863-6D8EF05A02D4",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": null,
            "no": 226,
            "name": "C相电压27次谐波",
            "groupId": "9b1f5445f7f54702899327d31b3ca00d",
            "id": "A526D749-AAE5-4FB4-A1CE-7EC10FBFB01E",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": null,
            "no": 227,
            "name": "C相电压28次谐波",
            "groupId": "43dda3a9f9e34bc0a45b434263862565",
            "id": "C12A5791-1B40-42D7-A9AC-1073D66E2AF6",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": null,
            "no": 228,
            "name": "C相电压29次谐波",
            "groupId": "9b1f5445f7f54702899327d31b3ca00d",
            "id": "CE714C69-47CF-48E2-9F80-619A2C5A597E",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": null,
            "no": 229,
            "name": "C相电压30次谐波",
            "groupId": "43dda3a9f9e34bc0a45b434263862565",
            "id": "1DFE7BCE-F660-41BB-9150-C8ECB5B54412",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": null,
            "no": 230,
            "name": "C相电压31次谐波",
            "groupId": "9b1f5445f7f54702899327d31b3ca00d",
            "id": "AF55E85C-0B32-43C7-896D-7516CEC14B7C",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": null,
            "no": 231,
            "name": "C相电压波形畸变率",
            "groupId": "4f1506f4-3aba-4bdd-a631-8cd194bc5773",
            "id": "3B606D0B-1792-4478-8DB0-6B88AACC6F71",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": null,
            "no": 232,
            "name": "开关量",
            "groupId": "a08fdbfa38ef4126a8471f0934bc2fe9",
            "id": "718D2EA8-FBF8-480F-A73D-6A19DA713184",
            "energyType": 0,
            "useDifference": 0,
            "enable": 0,
            "entityName": "AppType"
          },
          {
            "createTime": null,
            "no": 233,
            "name": "时间",
            "groupId": "a731f816411e4125a76c49c6ac16951d",
            "id": "0EEBBC77-AB06-4340-989A-E914826565B8",
            "energyType": 0,
            "useDifference": 1,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": null,
            "no": 234,
            "name": "温度",
            "groupId": "e2c6256b-ab82-4690-b8cb-a4a33b1ad8c4",
            "id": "DC566651-8993-4996-9CE8-1055B4A0348C",
            "energyType": null,
            "useDifference": null,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": null,
            "no": 235,
            "name": "湿度",
            "groupId": "dcaef86b54924477894b573d935ee6e9",
            "id": "3D1CB4C5-088C-4079-BC3F-DD714B194501",
            "energyType": null,
            "useDifference": null,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": null,
            "no": 236,
            "name": "压力",
            "groupId": "b31af6844f9243098793ca779f139fe9",
            "id": "33343CF9-0920-4252-A78B-19E2E2989ADA",
            "energyType": null,
            "useDifference": null,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": null,
            "no": 237,
            "name": "累计流量",
            "groupId": "2666a9ca4520424a9e4c521bd0f35b48",
            "id": "5A42F166-4145-45A0-96AD-2D3C875E7341",
            "energyType": 0,
            "useDifference": 0,
            "enable": 0,
            "entityName": "AppType"
          },
          {
            "createTime": null,
            "no": 238,
            "name": "相角",
            "groupId": "931b9e3cc6b54b328a8111f82cc613a4",
            "id": "52C634AE-7854-45F8-ADEE-BFF8BDC8CE90",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": null,
            "no": 239,
            "name": "K因数",
            "groupId": "2be1be84e97c4ccfa913ae3dcaf259cd",
            "id": "C84528FD-BADD-4275-82CE-45D676A1047D",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": null,
            "no": 240,
            "name": "频率偏差",
            "groupId": "2127db0372654a6e803645a7daeb48fd",
            "id": "2c7a1259-d851-4a6e-b3de-629df400aba6",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": null,
            "no": 241,
            "name": "三相电压不平衡度",
            "groupId": "6ba41729fae7410983f25aff22cc8cbb",
            "id": "04e0bb4a-d338-4c0a-a98f-300e106c6fa1",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": null,
            "no": 242,
            "name": "三相电流不平衡度",
            "groupId": "61e72559e3c641bb8a3bdbb852a0997b",
            "id": "7c038b8d-0011-493c-a215-54a83cad702f",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": null,
            "no": 243,
            "name": "A相电压偏差",
            "groupId": "7b093983e8d84d768de4fdf4bf0766af",
            "id": "fc427c70-21f8-45c8-aec5-e403ab484045",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": null,
            "no": 244,
            "name": "B相电压偏差",
            "groupId": "7b093983e8d84d768de4fdf4bf0766af",
            "id": "f92264ad-9b57-4588-84fe-03f4de521cc7",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": null,
            "no": 245,
            "name": "C相电压偏差",
            "groupId": "7b093983e8d84d768de4fdf4bf0766af",
            "id": "e0eeb22e-62af-4649-b7ce-b0b6fcf6a6d7",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": null,
            "no": 246,
            "name": "瞬时流量",
            "groupId": "2812a71f43cd4fd1ac5404b4d42f9385",
            "id": "50a5bf13-da12-4c4a-9669-2f8c20e2a364",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": null,
            "no": 247,
            "name": "亮度",
            "groupId": "f28f41719a104a8a8d0e0aadfb516363",
            "id": "9d2068c3-2506-4328-ad19-4241c53f0b8e",
            "energyType": null,
            "useDifference": null,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": null,
            "no": 248,
            "name": "调光度",
            "groupId": "12472bd435744ed8b8ffb302c2b9e235",
            "id": "78d489d4-ae83-4400-9729-2da204dea02d",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": null,
            "no": 249,
            "name": "A相电流总偶次畸变率",
            "groupId": "5f0330d6ea404867b1277b701c103aa3",
            "id": "0C0D80D9-87BA-4E2B-9DB3-FCF9643372E1",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": null,
            "no": 250,
            "name": "A相电流总奇次畸变率",
            "groupId": "5f0330d6ea404867b1277b701c103aa3",
            "id": "02BE024D-4870-40C3-BA15-94849978B117",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": null,
            "no": 251,
            "name": "B相电流总偶次畸变率",
            "groupId": "5f0330d6ea404867b1277b701c103aa3",
            "id": "833C323F-076F-4050-801C-F75ACF304536",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": null,
            "no": 252,
            "name": "B相电流总奇次畸变率",
            "groupId": "5f0330d6ea404867b1277b701c103aa3",
            "id": "46DD2A96-C6F6-4588-8C00-9E4B09C068EB",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": null,
            "no": 253,
            "name": "C相电流总偶次畸变率",
            "groupId": "5f0330d6ea404867b1277b701c103aa3",
            "id": "99F837D3-8797-41A6-967A-20EE93640DF7",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": null,
            "no": 254,
            "name": "C相电流总奇次畸变率",
            "groupId": "5f0330d6ea404867b1277b701c103aa3",
            "id": "6E0C642E-4F2E-483D-BEA2-9FC64F22EF06",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": null,
            "no": 255,
            "name": "A相电压总偶次畸变率",
            "groupId": "4f1506f4-3aba-4bdd-a631-8cd194bc5773",
            "id": "E5ED1DC8-4297-45BF-8ADC-2A6C1F3E703E",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": null,
            "no": 256,
            "name": "A相电压总奇次畸变率",
            "groupId": "4f1506f4-3aba-4bdd-a631-8cd194bc5773",
            "id": "251D4FA5-B10E-43B2-AEF4-027C3CB55CE5",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": null,
            "no": 257,
            "name": "B相电压总偶次畸变率",
            "groupId": "4f1506f4-3aba-4bdd-a631-8cd194bc5773",
            "id": "5C449868-A79C-4905-9379-1F3638365EDA",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": null,
            "no": 258,
            "name": "B相电压总奇次畸变率",
            "groupId": "4f1506f4-3aba-4bdd-a631-8cd194bc5773",
            "id": "3B0009CF-35E0-4C3A-9D67-E289C0FE935E",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": null,
            "no": 259,
            "name": "C相电压总偶次畸变率",
            "groupId": "4f1506f4-3aba-4bdd-a631-8cd194bc5773",
            "id": "41433D24-E64A-46CA-92E3-5E489EF05450",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": null,
            "no": 260,
            "name": "C相电压总奇次畸变率",
            "groupId": "4f1506f4-3aba-4bdd-a631-8cd194bc5773",
            "id": "C0A84EF1-9EB8-49E7-8D0D-6FEB0330F646",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": null,
            "no": 261,
            "name": "状态量",
            "groupId": "a08fdbfa38ef4126a8471f0934bc2fe9",
            "id": "0753ED56-522E-46CA-8CF9-EA72840892F4",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": null,
            "no": 262,
            "name": "西门子充电桩合开关",
            "groupId": "ce01ac4c1fc74753b18591f038d765ce",
            "id": "ce01ac4c1fc74753b18591f038d765ce",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": null,
            "no": 263,
            "name": "西门子充电桩分开关",
            "groupId": "ce01ac4c1fc74753b18591f038d765ce",
            "id": "321ac4c1fc74753b18591f038d765ce",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": null,
            "no": 264,
            "name": "有功功率需量",
            "groupId": "4c20865ac7ec49208fdcf004abee9a8b",
            "id": "afedea87daaa4257924cbec8e47f8800",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": null,
            "no": 265,
            "name": "无功功率需量",
            "groupId": "4e57970f96f74245b09464962f09e2a0",
            "id": "4c11b611f5fb40dbbcfff5c01ed2f004",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": null,
            "no": 266,
            "name": "视在功率需量",
            "groupId": "4330cc707b3d4dce9ac07a5fbc2cde80",
            "id": "d3b5156faab84a4e9e267400407901df",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": null,
            "no": 267,
            "name": "A相电流需量",
            "groupId": "700b5db9564c42bd97a1d2d16f725d73",
            "id": "fa0e3d074ba74f429a8784affadc64ca",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": null,
            "no": 268,
            "name": "B相电流需量",
            "groupId": "700b5db9564c42bd97a1d2d16f725d73",
            "id": "1ff1c480862944fc9ff5cdf345bfab1f",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": null,
            "no": 269,
            "name": "C相电流需量",
            "groupId": "700b5db9564c42bd97a1d2d16f725d73",
            "id": "0d2ff4ed92224c7e8a20f6ad98b57fe4",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": null,
            "no": 270,
            "name": "当前有功功率最大需量",
            "groupId": "4c20865ac7ec49208fdcf004abee9a8b",
            "id": "87f682f92ffb426ab7eaf7d528645046",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": null,
            "no": 271,
            "name": "当前无功功率最大需量",
            "groupId": "4e57970f96f74245b09464962f09e2a0",
            "id": "1e557ffded99432e9f3f48cad9de3219",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": null,
            "no": 272,
            "name": "当前视在功率最大需量",
            "groupId": "4330cc707b3d4dce9ac07a5fbc2cde80",
            "id": "6793891a0a6541e7b3e56d0df20b8e98",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": null,
            "no": 273,
            "name": "上次有功功率最大需量",
            "groupId": "4c20865ac7ec49208fdcf004abee9a8b",
            "id": "6d0428a82137454ea9b7b25511bb5045",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": null,
            "no": 274,
            "name": "上次无功功率最大需量",
            "groupId": "4e57970f96f74245b09464962f09e2a0",
            "id": "42fa65b3af42492c981d6f771fed05f3",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": null,
            "no": 275,
            "name": "上次视在功率最大需量",
            "groupId": "4330cc707b3d4dce9ac07a5fbc2cde80",
            "id": "54e84424eaab438c98fdd8d451083917",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": null,
            "no": 280,
            "name": "空调设定温度",
            "groupId": "a42b3ea9dfd24bb6ab7f548a8a78db7a",
            "id": "b8d396e8e2c9493582ce9d5fc5fcc1c4",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": null,
            "no": 281,
            "name": "空调运行模式",
            "groupId": "1831f085abfa435ea5f51b9a01839b6f",
            "id": "64b9e65722a24c63a80fdbe596d3c794",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": null,
            "no": 282,
            "name": "空调风速",
            "groupId": "1831f085abfa435ea5f51b9a01839b6f",
            "id": "f31108af36bd46b7931d8700cc7d0a17",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": null,
            "no": 283,
            "name": "空调垂直风摆",
            "groupId": "1831f085abfa435ea5f51b9a01839b6f",
            "id": "4714dc08c2bb4982851590da5a7155ef",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": null,
            "no": 284,
            "name": "空调水平风摆",
            "groupId": "1831f085abfa435ea5f51b9a01839b6f",
            "id": "6b8a6188fecf4c798c820dd65c231c44",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": null,
            "no": 285,
            "name": "最高温度权限",
            "groupId": "ee7926d51c734f9f8de891b1a87b4863",
            "id": "35cdc55a179b44998ae1fd4cca80f25e",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": null,
            "no": 286,
            "name": "最低温度权限",
            "groupId": "ee7926d51c734f9f8de891b1a87b4863",
            "id": "5411ed9ed8e54afea855232093e59e88",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": null,
            "no": 287,
            "name": "运行模式权限",
            "groupId": "ee7926d51c734f9f8de891b1a87b4863",
            "id": "872af7141adf499992a96442c312e63e",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": null,
            "no": 288,
            "name": "风速权限",
            "groupId": "ee7926d51c734f9f8de891b1a87b4863",
            "id": "db970274f3a94b279109aa52db313fdd",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": null,
            "no": 289,
            "name": "垂直风摆权限",
            "groupId": "ee7926d51c734f9f8de891b1a87b4863",
            "id": "3f83438b8ec64890bfa232d611b2305a",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": null,
            "no": 290,
            "name": "水平风摆权限",
            "groupId": "ee7926d51c734f9f8de891b1a87b4863",
            "id": "01d5e9e7c729434aaeb3e4bbf28244dd",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": null,
            "no": 291,
            "name": "人体红外状态",
            "groupId": "345a9d750d2a4009adf0d2f9f909b98c",
            "id": "71fdfb2d253d434ca5013850d3eeb5fa",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": null,
            "no": 292,
            "name": "电量百分比",
            "groupId": "345a9d750d2a4009adf0d2f9f909b98c",
            "id": "118912013e93473e85c4c7cb071ed05e",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": null,
            "no": 293,
            "name": "电池电压",
            "groupId": "345a9d750d2a4009adf0d2f9f909b98c",
            "id": "baef7e55415f49d3b9081653fb210252",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": null,
            "no": 295,
            "name": "信号强度",
            "groupId": "294c9e9706c84897bac436dc20274307",
            "id": "ef1ca6471b07400a9c97edfa29a87a44",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": null,
            "no": 296,
            "name": "联网状态",
            "groupId": "da2c71d085704b7eb61c5a891fd574ba",
            "id": "9968612e326e417f90a54fc178f4f97d",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": null,
            "no": 297,
            "name": "漏电流",
            "groupId": "aec119cd-245d-4432-b97d-1a11646377c0",
            "id": "0aa82b5e4420480aadce8a3012c58617",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": null,
            "no": 298,
            "name": "短路报警",
            "groupId": "da2c71d085704b7eb61c5a891fd574ba",
            "id": "354eaa47ed434edf9446341954dd3976",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": null,
            "no": 299,
            "name": "浪涌报警",
            "groupId": "da2c71d085704b7eb61c5a891fd574ba",
            "id": "c0b2f683018d4d599c0b6d1754f10d6c",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": null,
            "no": 300,
            "name": "过载报警",
            "groupId": "da2c71d085704b7eb61c5a891fd574ba",
            "id": "35663908558a443791a250780165b231",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": null,
            "no": 301,
            "name": "温度报警",
            "groupId": "da2c71d085704b7eb61c5a891fd574ba",
            "id": "8dffa1dc5a37422c8c776bcf0f7b126f",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": null,
            "no": 302,
            "name": "漏电报警",
            "groupId": "da2c71d085704b7eb61c5a891fd574ba",
            "id": "00c452629a474ccdbbfaa2562e48f99c",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": null,
            "no": 303,
            "name": "过流报警",
            "groupId": "da2c71d085704b7eb61c5a891fd574ba",
            "id": "134243995c6d4cafa715aa999c41861d",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": null,
            "no": 304,
            "name": "过压报警",
            "groupId": "da2c71d085704b7eb61c5a891fd574ba",
            "id": "74d274e2d3f4499cb7c8062a5deb6980",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": null,
            "no": 305,
            "name": "漏电保护功能正常",
            "groupId": "da2c71d085704b7eb61c5a891fd574ba",
            "id": "836da95a41964605a6f95a7424a247c5",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": null,
            "no": 306,
            "name": "漏电保护自检未完成",
            "groupId": "da2c71d085704b7eb61c5a891fd574ba",
            "id": "0c4dc1da46344995b7c43b979de7eb9a",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": null,
            "no": 307,
            "name": "输入缺相(380)",
            "groupId": "da2c71d085704b7eb61c5a891fd574ba",
            "id": "63d64b95921448fd82b8a1907baf9940",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": null,
            "no": 308,
            "name": "打火报警",
            "groupId": "da2c71d085704b7eb61c5a891fd574ba",
            "id": "9bd2e5ca502d426faab30d865e2667a2",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": null,
            "no": 309,
            "name": "欠压报警",
            "groupId": "da2c71d085704b7eb61c5a891fd574ba",
            "id": "fe7701d639234e5ea7ac622dfd99557b",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": null,
            "no": 310,
            "name": "过压预警",
            "groupId": "da2c71d085704b7eb61c5a891fd574ba",
            "id": "7ba3221ed7694c7eb9be6f1e5ef79073",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": null,
            "no": 311,
            "name": "欠压预警",
            "groupId": "da2c71d085704b7eb61c5a891fd574ba",
            "id": "57fd6230e1b04a5c96662d875048fb4f",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": null,
            "no": 312,
            "name": "漏电预警",
            "groupId": "da2c71d085704b7eb61c5a891fd574ba",
            "id": "e9dcc4043e7649c4904f58cd38f2dab0",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": null,
            "no": 313,
            "name": "电流预警",
            "groupId": "da2c71d085704b7eb61c5a891fd574ba",
            "id": "d28bad5050f348e489183ab8d56ac134",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": null,
            "no": 314,
            "name": "远程合闸禁止",
            "groupId": "da2c71d085704b7eb61c5a891fd574ba",
            "id": "4f8dd91276b94996a0f3486442eda06c",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": null,
            "no": 315,
            "name": "禁止缺相保护",
            "groupId": "da2c71d085704b7eb61c5a891fd574ba",
            "id": "5abdd3f415bb4a5eb3c32a796d1b1936",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": null,
            "no": 316,
            "name": "禁止不平衡保护",
            "groupId": "da2c71d085704b7eb61c5a891fd574ba",
            "id": "cef6b10602b64db8968c9645eebc2300",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": null,
            "no": 317,
            "name": "禁止相序保护",
            "groupId": "da2c71d085704b7eb61c5a891fd574ba",
            "id": "883775a0ee6e4395ba8a345fbdff248e",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": null,
            "no": 318,
            "name": "不平衡报警",
            "groupId": "da2c71d085704b7eb61c5a891fd574ba",
            "id": "3efaecd2d6af43f5bd9be8d7beaf7cff",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": null,
            "no": 319,
            "name": "相序ACB",
            "groupId": "da2c71d085704b7eb61c5a891fd574ba",
            "id": "8220fda2968a42d8870416ca348b60f2",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": null,
            "no": 320,
            "name": "开关开合状态",
            "groupId": "da2c71d085704b7eb61c5a891fd574ba",
            "id": "336074114dbe4af7b740a42525351aa7",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": null,
            "no": 321,
            "name": "开关在线状态",
            "groupId": "da2c71d085704b7eb61c5a891fd574ba",
            "id": "30c01d7ac0db4c82983dda1e0b8bec3a",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": null,
            "no": 322,
            "name": "N相电流值",
            "groupId": "aec119cd-245d-4432-b97d-1a11646377c0",
            "id": "125d562dc33f4a16a287fd112e29bae3",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": null,
            "no": 330,
            "name": "照明开关操作",
            "groupId": "26ed8f078fa9404bbbe4165106b22820",
            "id": "73d22d620f52410b9d3963ad5b669d42",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": null,
            "no": 331,
            "name": "照明调光设置",
            "groupId": "26ed8f078fa9404bbbe4165106b22820",
            "id": "35be2fe7117543a2a4744eb3cdc0e301",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": null,
            "no": 332,
            "name": "照明空调开关",
            "groupId": "26ed8f078fa9404bbbe4165106b22820",
            "id": "114297d876484797b5d7ad8c2b8e1e0e",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": null,
            "no": 333,
            "name": "照明空调风速",
            "groupId": "26ed8f078fa9404bbbe4165106b22820",
            "id": "e8485ee9eced43f78adf3358add235c6",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": null,
            "no": 334,
            "name": "照明空调模式",
            "groupId": "26ed8f078fa9404bbbe4165106b22820",
            "id": "a7589794c3144ec0bd6360bdb43a1eee",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": null,
            "no": 335,
            "name": "照明空调温度",
            "groupId": "26ed8f078fa9404bbbe4165106b22820",
            "id": "6621fe8e49de4a1bb60f0c061295d786",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": null,
            "no": 336,
            "name": "照明窗帘开关",
            "groupId": "26ed8f078fa9404bbbe4165106b22820",
            "id": "ed5ab44fc97a4dfb90a9951a5d6bce90",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": null,
            "no": 337,
            "name": "照明窗帘高度",
            "groupId": "26ed8f078fa9404bbbe4165106b22820",
            "id": "9de03923a2924bdeb53c06d407257e65",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": null,
            "no": 338,
            "name": "照明新风开关",
            "groupId": "26ed8f078fa9404bbbe4165106b22820",
            "id": "3b79675cfcae46ea950034701c20c992",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": null,
            "no": 339,
            "name": "照明新风档位",
            "groupId": "26ed8f078fa9404bbbe4165106b22820",
            "id": "16018490b4f94f4a969ac8e336e7307b",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": null,
            "no": 340,
            "name": "照明地暖开关",
            "groupId": "26ed8f078fa9404bbbe4165106b22820",
            "id": "02ac3029a59d42d087a8741ec77144fa",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": null,
            "no": 341,
            "name": "照明地暖温度",
            "groupId": "26ed8f078fa9404bbbe4165106b22820",
            "id": "396967680c844eb4b05f7997a1ae426f",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": null,
            "no": 342,
            "name": "照明地暖风速",
            "groupId": "26ed8f078fa9404bbbe4165106b22820",
            "id": "34f12772567448c0addc3422a1adb14c",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": null,
            "no": 343,
            "name": "照明相对调光",
            "groupId": "26ed8f078fa9404bbbe4165106b22820",
            "id": "63c0c35858e043beb987e5c859ced047",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": null,
            "no": 344,
            "name": "照明绝对调光",
            "groupId": "26ed8f078fa9404bbbe4165106b22820",
            "id": "f090679424e8484e80538cb025b47806",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": null,
            "no": 350,
            "name": "总",
            "groupId": "fb851bbfd23b44cea50ac7cbb62ddd5d",
            "id": "33e5be1d4e2b4e399f2fbf8916e40ba0",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": null,
            "no": 351,
            "name": "尖",
            "groupId": "fb851bbfd23b44cea50ac7cbb62ddd5d",
            "id": "2b742f3b2538482c95588855cd754d7b",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": null,
            "no": 352,
            "name": "峰",
            "groupId": "fb851bbfd23b44cea50ac7cbb62ddd5d",
            "id": "60f48d960ee1483286bf7949b67f1e2f",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": null,
            "no": 353,
            "name": "平",
            "groupId": "fb851bbfd23b44cea50ac7cbb62ddd5d",
            "id": "2f217207991d4cf4bdbfd9089c80f4f2",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": null,
            "no": 354,
            "name": "谷",
            "groupId": "fb851bbfd23b44cea50ac7cbb62ddd5d",
            "id": "3c7fd03f0a2941fd8c8c36424e8963c2",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": null,
            "no": 361,
            "name": "天然气累计流量",
            "groupId": "2666a9ca4520424a9e4c521bd0f35b48",
            "id": "87f358d1d2994a79bae40ee8374bdbc2",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": null,
            "no": 362,
            "name": "蒸汽累计流量",
            "groupId": "2666a9ca4520424a9e4c521bd0f35b48",
            "id": "4cbafc45d7bd4cb7bd23963127ab548b",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": null,
            "no": 370,
            "name": "当日尖",
            "groupId": "fb851bbfd23b44cea50ac7cbb62ddd5d",
            "id": "f65496629cb6469aa62cdfabba696d05",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": null,
            "no": 371,
            "name": "当日峰",
            "groupId": "fb851bbfd23b44cea50ac7cbb62ddd5d",
            "id": "bed394f10eb4432fad63caf98549ca51",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": null,
            "no": 372,
            "name": "当日平",
            "groupId": "fb851bbfd23b44cea50ac7cbb62ddd5d",
            "id": "d65590b375fb4a67b4aaf63d2a35a28b",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": null,
            "no": 373,
            "name": "当日谷",
            "groupId": "fb851bbfd23b44cea50ac7cbb62ddd5d",
            "id": "297c51509ca74ed99414916b36801268",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": null,
            "no": 374,
            "name": "昨日尖",
            "groupId": "fb851bbfd23b44cea50ac7cbb62ddd5d",
            "id": "e64c4a8a79e04483977f70e483830eb2",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": null,
            "no": 375,
            "name": "昨日峰",
            "groupId": "fb851bbfd23b44cea50ac7cbb62ddd5d",
            "id": "8dea1fa7be1c421cae25d24637cc5262",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": null,
            "no": 376,
            "name": "昨日平",
            "groupId": "fb851bbfd23b44cea50ac7cbb62ddd5d",
            "id": "2012204307d04f669d15bad30bf96b06",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": null,
            "no": 377,
            "name": "昨日谷",
            "groupId": "fb851bbfd23b44cea50ac7cbb62ddd5d",
            "id": "3bb8491df0214898a1dada63a94e5fd2",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": null,
            "no": 378,
            "name": "前日尖",
            "groupId": "fb851bbfd23b44cea50ac7cbb62ddd5d",
            "id": "67017e7cd3f84c7699c5327e36356716",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": null,
            "no": 379,
            "name": "前日峰",
            "groupId": "fb851bbfd23b44cea50ac7cbb62ddd5d",
            "id": "06ef047f8ad54ab99a8e9295fb7e6122",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": null,
            "no": 380,
            "name": "前日平",
            "groupId": "fb851bbfd23b44cea50ac7cbb62ddd5d",
            "id": "c5cd9041ee4945238b43903d774d641e",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": null,
            "no": 381,
            "name": "前日谷",
            "groupId": "fb851bbfd23b44cea50ac7cbb62ddd5d",
            "id": "82a90fac364c403a9867dec9bf70cd96",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": null,
            "no": 382,
            "name": "当月尖",
            "groupId": "fb851bbfd23b44cea50ac7cbb62ddd5d",
            "id": "324a14bf73524daba78bd09d0d3dbd9d",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": null,
            "no": 383,
            "name": "当月峰",
            "groupId": "fb851bbfd23b44cea50ac7cbb62ddd5d",
            "id": "c2b7cb388216459c90dfeef6127d62b9",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": null,
            "no": 384,
            "name": "当月平",
            "groupId": "fb851bbfd23b44cea50ac7cbb62ddd5d",
            "id": "80bf51e186104a64ac217847637482fb",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": null,
            "no": 385,
            "name": "当月谷",
            "groupId": "fb851bbfd23b44cea50ac7cbb62ddd5d",
            "id": "378494de6f744820be415a1b35f6adeb",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": null,
            "no": 386,
            "name": "上月尖",
            "groupId": "fb851bbfd23b44cea50ac7cbb62ddd5d",
            "id": "904dd70e8a974c1dade1ca8cc572519e",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": null,
            "no": 387,
            "name": "上月峰",
            "groupId": "fb851bbfd23b44cea50ac7cbb62ddd5d",
            "id": "143f829a8f71483f991d58fecf11cc5d",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": null,
            "no": 388,
            "name": "上月平",
            "groupId": "fb851bbfd23b44cea50ac7cbb62ddd5d",
            "id": "af8abc31fdb94b3bb3915a6d68b5777a",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": null,
            "no": 389,
            "name": "上月谷",
            "groupId": "fb851bbfd23b44cea50ac7cbb62ddd5d",
            "id": "aef29dd32ca3476babbb9d3f2b378aec",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": null,
            "no": 390,
            "name": "前月尖",
            "groupId": "fb851bbfd23b44cea50ac7cbb62ddd5d",
            "id": "bf7bc2427c0c4953ba2e051815149844",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": null,
            "no": 391,
            "name": "前月峰",
            "groupId": "fb851bbfd23b44cea50ac7cbb62ddd5d",
            "id": "619bd97f47314b8aa065cc9db72450bd",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": null,
            "no": 392,
            "name": "前月平",
            "groupId": "fb851bbfd23b44cea50ac7cbb62ddd5d",
            "id": "7c214b55621c409d8dad8db939e84415",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": null,
            "no": 393,
            "name": "前月谷",
            "groupId": "fb851bbfd23b44cea50ac7cbb62ddd5d",
            "id": "d2c2ab4e6bef4f0b98e79801d9c1454c",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": null,
            "no": 394,
            "name": "当年尖",
            "groupId": "fb851bbfd23b44cea50ac7cbb62ddd5d",
            "id": "62ef1385a1c145739d0d205ffe27d0dd",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": null,
            "no": 395,
            "name": "当年峰",
            "groupId": "fb851bbfd23b44cea50ac7cbb62ddd5d",
            "id": "ec45b6864d8640fda1f10bf8c3995939",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": null,
            "no": 396,
            "name": "当年平",
            "groupId": "fb851bbfd23b44cea50ac7cbb62ddd5d",
            "id": "d0d85160ac3e47f2808c3fa78e292755",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": null,
            "no": 397,
            "name": "当年谷",
            "groupId": "fb851bbfd23b44cea50ac7cbb62ddd5d",
            "id": "cb3a8196f3f74939a2060bcdd88a0e18",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": null,
            "no": 398,
            "name": "上年尖",
            "groupId": "fb851bbfd23b44cea50ac7cbb62ddd5d",
            "id": "3f19202e0ecb4ae4b1b3931a2b397487",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": null,
            "no": 399,
            "name": "上年峰",
            "groupId": "fb851bbfd23b44cea50ac7cbb62ddd5d",
            "id": "5e41a3f822e6467d8fc04e6e1a3099ec",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": null,
            "no": 400,
            "name": "上年平",
            "groupId": "fb851bbfd23b44cea50ac7cbb62ddd5d",
            "id": "e2eec61e129b48f28b667d711d368a7f",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": null,
            "no": 401,
            "name": "上年谷",
            "groupId": "fb851bbfd23b44cea50ac7cbb62ddd5d",
            "id": "7b4953aef77a4b9b9cea4d7208e742e3",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": null,
            "no": 402,
            "name": "前年尖",
            "groupId": "fb851bbfd23b44cea50ac7cbb62ddd5d",
            "id": "bccd385589dc425580907d97cd811761",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": null,
            "no": 403,
            "name": "前年峰",
            "groupId": "fb851bbfd23b44cea50ac7cbb62ddd5d",
            "id": "bbb361826287475fa1c97367d3ca6ebe",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": null,
            "no": 404,
            "name": "前年平",
            "groupId": "fb851bbfd23b44cea50ac7cbb62ddd5d",
            "id": "3e801e974c25419b836f445737bcc573",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": null,
            "no": 405,
            "name": "前年谷",
            "groupId": "fb851bbfd23b44cea50ac7cbb62ddd5d",
            "id": "08b8a4f0f33049f7a44e9cf93c32b745",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": null,
            "no": 410,
            "name": "剩余电量",
            "groupId": "cec535339e794783b932f764d9ee12a9",
            "id": "297fd9a720224b9a98c3a8acca8577de",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": null,
            "no": 411,
            "name": "过零电量",
            "groupId": "cec535339e794783b932f764d9ee12a9",
            "id": "5885681bc2884d41af1279a627abf746",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": null,
            "no": 412,
            "name": "透支电量",
            "groupId": "cec535339e794783b932f764d9ee12a9",
            "id": "74da93c7f52d4ca78a2bde3bcb28fd9b",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": null,
            "no": 413,
            "name": "接触磨损",
            "groupId": "5fcd7ac541a24967af64539b40ce1648",
            "id": "48720fec8d68449988d5dcef40c579f8",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": null,
            "no": 414,
            "name": "跳匝次数",
            "groupId": "5fcd7ac541a24967af64539b40ce1648",
            "id": "2637e3ca9d17410c94343c2bcedb7f9a",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": null,
            "no": 415,
            "name": "健康指数",
            "groupId": "5738a003d7ce49dfb0873cc22f162642",
            "id": "f5b4a6ca46024d5cb2381d5dfd44bc62",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": null,
            "no": 416,
            "name": "剩余寿命",
            "groupId": "5738a003d7ce49dfb0873cc22f162642",
            "id": "2de4a8de86fa47a19fb2ad181f152ca3",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": null,
            "no": 417,
            "name": "剩余保养天数",
            "groupId": "5738a003d7ce49dfb0873cc22f162642",
            "id": "d76f0aa23d464d5ca6059b7a56b0d8dc",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": null,
            "no": 1001,
            "name": "上月需量",
            "groupId": "c70627186f0b40bcb54e409687f60b5d",
            "id": "542bfa88df184adcb66d5a48cfdb12aa",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": null,
            "no": 1002,
            "name": "本月需量",
            "groupId": "c70627186f0b40bcb54e409687f60b5d",
            "id": "80676065d14d4fa7a01f497c1a1b2a8d",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": 1689729289000,
            "no": 1003,
            "name": "煤炭",
            "groupId": "0125e86ea9734aca8ad0980fa057d702",
            "id": "fa84a27eccd948dd8be4859ac6eb3e0e",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": 1689729297000,
            "no": 1004,
            "name": "汽油",
            "groupId": "0125e86ea9734aca8ad0980fa057d702",
            "id": "d0aa47e143c441669f0b703808cff28d",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": 1689729320000,
            "no": 1005,
            "name": "液化石油气",
            "groupId": "0125e86ea9734aca8ad0980fa057d702",
            "id": "8041e98b68a545f2bd2549e2b361ba60",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": 1689729358000,
            "no": 1006,
            "name": "热力",
            "groupId": "0125e86ea9734aca8ad0980fa057d702",
            "id": "2b7a4ee5d96646a1bf9e7c80239d44a5",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": 1689729367000,
            "no": 1007,
            "name": "其他能源",
            "groupId": "0125e86ea9734aca8ad0980fa057d702",
            "id": "98df0e39c7e24e9ea55af6f498746642",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": 1689729596000,
            "no": 1008,
            "name": "柴油",
            "groupId": "0125e86ea9734aca8ad0980fa057d702",
            "id": "b6d99266f51b451584df106bcc38710d",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": 1696669138000,
            "no": 1009,
            "name": "A相电压谐波含有率",
            "groupId": "8fd4a17e00cb4d69ab590270ed64774a",
            "id": "fabbf58974a34770aee3ffae1342dd31",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": 1696669164000,
            "no": 1010,
            "name": "B相电压谐波含有率",
            "groupId": "8fd4a17e00cb4d69ab590270ed64774a",
            "id": "feae7b209603457bba555161e4c473b7",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": 1696669173000,
            "no": 1011,
            "name": "C相电压谐波含有率",
            "groupId": "8fd4a17e00cb4d69ab590270ed64774a",
            "id": "c53b1a11d48d4936b54195b5cc31e4e3",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": 1696669230000,
            "no": 1012,
            "name": "A相电流谐波含有率",
            "groupId": "1d7b3624d9ed43968fafbb2f07a46ddd",
            "id": "7b6d1e034405495095da0053e09e80ba",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": 1696669238000,
            "no": 1013,
            "name": "B相电流谐波含有率",
            "groupId": "1d7b3624d9ed43968fafbb2f07a46ddd",
            "id": "578d5723412641eab3d7f5318ebff244",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": 1696669245000,
            "no": 1014,
            "name": "C相电流谐波含有率",
            "groupId": "1d7b3624d9ed43968fafbb2f07a46ddd",
            "id": "d8211d728f6e4f218890523b83aefb56",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": 1696671123000,
            "no": 1015,
            "name": "A相电压基波",
            "groupId": "c976398a97fc457bb7181f2af08f00e3",
            "id": "68603b86271441aeb58cb6437e18518d",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": 1696671132000,
            "no": 1016,
            "name": "B相电压基波",
            "groupId": "c976398a97fc457bb7181f2af08f00e3",
            "id": "387f3651a5b149df9537a2a798c178e6",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": 1696671139000,
            "no": 1017,
            "name": "C相电压基波",
            "groupId": "c976398a97fc457bb7181f2af08f00e3",
            "id": "3eb4d2b4c90345bb81dd0c5de964c873",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": 1696671149000,
            "no": 1018,
            "name": "A相电流基波",
            "groupId": "b6524d5e0424454dbc0f349eec5b0fd6",
            "id": "8c21613d92ad4b9c9c54674f3c88f4dd",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": 1696671156000,
            "no": 1019,
            "name": "B相电流基波",
            "groupId": "b6524d5e0424454dbc0f349eec5b0fd6",
            "id": "7ad4de36f3d340668fa5bd08d3b1f3cf",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": 1696671162000,
            "no": 1020,
            "name": "C相电流基波",
            "groupId": "b6524d5e0424454dbc0f349eec5b0fd6",
            "id": "38f67d681ea44d87af1d03758e2dbf92",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": 1696671921000,
            "no": 1021,
            "name": "电压A相2次谐波",
            "groupId": "1861b8d271314793a72be5252f386766",
            "id": "09c2b32a4e5f4bbfaa00aca2858299c9",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": 1696671928000,
            "no": 1022,
            "name": "电压A相3次谐波",
            "groupId": "1861b8d271314793a72be5252f386766",
            "id": "add660200d7245e0b4ec5ea719e58ccc",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": 1696671946000,
            "no": 1023,
            "name": "电压A相4次谐波",
            "groupId": "1861b8d271314793a72be5252f386766",
            "id": "c9a92e128469401e834174c64eef6448",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": 1696672017000,
            "no": 1024,
            "name": "电压A相5次谐波",
            "groupId": "1861b8d271314793a72be5252f386766",
            "id": "713a316232f543948f32e6011492e699",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": 1696673116000,
            "no": 1025,
            "name": "电压A相6次谐波",
            "groupId": "1861b8d271314793a72be5252f386766",
            "id": "1c833262747a4fe8be34c590e7761ac3",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": 1696673116000,
            "no": 1026,
            "name": "电压A相7次谐波",
            "groupId": "1861b8d271314793a72be5252f386766",
            "id": "5a131c5161cd42da82c5f81c7d5c4172",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": 1696673116000,
            "no": 1027,
            "name": "电压A相8次谐波",
            "groupId": "1861b8d271314793a72be5252f386766",
            "id": "28e7378e4d07416b935c7d0ebb1f7551",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": 1696673117000,
            "no": 1028,
            "name": "电压A相9次谐波",
            "groupId": "1861b8d271314793a72be5252f386766",
            "id": "f407add40fa342f880242df51b4d5691",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": 1696673117000,
            "no": 1029,
            "name": "电压A相10次谐波",
            "groupId": "1861b8d271314793a72be5252f386766",
            "id": "5d64bcb54efa471fb15656c8f0316a97",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": 1696673117000,
            "no": 1030,
            "name": "电压A相11次谐波",
            "groupId": "1861b8d271314793a72be5252f386766",
            "id": "3e9eb9eca59845e6972ef06bb3e03d76",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": 1696673117000,
            "no": 1031,
            "name": "电压A相12次谐波",
            "groupId": "1861b8d271314793a72be5252f386766",
            "id": "72d0ff7556b54a5c88a7eee6e9cf7665",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": 1696673117000,
            "no": 1032,
            "name": "电压A相13次谐波",
            "groupId": "1861b8d271314793a72be5252f386766",
            "id": "fc5771c81fdf46c988d89a5dea6f924f",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": 1696673117000,
            "no": 1033,
            "name": "电压A相14次谐波",
            "groupId": "1861b8d271314793a72be5252f386766",
            "id": "d9fe2e3f885e4406b75ef52a0094acd2",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": 1696673117000,
            "no": 1034,
            "name": "电压A相15次谐波",
            "groupId": "1861b8d271314793a72be5252f386766",
            "id": "6c786aed69e849baad305bf641e13b6b",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": 1696673117000,
            "no": 1035,
            "name": "电压A相16次谐波",
            "groupId": "1861b8d271314793a72be5252f386766",
            "id": "d22efa1e853b4e92ac0ae083b408a6db",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": 1696673117000,
            "no": 1036,
            "name": "电压A相17次谐波",
            "groupId": "1861b8d271314793a72be5252f386766",
            "id": "6a5f9a088cac416b8665a8ff2a24ef09",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": 1696673118000,
            "no": 1037,
            "name": "电压A相18次谐波",
            "groupId": "1861b8d271314793a72be5252f386766",
            "id": "178da1561b0d45549b4f77cdca708e30",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": 1696673118000,
            "no": 1038,
            "name": "电压A相19次谐波",
            "groupId": "1861b8d271314793a72be5252f386766",
            "id": "5fe8b42c624b4886a3491e954abd1ba1",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": 1696673118000,
            "no": 1039,
            "name": "电压A相20次谐波",
            "groupId": "1861b8d271314793a72be5252f386766",
            "id": "b7273f6ba22a4d7290e3ac0a76ef7659",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": 1696673118000,
            "no": 1040,
            "name": "电压A相21次谐波",
            "groupId": "1861b8d271314793a72be5252f386766",
            "id": "121746c3f3b04048a7dd2b57d6421a2c",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": 1696673118000,
            "no": 1041,
            "name": "电压A相22次谐波",
            "groupId": "1861b8d271314793a72be5252f386766",
            "id": "3e3acec5957044afadc55e74600ccf4d",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": 1696673118000,
            "no": 1042,
            "name": "电压A相23次谐波",
            "groupId": "1861b8d271314793a72be5252f386766",
            "id": "1801b404554d403aa8a35a588bce606f",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": 1696673118000,
            "no": 1043,
            "name": "电压A相24次谐波",
            "groupId": "1861b8d271314793a72be5252f386766",
            "id": "b159162fb64f42d1bb6a95f9154d8d4d",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": 1696673118000,
            "no": 1044,
            "name": "电压A相25次谐波",
            "groupId": "1861b8d271314793a72be5252f386766",
            "id": "22be383e46514b188d0caa124400d5ce",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": 1696673118000,
            "no": 1045,
            "name": "电压A相26次谐波",
            "groupId": "1861b8d271314793a72be5252f386766",
            "id": "6157fea55e2442edac684d6974d4ac37",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": 1696673118000,
            "no": 1046,
            "name": "电压A相27次谐波",
            "groupId": "1861b8d271314793a72be5252f386766",
            "id": "13ba46804742469694876e0464ed3ab5",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": 1696673118000,
            "no": 1047,
            "name": "电压A相28次谐波",
            "groupId": "1861b8d271314793a72be5252f386766",
            "id": "6a372006998746cdbc347552cb78dd83",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": 1696673118000,
            "no": 1048,
            "name": "电压A相29次谐波",
            "groupId": "1861b8d271314793a72be5252f386766",
            "id": "4388e1d37a764f509c09581dea2b8a4c",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": 1696673118000,
            "no": 1049,
            "name": "电压A相30次谐波",
            "groupId": "1861b8d271314793a72be5252f386766",
            "id": "45b93e1f64254e53a507e2b2b49c3c40",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": 1696673118000,
            "no": 1050,
            "name": "电压A相31次谐波",
            "groupId": "1861b8d271314793a72be5252f386766",
            "id": "cec7cd23b6ef4ad9a63b585353be0702",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": 1696673118000,
            "no": 1051,
            "name": "电压A相32次谐波",
            "groupId": "1861b8d271314793a72be5252f386766",
            "id": "9c13c00c38e84d1988a623eab9ecba37",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": 1696673118000,
            "no": 1052,
            "name": "电压A相33次谐波",
            "groupId": "1861b8d271314793a72be5252f386766",
            "id": "28d03128f1974bd886b9584c31e3995d",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": 1696673119000,
            "no": 1053,
            "name": "电压A相34次谐波",
            "groupId": "1861b8d271314793a72be5252f386766",
            "id": "0469608d243243678c10034eeb78a37d",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": 1696673119000,
            "no": 1054,
            "name": "电压A相35次谐波",
            "groupId": "1861b8d271314793a72be5252f386766",
            "id": "f43fbbdc737b4683a51c0023374a5435",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": 1696673119000,
            "no": 1055,
            "name": "电压A相36次谐波",
            "groupId": "1861b8d271314793a72be5252f386766",
            "id": "2443bec31c7f4819baedd1303a35a019",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": 1696673119000,
            "no": 1056,
            "name": "电压A相37次谐波",
            "groupId": "1861b8d271314793a72be5252f386766",
            "id": "e8ded48234e14945971839e06d43fc79",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": 1696673119000,
            "no": 1057,
            "name": "电压A相38次谐波",
            "groupId": "1861b8d271314793a72be5252f386766",
            "id": "c70b3f01c0cc4cc0bc863a41c5404a9b",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": 1696673119000,
            "no": 1058,
            "name": "电压A相39次谐波",
            "groupId": "1861b8d271314793a72be5252f386766",
            "id": "0ef7ee90f9174260988728949f6cee85",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": 1696673119000,
            "no": 1059,
            "name": "电压A相40次谐波",
            "groupId": "1861b8d271314793a72be5252f386766",
            "id": "08e30118b73a400d899034c2143a191b",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": 1696673119000,
            "no": 1060,
            "name": "电压A相41次谐波",
            "groupId": "1861b8d271314793a72be5252f386766",
            "id": "478af2a864854f6599ee67a0911c2d6c",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": 1696673119000,
            "no": 1061,
            "name": "电压A相42次谐波",
            "groupId": "1861b8d271314793a72be5252f386766",
            "id": "ce1767af6a88423c8f369c9b7eabd071",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": 1696673119000,
            "no": 1062,
            "name": "电压A相43次谐波",
            "groupId": "1861b8d271314793a72be5252f386766",
            "id": "a2de3030006846acae6bdd4de36569f7",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": 1696673119000,
            "no": 1063,
            "name": "电压A相44次谐波",
            "groupId": "1861b8d271314793a72be5252f386766",
            "id": "e968fa584095416f8d001e167268e3d1",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": 1696673119000,
            "no": 1064,
            "name": "电压A相45次谐波",
            "groupId": "1861b8d271314793a72be5252f386766",
            "id": "29a5deb783804db8811b8cfdf43e3856",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": 1696673119000,
            "no": 1065,
            "name": "电压A相46次谐波",
            "groupId": "1861b8d271314793a72be5252f386766",
            "id": "6a9958254f914d8c95154ef430e5af1d",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": 1696673119000,
            "no": 1066,
            "name": "电压A相47次谐波",
            "groupId": "1861b8d271314793a72be5252f386766",
            "id": "831976595124414d8b2a03256293608f",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": 1696673119000,
            "no": 1067,
            "name": "电压A相48次谐波",
            "groupId": "1861b8d271314793a72be5252f386766",
            "id": "8897c82e5e634d20bd5662ec11b0d9fa",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": 1696673119000,
            "no": 1068,
            "name": "电压A相49次谐波",
            "groupId": "1861b8d271314793a72be5252f386766",
            "id": "08b154371f794e299ad9f2750414979b",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": 1696673253000,
            "no": 1069,
            "name": "电压A相50次谐波",
            "groupId": "1861b8d271314793a72be5252f386766",
            "id": "ffa780a79c7b4d8aa6bc91d52064c04a",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": 1696673396000,
            "no": 1070,
            "name": "电压B相2次谐波",
            "groupId": "d504fbb6930546e2984f86bc5896a2db",
            "id": "05f31da3d6d3423eb28406a0e8a9c2b3",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": 1696673396000,
            "no": 1071,
            "name": "电压B相3次谐波",
            "groupId": "d504fbb6930546e2984f86bc5896a2db",
            "id": "e5c8bb9782c5458eba8589029406d482",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": 1696673396000,
            "no": 1072,
            "name": "电压B相4次谐波",
            "groupId": "d504fbb6930546e2984f86bc5896a2db",
            "id": "bb18c67431034cabbe75b90cd9c1eb16",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": 1696673396000,
            "no": 1073,
            "name": "电压B相5次谐波",
            "groupId": "d504fbb6930546e2984f86bc5896a2db",
            "id": "e342da5819d1492e9855329661dffef4",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": 1696673396000,
            "no": 1074,
            "name": "电压B相6次谐波",
            "groupId": "d504fbb6930546e2984f86bc5896a2db",
            "id": "da0eeaab6c294018a2023e9ddff0c87a",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": 1696673396000,
            "no": 1075,
            "name": "电压B相7次谐波",
            "groupId": "d504fbb6930546e2984f86bc5896a2db",
            "id": "fb505adf5ca441eead5ed363f59ebc23",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": 1696673396000,
            "no": 1076,
            "name": "电压B相8次谐波",
            "groupId": "d504fbb6930546e2984f86bc5896a2db",
            "id": "6dd51de33f8244fc9c2b5d6e7cfe9d38",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": 1696673396000,
            "no": 1077,
            "name": "电压B相9次谐波",
            "groupId": "d504fbb6930546e2984f86bc5896a2db",
            "id": "2b4d26f20f1a49918bcf4a7fa00b4b7c",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": 1696673396000,
            "no": 1078,
            "name": "电压B相10次谐波",
            "groupId": "d504fbb6930546e2984f86bc5896a2db",
            "id": "4b0fb7100edf4f7ea5c2fe5eabef81ca",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": 1696673397000,
            "no": 1079,
            "name": "电压B相11次谐波",
            "groupId": "d504fbb6930546e2984f86bc5896a2db",
            "id": "ec5692c32c2b43ebba13437abe7c84b6",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": 1696673397000,
            "no": 1080,
            "name": "电压B相12次谐波",
            "groupId": "d504fbb6930546e2984f86bc5896a2db",
            "id": "d46a75063d414319990578e9c67567ca",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": 1696673397000,
            "no": 1081,
            "name": "电压B相13次谐波",
            "groupId": "d504fbb6930546e2984f86bc5896a2db",
            "id": "2b3c2b20b9444edfa1f1e94c9a6c63ba",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": 1696673397000,
            "no": 1082,
            "name": "电压B相14次谐波",
            "groupId": "d504fbb6930546e2984f86bc5896a2db",
            "id": "1517ee38fb34476e8a17e12a38508974",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": 1696673397000,
            "no": 1083,
            "name": "电压B相15次谐波",
            "groupId": "d504fbb6930546e2984f86bc5896a2db",
            "id": "e991ef85fa5345c0aecc0003f3eb98b7",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": 1696673397000,
            "no": 1084,
            "name": "电压B相16次谐波",
            "groupId": "d504fbb6930546e2984f86bc5896a2db",
            "id": "ea076ac654bb43aabfdb0d5dc911429e",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": 1696673397000,
            "no": 1085,
            "name": "电压B相17次谐波",
            "groupId": "d504fbb6930546e2984f86bc5896a2db",
            "id": "e71d21b657be459f842b5bedd6d17bc6",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": 1696673397000,
            "no": 1086,
            "name": "电压B相18次谐波",
            "groupId": "d504fbb6930546e2984f86bc5896a2db",
            "id": "54b5308005a0478e9c03b5f81640d336",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": 1696673397000,
            "no": 1087,
            "name": "电压B相19次谐波",
            "groupId": "d504fbb6930546e2984f86bc5896a2db",
            "id": "129fca9530354c6a94198dfe884d13f4",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": 1696673397000,
            "no": 1088,
            "name": "电压B相20次谐波",
            "groupId": "d504fbb6930546e2984f86bc5896a2db",
            "id": "546e9634c03b43b8ab70bbe80f23d598",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": 1696673397000,
            "no": 1089,
            "name": "电压B相21次谐波",
            "groupId": "d504fbb6930546e2984f86bc5896a2db",
            "id": "adfacc9e1c104c418d8e90bc722a159f",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": 1696673397000,
            "no": 1090,
            "name": "电压B相22次谐波",
            "groupId": "d504fbb6930546e2984f86bc5896a2db",
            "id": "213c474d1d9d492ab1eee002d955b344",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": 1696673397000,
            "no": 1091,
            "name": "电压B相23次谐波",
            "groupId": "d504fbb6930546e2984f86bc5896a2db",
            "id": "f0a9a500c4f44c53abc14af4c3cf0917",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": 1696673397000,
            "no": 1092,
            "name": "电压B相24次谐波",
            "groupId": "d504fbb6930546e2984f86bc5896a2db",
            "id": "996c73d3bd9b44228ddffd52187983c4",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": 1696673397000,
            "no": 1093,
            "name": "电压B相25次谐波",
            "groupId": "d504fbb6930546e2984f86bc5896a2db",
            "id": "470946a7362945839cf4908f31ff6660",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": 1696673397000,
            "no": 1094,
            "name": "电压B相26次谐波",
            "groupId": "d504fbb6930546e2984f86bc5896a2db",
            "id": "95c451277a01480fbb0d2854bc4365e9",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": 1696673397000,
            "no": 1095,
            "name": "电压B相27次谐波",
            "groupId": "d504fbb6930546e2984f86bc5896a2db",
            "id": "65cb0447b2594db7bc7aefd235240d56",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": 1696673398000,
            "no": 1096,
            "name": "电压B相28次谐波",
            "groupId": "d504fbb6930546e2984f86bc5896a2db",
            "id": "a1f4248d69b84e77a79b617fdccb2a38",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": 1696673398000,
            "no": 1097,
            "name": "电压B相29次谐波",
            "groupId": "d504fbb6930546e2984f86bc5896a2db",
            "id": "41c4724c5c4a4d84845a08918786ac36",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": 1696673398000,
            "no": 1098,
            "name": "电压B相30次谐波",
            "groupId": "d504fbb6930546e2984f86bc5896a2db",
            "id": "b3abff0c87a34178a0a02b4964cc49d4",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": 1696673398000,
            "no": 1099,
            "name": "电压B相31次谐波",
            "groupId": "d504fbb6930546e2984f86bc5896a2db",
            "id": "1199cb90b71c470da34364f08412c8ca",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": 1696673398000,
            "no": 1100,
            "name": "电压B相32次谐波",
            "groupId": "d504fbb6930546e2984f86bc5896a2db",
            "id": "10cc9b5fc9f54ca6990dec5fb16eb3f0",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": 1696673398000,
            "no": 1101,
            "name": "电压B相33次谐波",
            "groupId": "d504fbb6930546e2984f86bc5896a2db",
            "id": "b6bdec76f1ae41129abdc483920deb1f",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": 1696673398000,
            "no": 1102,
            "name": "电压B相34次谐波",
            "groupId": "d504fbb6930546e2984f86bc5896a2db",
            "id": "372f9d650cc14b1596e3aae0d1dc4f7a",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": 1696673398000,
            "no": 1103,
            "name": "电压B相35次谐波",
            "groupId": "d504fbb6930546e2984f86bc5896a2db",
            "id": "5749a346617c4722b6fe7fedc5f5be56",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": 1696673398000,
            "no": 1104,
            "name": "电压B相36次谐波",
            "groupId": "d504fbb6930546e2984f86bc5896a2db",
            "id": "a2ef4ff7aea848499600920487f7b61f",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": 1696673398000,
            "no": 1105,
            "name": "电压B相37次谐波",
            "groupId": "d504fbb6930546e2984f86bc5896a2db",
            "id": "fa0d46f1722f4345a4bdd0b6ac4105ff",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": 1696673398000,
            "no": 1106,
            "name": "电压B相38次谐波",
            "groupId": "d504fbb6930546e2984f86bc5896a2db",
            "id": "40e7874a0f3041e9ab7864592af72fc1",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": 1696673398000,
            "no": 1107,
            "name": "电压B相39次谐波",
            "groupId": "d504fbb6930546e2984f86bc5896a2db",
            "id": "f0ff3247f31140d192756a6865b1d882",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": 1696673398000,
            "no": 1108,
            "name": "电压B相40次谐波",
            "groupId": "d504fbb6930546e2984f86bc5896a2db",
            "id": "63b37e7a608d4ccab1ada73a73409ee3",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": 1696673398000,
            "no": 1109,
            "name": "电压B相41次谐波",
            "groupId": "d504fbb6930546e2984f86bc5896a2db",
            "id": "608bcaa7a9df4d0aa16ba07a850da6bc",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": 1696673398000,
            "no": 1110,
            "name": "电压B相42次谐波",
            "groupId": "d504fbb6930546e2984f86bc5896a2db",
            "id": "e578547dc9324703a0f51bb397878316",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": 1696673399000,
            "no": 1111,
            "name": "电压B相43次谐波",
            "groupId": "d504fbb6930546e2984f86bc5896a2db",
            "id": "8a8e499206c3413aa6cf0f1c6c6b28db",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": 1696673399000,
            "no": 1112,
            "name": "电压B相44次谐波",
            "groupId": "d504fbb6930546e2984f86bc5896a2db",
            "id": "961b1fcec078497385b81a2e9f392f1d",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": 1696673399000,
            "no": 1113,
            "name": "电压B相45次谐波",
            "groupId": "d504fbb6930546e2984f86bc5896a2db",
            "id": "84eda566e9d84cee88ab1297d410ab6b",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": 1696673399000,
            "no": 1114,
            "name": "电压B相46次谐波",
            "groupId": "d504fbb6930546e2984f86bc5896a2db",
            "id": "036650001e0d4243a9f69fca25d7d091",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": 1696673399000,
            "no": 1115,
            "name": "电压B相47次谐波",
            "groupId": "d504fbb6930546e2984f86bc5896a2db",
            "id": "194cf19278e247a9813092e3e88656db",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": 1696673399000,
            "no": 1116,
            "name": "电压B相48次谐波",
            "groupId": "d504fbb6930546e2984f86bc5896a2db",
            "id": "3379e812e4194c12b040782fc978576a",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": 1696673399000,
            "no": 1117,
            "name": "电压B相49次谐波",
            "groupId": "d504fbb6930546e2984f86bc5896a2db",
            "id": "39be10ffe7d0430580d181507687189f",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": 1696673399000,
            "no": 1118,
            "name": "电压B相50次谐波",
            "groupId": "d504fbb6930546e2984f86bc5896a2db",
            "id": "596c33ed38d84e68a8dc61320b90e485",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": 1696673471000,
            "no": 1119,
            "name": "电压C相2次谐波",
            "groupId": "4d1674e52604433b95b3ada0db0aef29",
            "id": "3733b4f589fd4ea0b64d2966359977c4",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": 1696673471000,
            "no": 1120,
            "name": "电压C相3次谐波",
            "groupId": "4d1674e52604433b95b3ada0db0aef29",
            "id": "3e354ae392214d3bbd41800abf74aa34",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": 1696673471000,
            "no": 1121,
            "name": "电压C相4次谐波",
            "groupId": "4d1674e52604433b95b3ada0db0aef29",
            "id": "0b72baf98bf74c9c9609af1f6cb30508",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": 1696673471000,
            "no": 1122,
            "name": "电压C相5次谐波",
            "groupId": "4d1674e52604433b95b3ada0db0aef29",
            "id": "2df648de8f6e4c36b0613416ce9b2a24",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": 1696673471000,
            "no": 1123,
            "name": "电压C相6次谐波",
            "groupId": "4d1674e52604433b95b3ada0db0aef29",
            "id": "fa4e326f6d794d2fb275c9568e27bdcf",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": 1696673471000,
            "no": 1124,
            "name": "电压C相7次谐波",
            "groupId": "4d1674e52604433b95b3ada0db0aef29",
            "id": "9f396dec672241bc9ba1917ef95dc608",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": 1696673472000,
            "no": 1125,
            "name": "电压C相8次谐波",
            "groupId": "4d1674e52604433b95b3ada0db0aef29",
            "id": "33ce71ac705442ae999ce693156a37ec",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": 1696673472000,
            "no": 1126,
            "name": "电压C相9次谐波",
            "groupId": "4d1674e52604433b95b3ada0db0aef29",
            "id": "b0053eb35542422583428f2d754ec7ea",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": 1696673472000,
            "no": 1127,
            "name": "电压C相10次谐波",
            "groupId": "4d1674e52604433b95b3ada0db0aef29",
            "id": "43af5f80106c48638cc859fe1a85b74a",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": 1696673472000,
            "no": 1128,
            "name": "电压C相11次谐波",
            "groupId": "4d1674e52604433b95b3ada0db0aef29",
            "id": "7ec0a4992f564d3d9918c9de659c21f0",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": 1696673472000,
            "no": 1129,
            "name": "电压C相12次谐波",
            "groupId": "4d1674e52604433b95b3ada0db0aef29",
            "id": "7db6dcc62e03490eb57d69477a14405e",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": 1696673472000,
            "no": 1130,
            "name": "电压C相13次谐波",
            "groupId": "4d1674e52604433b95b3ada0db0aef29",
            "id": "e50df3c7e450499c8887a93c7f181f5d",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": 1696673472000,
            "no": 1131,
            "name": "电压C相14次谐波",
            "groupId": "4d1674e52604433b95b3ada0db0aef29",
            "id": "f9420907968f40768e8a8e3a387525c0",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": 1696673472000,
            "no": 1132,
            "name": "电压C相15次谐波",
            "groupId": "4d1674e52604433b95b3ada0db0aef29",
            "id": "fac439034ac44fe3b09a44cb9d9084c3",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": 1696673472000,
            "no": 1133,
            "name": "电压C相16次谐波",
            "groupId": "4d1674e52604433b95b3ada0db0aef29",
            "id": "bdb278d41014483294a97a1aa4d6bca1",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": 1696673472000,
            "no": 1134,
            "name": "电压C相17次谐波",
            "groupId": "4d1674e52604433b95b3ada0db0aef29",
            "id": "cb8e63edbea34d459e40d776f0c9d641",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": 1696673472000,
            "no": 1135,
            "name": "电压C相18次谐波",
            "groupId": "4d1674e52604433b95b3ada0db0aef29",
            "id": "a635447b984445649073fc3a494725d5",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": 1696673472000,
            "no": 1136,
            "name": "电压C相19次谐波",
            "groupId": "4d1674e52604433b95b3ada0db0aef29",
            "id": "507f92da7b1347ef88129a7e63185b88",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": 1696673472000,
            "no": 1137,
            "name": "电压C相20次谐波",
            "groupId": "4d1674e52604433b95b3ada0db0aef29",
            "id": "533cf2c6df60454ea4499973472e7a1e",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": 1696673472000,
            "no": 1138,
            "name": "电压C相21次谐波",
            "groupId": "4d1674e52604433b95b3ada0db0aef29",
            "id": "c865daa9d99343f68019e12e1458d2ca",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": 1696673473000,
            "no": 1139,
            "name": "电压C相22次谐波",
            "groupId": "4d1674e52604433b95b3ada0db0aef29",
            "id": "5701c1a0d48a4cbca54d6e4708ff6ed3",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": 1696673473000,
            "no": 1140,
            "name": "电压C相23次谐波",
            "groupId": "4d1674e52604433b95b3ada0db0aef29",
            "id": "d9401d9b15f046f9915dd6d6c9e24c63",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": 1696673473000,
            "no": 1141,
            "name": "电压C相24次谐波",
            "groupId": "4d1674e52604433b95b3ada0db0aef29",
            "id": "69fc9584b89f4d57a352b46c9cf66afb",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": 1696673473000,
            "no": 1142,
            "name": "电压C相25次谐波",
            "groupId": "4d1674e52604433b95b3ada0db0aef29",
            "id": "6a4c523492174d12a8982fe5949a16c9",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": 1696673473000,
            "no": 1143,
            "name": "电压C相26次谐波",
            "groupId": "4d1674e52604433b95b3ada0db0aef29",
            "id": "17715fc590ce4906b21093cfa1ead77b",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": 1696673473000,
            "no": 1144,
            "name": "电压C相27次谐波",
            "groupId": "4d1674e52604433b95b3ada0db0aef29",
            "id": "06ead131968049429d9a5f36bd9cd944",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": 1696673473000,
            "no": 1145,
            "name": "电压C相28次谐波",
            "groupId": "4d1674e52604433b95b3ada0db0aef29",
            "id": "1fa936b1de254262b0e49dc737374500",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": 1696673473000,
            "no": 1146,
            "name": "电压C相29次谐波",
            "groupId": "4d1674e52604433b95b3ada0db0aef29",
            "id": "a4aa5b28a2cf452a972fbb3680691540",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": 1696673473000,
            "no": 1147,
            "name": "电压C相30次谐波",
            "groupId": "4d1674e52604433b95b3ada0db0aef29",
            "id": "5591e16416e04c15b758d3257a1f063d",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": 1696673473000,
            "no": 1148,
            "name": "电压C相31次谐波",
            "groupId": "4d1674e52604433b95b3ada0db0aef29",
            "id": "bd1f1a69b2974864bde8022167ecf208",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": 1696673473000,
            "no": 1149,
            "name": "电压C相32次谐波",
            "groupId": "4d1674e52604433b95b3ada0db0aef29",
            "id": "80164ce765af46b2a2832fd3240fa66f",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": 1696673473000,
            "no": 1150,
            "name": "电压C相33次谐波",
            "groupId": "4d1674e52604433b95b3ada0db0aef29",
            "id": "7342330617914fa5ab08151f75dcb6bd",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": 1696673473000,
            "no": 1151,
            "name": "电压C相34次谐波",
            "groupId": "4d1674e52604433b95b3ada0db0aef29",
            "id": "a209560c320a4a5685f72986057aba29",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": 1696673473000,
            "no": 1152,
            "name": "电压C相35次谐波",
            "groupId": "4d1674e52604433b95b3ada0db0aef29",
            "id": "7e96d934cf534c629bd579fbc05ec21f",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": 1696673473000,
            "no": 1153,
            "name": "电压C相36次谐波",
            "groupId": "4d1674e52604433b95b3ada0db0aef29",
            "id": "0eb92b5573194e2fa51f5d748b20caca",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": 1696673473000,
            "no": 1154,
            "name": "电压C相37次谐波",
            "groupId": "4d1674e52604433b95b3ada0db0aef29",
            "id": "97f5a55e6f064a81b0a5f9d0adce524f",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": 1696673473000,
            "no": 1155,
            "name": "电压C相38次谐波",
            "groupId": "4d1674e52604433b95b3ada0db0aef29",
            "id": "9a6059b739d248de8eb22195770772b3",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": 1696673473000,
            "no": 1156,
            "name": "电压C相39次谐波",
            "groupId": "4d1674e52604433b95b3ada0db0aef29",
            "id": "7ecbfcc7704a44548dfe2bf9daaa15f4",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": 1696673473000,
            "no": 1157,
            "name": "电压C相40次谐波",
            "groupId": "4d1674e52604433b95b3ada0db0aef29",
            "id": "aec14038d7544bdfaa1780fe7baaf98b",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": 1696673474000,
            "no": 1158,
            "name": "电压C相41次谐波",
            "groupId": "4d1674e52604433b95b3ada0db0aef29",
            "id": "fc99b5e0548f4899aed9c920390a2d20",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": 1696673474000,
            "no": 1159,
            "name": "电压C相42次谐波",
            "groupId": "4d1674e52604433b95b3ada0db0aef29",
            "id": "b3490aeba8d64c33aaaea686eee875c5",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": 1696673474000,
            "no": 1160,
            "name": "电压C相43次谐波",
            "groupId": "4d1674e52604433b95b3ada0db0aef29",
            "id": "d414e30c2fad469080ccf01a69cf38a7",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": 1696673474000,
            "no": 1161,
            "name": "电压C相44次谐波",
            "groupId": "4d1674e52604433b95b3ada0db0aef29",
            "id": "d73e78d32c6a4617b1eb25ef7fcad5d8",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": 1696673474000,
            "no": 1162,
            "name": "电压C相45次谐波",
            "groupId": "4d1674e52604433b95b3ada0db0aef29",
            "id": "f12f985e48b44f399ae74492ada949b3",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": 1696673474000,
            "no": 1163,
            "name": "电压C相46次谐波",
            "groupId": "4d1674e52604433b95b3ada0db0aef29",
            "id": "7d26864ab3164be398c5b562dfd16cfc",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": 1696673474000,
            "no": 1164,
            "name": "电压C相47次谐波",
            "groupId": "4d1674e52604433b95b3ada0db0aef29",
            "id": "81408036935543fab8afcfb54800f386",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": 1696673474000,
            "no": 1165,
            "name": "电压C相48次谐波",
            "groupId": "4d1674e52604433b95b3ada0db0aef29",
            "id": "a5c9bdde311c43038b85f09ab1ef88cf",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": 1696673474000,
            "no": 1166,
            "name": "电压C相49次谐波",
            "groupId": "4d1674e52604433b95b3ada0db0aef29",
            "id": "39da093277404f2ebb0a4be143c95f20",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": 1696673474000,
            "no": 1167,
            "name": "电压C相50次谐波",
            "groupId": "4d1674e52604433b95b3ada0db0aef29",
            "id": "d4b94fc0bbed47beb76dd0195ff148ef",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": 1696673573000,
            "no": 1168,
            "name": "电流A相2次谐波",
            "groupId": "65c7f6462ed84cda924220feeab96713",
            "id": "0ba9a7f5be0a46238d9c7f2454d68f28",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": 1696673573000,
            "no": 1169,
            "name": "电流A相3次谐波",
            "groupId": "65c7f6462ed84cda924220feeab96713",
            "id": "a3b3cae58d6842c3b7ac9be456aae921",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": 1696673573000,
            "no": 1170,
            "name": "电流A相4次谐波",
            "groupId": "65c7f6462ed84cda924220feeab96713",
            "id": "f84eaf5aba2e4c2c9bd2d686746ea316",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": 1696673573000,
            "no": 1171,
            "name": "电流A相5次谐波",
            "groupId": "65c7f6462ed84cda924220feeab96713",
            "id": "8e96e37fca9f4afbb9afa43c3ebd54b2",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": 1696673574000,
            "no": 1172,
            "name": "电流A相6次谐波",
            "groupId": "65c7f6462ed84cda924220feeab96713",
            "id": "d0134b44a7b548079ffc84fe5669300c",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": 1696673574000,
            "no": 1173,
            "name": "电流A相7次谐波",
            "groupId": "65c7f6462ed84cda924220feeab96713",
            "id": "891f0158b0a643439f843bd6780ac787",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": 1696673574000,
            "no": 1174,
            "name": "电流A相8次谐波",
            "groupId": "65c7f6462ed84cda924220feeab96713",
            "id": "123d84c5ce5646d9900772a854ff42b6",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": 1696673574000,
            "no": 1175,
            "name": "电流A相9次谐波",
            "groupId": "65c7f6462ed84cda924220feeab96713",
            "id": "368cf0d884ff422096fb9f529e2fc910",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": 1696673574000,
            "no": 1176,
            "name": "电流A相10次谐波",
            "groupId": "65c7f6462ed84cda924220feeab96713",
            "id": "35fa188093f642ada15360488f09ac3e",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": 1696673574000,
            "no": 1177,
            "name": "电流A相11次谐波",
            "groupId": "65c7f6462ed84cda924220feeab96713",
            "id": "dba8946eedaa4d1683f6e237244388bc",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": 1696673574000,
            "no": 1178,
            "name": "电流A相12次谐波",
            "groupId": "65c7f6462ed84cda924220feeab96713",
            "id": "349a662018de4f23b6818fdeaacba62b",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": 1696673574000,
            "no": 1179,
            "name": "电流A相13次谐波",
            "groupId": "65c7f6462ed84cda924220feeab96713",
            "id": "87cb4f613615417ba79d987866675bf2",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": 1696673574000,
            "no": 1180,
            "name": "电流A相14次谐波",
            "groupId": "65c7f6462ed84cda924220feeab96713",
            "id": "badb41438a294772acfc5b461f1a8fdd",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": 1696673574000,
            "no": 1181,
            "name": "电流A相15次谐波",
            "groupId": "65c7f6462ed84cda924220feeab96713",
            "id": "02efb1e5447049f09297cb908ca53fe3",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": 1696673574000,
            "no": 1182,
            "name": "电流A相16次谐波",
            "groupId": "65c7f6462ed84cda924220feeab96713",
            "id": "9fbca4d546ce4b40afdfafdb119e8cbc",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": 1696673574000,
            "no": 1183,
            "name": "电流A相17次谐波",
            "groupId": "65c7f6462ed84cda924220feeab96713",
            "id": "b8be2a8e676b4bc690c6c3056d91742e",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": 1696673574000,
            "no": 1184,
            "name": "电流A相18次谐波",
            "groupId": "65c7f6462ed84cda924220feeab96713",
            "id": "f59c72f48ed84eaeaa05f9cde0f8b079",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": 1696673574000,
            "no": 1185,
            "name": "电流A相19次谐波",
            "groupId": "65c7f6462ed84cda924220feeab96713",
            "id": "c0de20d2ca4c44dea0ac81a197383b7e",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": 1696673574000,
            "no": 1186,
            "name": "电流A相20次谐波",
            "groupId": "65c7f6462ed84cda924220feeab96713",
            "id": "48af3c7aac1b4d55a543e9b3c66edcb4",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": 1696673574000,
            "no": 1187,
            "name": "电流A相21次谐波",
            "groupId": "65c7f6462ed84cda924220feeab96713",
            "id": "9810de49657e44d89e1014779e5452ef",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": 1696673574000,
            "no": 1188,
            "name": "电流A相22次谐波",
            "groupId": "65c7f6462ed84cda924220feeab96713",
            "id": "52fcfa5244f84fdea30f7906eaab3865",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": 1696673575000,
            "no": 1189,
            "name": "电流A相23次谐波",
            "groupId": "65c7f6462ed84cda924220feeab96713",
            "id": "a7b90ffd5c184dcf9039d93b663b1583",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": 1696673575000,
            "no": 1190,
            "name": "电流A相24次谐波",
            "groupId": "65c7f6462ed84cda924220feeab96713",
            "id": "5508ab91466646589d17ab99edee3efe",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": 1696673575000,
            "no": 1191,
            "name": "电流A相25次谐波",
            "groupId": "65c7f6462ed84cda924220feeab96713",
            "id": "004f155559cd41828b55810dab3894aa",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": 1696673575000,
            "no": 1192,
            "name": "电流A相26次谐波",
            "groupId": "65c7f6462ed84cda924220feeab96713",
            "id": "93bd4046c5064c939fdac389fa78273f",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": 1696673575000,
            "no": 1193,
            "name": "电流A相27次谐波",
            "groupId": "65c7f6462ed84cda924220feeab96713",
            "id": "4c0bfb2620f248dc89d51ff2df42095a",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": 1696673575000,
            "no": 1194,
            "name": "电流A相28次谐波",
            "groupId": "65c7f6462ed84cda924220feeab96713",
            "id": "002971e0ef86438e86e7f5421109d7ca",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": 1696673575000,
            "no": 1195,
            "name": "电流A相29次谐波",
            "groupId": "65c7f6462ed84cda924220feeab96713",
            "id": "e45bc31e09274f9eac4a6b2674cd6520",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": 1696673575000,
            "no": 1196,
            "name": "电流A相30次谐波",
            "groupId": "65c7f6462ed84cda924220feeab96713",
            "id": "aaa51378b1414b1fb7ea794a71cac1f8",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": 1696673575000,
            "no": 1197,
            "name": "电流A相31次谐波",
            "groupId": "65c7f6462ed84cda924220feeab96713",
            "id": "49dda029669444b894cb006a2f28e08d",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": 1696673575000,
            "no": 1198,
            "name": "电流A相32次谐波",
            "groupId": "65c7f6462ed84cda924220feeab96713",
            "id": "b25f86253f984959953edd66d9c77594",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": 1696673575000,
            "no": 1199,
            "name": "电流A相33次谐波",
            "groupId": "65c7f6462ed84cda924220feeab96713",
            "id": "ef0199fe42c6410eb8816818307bf71a",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": 1696673575000,
            "no": 1200,
            "name": "电流A相34次谐波",
            "groupId": "65c7f6462ed84cda924220feeab96713",
            "id": "e0256beae7124996beacb5af1e518f96",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": 1696673575000,
            "no": 1201,
            "name": "电流A相35次谐波",
            "groupId": "65c7f6462ed84cda924220feeab96713",
            "id": "7c1c4f3c06064e9fb0f14abd2966924f",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": 1696673575000,
            "no": 1202,
            "name": "电流A相36次谐波",
            "groupId": "65c7f6462ed84cda924220feeab96713",
            "id": "0e3c82093167402ea2883e533eec90e9",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": 1696673575000,
            "no": 1203,
            "name": "电流A相37次谐波",
            "groupId": "65c7f6462ed84cda924220feeab96713",
            "id": "319dd863ecf849fb9046b9dfe332b23e",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": 1696673576000,
            "no": 1204,
            "name": "电流A相38次谐波",
            "groupId": "65c7f6462ed84cda924220feeab96713",
            "id": "0f91b7864ef04c16830dbcb756ea1c4d",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": 1696673576000,
            "no": 1205,
            "name": "电流A相39次谐波",
            "groupId": "65c7f6462ed84cda924220feeab96713",
            "id": "c1f4f1e001594a2e9a950ee5bd9c0d07",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": 1696673576000,
            "no": 1206,
            "name": "电流A相40次谐波",
            "groupId": "65c7f6462ed84cda924220feeab96713",
            "id": "2122cb9f96a14490a9a77b04cf4447bf",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": 1696673576000,
            "no": 1207,
            "name": "电流A相41次谐波",
            "groupId": "65c7f6462ed84cda924220feeab96713",
            "id": "25d9d4ffe3c44775bab9584632828d4a",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": 1696673576000,
            "no": 1208,
            "name": "电流A相42次谐波",
            "groupId": "65c7f6462ed84cda924220feeab96713",
            "id": "a2bcc0523b99489aa47eefb91738eff4",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": 1696673576000,
            "no": 1209,
            "name": "电流A相43次谐波",
            "groupId": "65c7f6462ed84cda924220feeab96713",
            "id": "444527d15ad34301a8e9136bb216cfb0",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": 1696673576000,
            "no": 1210,
            "name": "电流A相44次谐波",
            "groupId": "65c7f6462ed84cda924220feeab96713",
            "id": "00ff4e93fe944402bd2a5680f5f90d0e",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": 1696673576000,
            "no": 1211,
            "name": "电流A相45次谐波",
            "groupId": "65c7f6462ed84cda924220feeab96713",
            "id": "357789c2c6b944ef816fea41c8e2fada",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": 1696673576000,
            "no": 1212,
            "name": "电流A相46次谐波",
            "groupId": "65c7f6462ed84cda924220feeab96713",
            "id": "41ffde5b6e2c40d8979b4a38618c19e5",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": 1696673576000,
            "no": 1213,
            "name": "电流A相47次谐波",
            "groupId": "65c7f6462ed84cda924220feeab96713",
            "id": "67b1c746306c463ea51cd9e98c5b00bf",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": 1696673576000,
            "no": 1214,
            "name": "电流A相48次谐波",
            "groupId": "65c7f6462ed84cda924220feeab96713",
            "id": "4459f8aa132047fcb05100e2753ba31d",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": 1696673576000,
            "no": 1215,
            "name": "电流A相49次谐波",
            "groupId": "65c7f6462ed84cda924220feeab96713",
            "id": "feaba6aecfb94a1fa53b013c402a4bca",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": 1696673576000,
            "no": 1216,
            "name": "电流A相50次谐波",
            "groupId": "65c7f6462ed84cda924220feeab96713",
            "id": "a16f6f2b29084c6c9d1aa660550017db",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": 1696673627000,
            "no": 1217,
            "name": "电流B相2次谐波",
            "groupId": "0b4e1c9866f447bbb4367a83dc139d26",
            "id": "dd7a64e37d784ddb953cccdfba4fa40a",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": 1696673627000,
            "no": 1218,
            "name": "电流B相3次谐波",
            "groupId": "0b4e1c9866f447bbb4367a83dc139d26",
            "id": "cbaddc37b8254c5cbf3fd0e6a75f3cf4",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": 1696673627000,
            "no": 1219,
            "name": "电流B相4次谐波",
            "groupId": "0b4e1c9866f447bbb4367a83dc139d26",
            "id": "7b0b2f968d2c490582b7e7e26512e3b9",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": 1696673627000,
            "no": 1220,
            "name": "电流B相5次谐波",
            "groupId": "0b4e1c9866f447bbb4367a83dc139d26",
            "id": "ebdbdddccb464d1d93d71a754f99e5ba",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": 1696673627000,
            "no": 1221,
            "name": "电流B相6次谐波",
            "groupId": "0b4e1c9866f447bbb4367a83dc139d26",
            "id": "a2e60e3a5a094dd184035999214a51c8",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": 1696673627000,
            "no": 1222,
            "name": "电流B相7次谐波",
            "groupId": "0b4e1c9866f447bbb4367a83dc139d26",
            "id": "efc64d359b4a42dfb081597685d3ca63",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": 1696673627000,
            "no": 1223,
            "name": "电流B相8次谐波",
            "groupId": "0b4e1c9866f447bbb4367a83dc139d26",
            "id": "91d45bb3012d45d180f11480c4e58cbe",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": 1696673627000,
            "no": 1224,
            "name": "电流B相9次谐波",
            "groupId": "0b4e1c9866f447bbb4367a83dc139d26",
            "id": "febbff1a5a9f47cebc159f8bf5961294",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": 1696673627000,
            "no": 1225,
            "name": "电流B相10次谐波",
            "groupId": "0b4e1c9866f447bbb4367a83dc139d26",
            "id": "aa0a3da59a544611928be51c7c9bc79f",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": 1696673627000,
            "no": 1226,
            "name": "电流B相11次谐波",
            "groupId": "0b4e1c9866f447bbb4367a83dc139d26",
            "id": "c153fb3a53e149f9970c41f9ba8d4d68",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": 1696673627000,
            "no": 1227,
            "name": "电流B相12次谐波",
            "groupId": "0b4e1c9866f447bbb4367a83dc139d26",
            "id": "9774d140ed41422693ec258deef0c8bd",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": 1696673627000,
            "no": 1228,
            "name": "电流B相13次谐波",
            "groupId": "0b4e1c9866f447bbb4367a83dc139d26",
            "id": "25956810a64647e394416f94ab9dd2ab",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": 1696673627000,
            "no": 1229,
            "name": "电流B相14次谐波",
            "groupId": "0b4e1c9866f447bbb4367a83dc139d26",
            "id": "a29b57ca6b2b4a6d88707f7902766b67",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": 1696673627000,
            "no": 1230,
            "name": "电流B相15次谐波",
            "groupId": "0b4e1c9866f447bbb4367a83dc139d26",
            "id": "42edf9c4819044979694b27bacaef62b",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": 1696673627000,
            "no": 1231,
            "name": "电流B相16次谐波",
            "groupId": "0b4e1c9866f447bbb4367a83dc139d26",
            "id": "81c064f9ad4643a2b5ecb2071f4e4d66",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": 1696673627000,
            "no": 1232,
            "name": "电流B相17次谐波",
            "groupId": "0b4e1c9866f447bbb4367a83dc139d26",
            "id": "3b21f16758554580b059ded742a5f3ba",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": 1696673628000,
            "no": 1233,
            "name": "电流B相18次谐波",
            "groupId": "0b4e1c9866f447bbb4367a83dc139d26",
            "id": "a1845c4f191c4ff19a961aceeedb2248",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": 1696673628000,
            "no": 1234,
            "name": "电流B相19次谐波",
            "groupId": "0b4e1c9866f447bbb4367a83dc139d26",
            "id": "81945d3f344b4639a4f0e0a896624561",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": 1696673628000,
            "no": 1235,
            "name": "电流B相20次谐波",
            "groupId": "0b4e1c9866f447bbb4367a83dc139d26",
            "id": "8d9a1dc25aae4b789d14d8095a9bf0fb",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": 1696673628000,
            "no": 1236,
            "name": "电流B相21次谐波",
            "groupId": "0b4e1c9866f447bbb4367a83dc139d26",
            "id": "5560bab79d9c47a1a4e2f6219f6a7dbe",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": 1696673628000,
            "no": 1237,
            "name": "电流B相22次谐波",
            "groupId": "0b4e1c9866f447bbb4367a83dc139d26",
            "id": "ca035e17bc564d2d9d44d2c702d2e04d",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": 1696673628000,
            "no": 1238,
            "name": "电流B相23次谐波",
            "groupId": "0b4e1c9866f447bbb4367a83dc139d26",
            "id": "ee8cd382fd92404d97628aa501c734fe",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": 1696673628000,
            "no": 1239,
            "name": "电流B相24次谐波",
            "groupId": "0b4e1c9866f447bbb4367a83dc139d26",
            "id": "f27261a8666840089e62dd525faa0739",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": 1696673628000,
            "no": 1240,
            "name": "电流B相25次谐波",
            "groupId": "0b4e1c9866f447bbb4367a83dc139d26",
            "id": "1258e47c1eee42e1985e69fbbd16f037",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": 1696673628000,
            "no": 1241,
            "name": "电流B相26次谐波",
            "groupId": "0b4e1c9866f447bbb4367a83dc139d26",
            "id": "a8583c1e95314b168c3ecdcba016a514",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": 1696673628000,
            "no": 1242,
            "name": "电流B相27次谐波",
            "groupId": "0b4e1c9866f447bbb4367a83dc139d26",
            "id": "9ab82ffb5a7d4edb94b88d4d66233316",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": 1696673628000,
            "no": 1243,
            "name": "电流B相28次谐波",
            "groupId": "0b4e1c9866f447bbb4367a83dc139d26",
            "id": "1877ad36b3774b318710f7dd9e43ccfc",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": 1696673628000,
            "no": 1244,
            "name": "电流B相29次谐波",
            "groupId": "0b4e1c9866f447bbb4367a83dc139d26",
            "id": "adbed88f0ad64ca2abc10a9124a26140",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": 1696673628000,
            "no": 1245,
            "name": "电流B相30次谐波",
            "groupId": "0b4e1c9866f447bbb4367a83dc139d26",
            "id": "50e1e06854e64c3eb933b212429475df",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": 1696673628000,
            "no": 1246,
            "name": "电流B相31次谐波",
            "groupId": "0b4e1c9866f447bbb4367a83dc139d26",
            "id": "32617a22966c42b4bb5642a792b05861",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": 1696673628000,
            "no": 1247,
            "name": "电流B相32次谐波",
            "groupId": "0b4e1c9866f447bbb4367a83dc139d26",
            "id": "eda15290931f4c69a1cdcec694ce041a",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": 1696673628000,
            "no": 1248,
            "name": "电流B相33次谐波",
            "groupId": "0b4e1c9866f447bbb4367a83dc139d26",
            "id": "26de7b4e495c44e18583ab31b38305be",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": 1696673628000,
            "no": 1249,
            "name": "电流B相34次谐波",
            "groupId": "0b4e1c9866f447bbb4367a83dc139d26",
            "id": "cf83b84f0d384f5aac25849ef3233824",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": 1696673628000,
            "no": 1250,
            "name": "电流B相35次谐波",
            "groupId": "0b4e1c9866f447bbb4367a83dc139d26",
            "id": "bcdc7620fb2e47f0b698d5f84f1ce1cd",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": 1696673629000,
            "no": 1251,
            "name": "电流B相36次谐波",
            "groupId": "0b4e1c9866f447bbb4367a83dc139d26",
            "id": "f587215a2b574ea7b5e7eb85b527d172",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": 1696673629000,
            "no": 1252,
            "name": "电流B相37次谐波",
            "groupId": "0b4e1c9866f447bbb4367a83dc139d26",
            "id": "c44e941fa5424402b2bbb540581af8a6",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": 1696673629000,
            "no": 1253,
            "name": "电流B相38次谐波",
            "groupId": "0b4e1c9866f447bbb4367a83dc139d26",
            "id": "d7acb35c3fd3408786ab51609de2ad85",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": 1696673629000,
            "no": 1254,
            "name": "电流B相39次谐波",
            "groupId": "0b4e1c9866f447bbb4367a83dc139d26",
            "id": "96396dd3871948b5afe390ed61c5a4e0",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": 1696673629000,
            "no": 1255,
            "name": "电流B相40次谐波",
            "groupId": "0b4e1c9866f447bbb4367a83dc139d26",
            "id": "ba3ad7dd01984b6ab60237ba14040cf8",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": 1696673629000,
            "no": 1256,
            "name": "电流B相41次谐波",
            "groupId": "0b4e1c9866f447bbb4367a83dc139d26",
            "id": "fdb250ca61ec4550aa4e11eb5518d628",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": 1696673629000,
            "no": 1257,
            "name": "电流B相42次谐波",
            "groupId": "0b4e1c9866f447bbb4367a83dc139d26",
            "id": "f956ca2826fc4871a573864214ee9b96",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": 1696673629000,
            "no": 1258,
            "name": "电流B相43次谐波",
            "groupId": "0b4e1c9866f447bbb4367a83dc139d26",
            "id": "89ae7ffd68c74e80bd3305dfe9f33d15",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": 1696673629000,
            "no": 1259,
            "name": "电流B相44次谐波",
            "groupId": "0b4e1c9866f447bbb4367a83dc139d26",
            "id": "d6150fd5a15541afade3adb42c40a044",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": 1696673629000,
            "no": 1260,
            "name": "电流B相45次谐波",
            "groupId": "0b4e1c9866f447bbb4367a83dc139d26",
            "id": "13b2fcdeea764aca9ebe1cc2b4c8fc56",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": 1696673629000,
            "no": 1261,
            "name": "电流B相46次谐波",
            "groupId": "0b4e1c9866f447bbb4367a83dc139d26",
            "id": "56816849c5414ae390977eb2386967d1",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": 1696673629000,
            "no": 1262,
            "name": "电流B相47次谐波",
            "groupId": "0b4e1c9866f447bbb4367a83dc139d26",
            "id": "4aa885f39357455d8cc1b735b7793f78",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": 1696673629000,
            "no": 1263,
            "name": "电流B相48次谐波",
            "groupId": "0b4e1c9866f447bbb4367a83dc139d26",
            "id": "94fff7b064aa430cbcb3c6788d8f936f",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": 1696673629000,
            "no": 1264,
            "name": "电流B相49次谐波",
            "groupId": "0b4e1c9866f447bbb4367a83dc139d26",
            "id": "46fe8060e07a4a1494f8265a78de1fe9",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": 1696673629000,
            "no": 1265,
            "name": "电流B相50次谐波",
            "groupId": "0b4e1c9866f447bbb4367a83dc139d26",
            "id": "97c79c85e5ea44c090cd7271f93a52dc",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": 1696673677000,
            "no": 1266,
            "name": "电流C相2次谐波",
            "groupId": "4aa52b7fc17a461383880468cc46b4b4",
            "id": "ec5f5da9594b4098bcb44958dec8b691",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": 1696673677000,
            "no": 1267,
            "name": "电流C相3次谐波",
            "groupId": "4aa52b7fc17a461383880468cc46b4b4",
            "id": "013a8f82f47d4a9e8c35e1299f750c50",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": 1696673677000,
            "no": 1268,
            "name": "电流C相4次谐波",
            "groupId": "4aa52b7fc17a461383880468cc46b4b4",
            "id": "3fe050a7fadc487c9774f097ef8beba3",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": 1696673677000,
            "no": 1269,
            "name": "电流C相5次谐波",
            "groupId": "4aa52b7fc17a461383880468cc46b4b4",
            "id": "877c5339ab734dbb9a64f1a068681978",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": 1696673677000,
            "no": 1270,
            "name": "电流C相6次谐波",
            "groupId": "4aa52b7fc17a461383880468cc46b4b4",
            "id": "e9761cd48fbd45c6a448b09c4fb585d7",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": 1696673677000,
            "no": 1271,
            "name": "电流C相7次谐波",
            "groupId": "4aa52b7fc17a461383880468cc46b4b4",
            "id": "f76d0ceb793b4e3ba0a45a2aa53c01c5",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": 1696673677000,
            "no": 1272,
            "name": "电流C相8次谐波",
            "groupId": "4aa52b7fc17a461383880468cc46b4b4",
            "id": "f57bbb5383d546d6b31e5b2294adab9f",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": 1696673677000,
            "no": 1273,
            "name": "电流C相9次谐波",
            "groupId": "4aa52b7fc17a461383880468cc46b4b4",
            "id": "f244af782f5142c488aa5fd4aac31b30",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": 1696673677000,
            "no": 1274,
            "name": "电流C相10次谐波",
            "groupId": "4aa52b7fc17a461383880468cc46b4b4",
            "id": "94a3efef85d149be8e0480f5879912c6",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": 1696673677000,
            "no": 1275,
            "name": "电流C相11次谐波",
            "groupId": "4aa52b7fc17a461383880468cc46b4b4",
            "id": "b71bf594cfcd4f00909170c318b367e6",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": 1696673677000,
            "no": 1276,
            "name": "电流C相12次谐波",
            "groupId": "4aa52b7fc17a461383880468cc46b4b4",
            "id": "c28619aae33242d4b67f8add6db6643f",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": 1696673677000,
            "no": 1277,
            "name": "电流C相13次谐波",
            "groupId": "4aa52b7fc17a461383880468cc46b4b4",
            "id": "dfd7f444664a408697037407db92b48d",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": 1696673677000,
            "no": 1278,
            "name": "电流C相14次谐波",
            "groupId": "4aa52b7fc17a461383880468cc46b4b4",
            "id": "f5abc389ea7a4489a1225d1bf56c5b78",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": 1696673677000,
            "no": 1279,
            "name": "电流C相15次谐波",
            "groupId": "4aa52b7fc17a461383880468cc46b4b4",
            "id": "526ca5bcc7ef4a3089a7796a71a99985",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": 1696673678000,
            "no": 1280,
            "name": "电流C相16次谐波",
            "groupId": "4aa52b7fc17a461383880468cc46b4b4",
            "id": "d0c93771935c4303b69321cfd1d85fe8",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": 1696673678000,
            "no": 1281,
            "name": "电流C相17次谐波",
            "groupId": "4aa52b7fc17a461383880468cc46b4b4",
            "id": "6c6f01d9bb674e488dd5f13eb5149150",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": 1696673678000,
            "no": 1282,
            "name": "电流C相18次谐波",
            "groupId": "4aa52b7fc17a461383880468cc46b4b4",
            "id": "86d7b98d06e541dda45d78f27bec7910",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": 1696673678000,
            "no": 1283,
            "name": "电流C相19次谐波",
            "groupId": "4aa52b7fc17a461383880468cc46b4b4",
            "id": "2010ee41181649e7b2109da84622b697",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": 1696673678000,
            "no": 1284,
            "name": "电流C相20次谐波",
            "groupId": "4aa52b7fc17a461383880468cc46b4b4",
            "id": "10a24b2ee4994c3593a4c746d1b94f5f",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": 1696673678000,
            "no": 1285,
            "name": "电流C相21次谐波",
            "groupId": "4aa52b7fc17a461383880468cc46b4b4",
            "id": "74216c3d92ed44058504481dc2bd15ef",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": 1696673678000,
            "no": 1286,
            "name": "电流C相22次谐波",
            "groupId": "4aa52b7fc17a461383880468cc46b4b4",
            "id": "3148c7022eaf449ea847265f68da402c",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": 1696673678000,
            "no": 1287,
            "name": "电流C相23次谐波",
            "groupId": "4aa52b7fc17a461383880468cc46b4b4",
            "id": "8fa73d1fe80d4a3784f19bc4d2a6b1c7",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": 1696673678000,
            "no": 1288,
            "name": "电流C相24次谐波",
            "groupId": "4aa52b7fc17a461383880468cc46b4b4",
            "id": "b509a72b9ace460f8a6d65cd35c50365",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": 1696673678000,
            "no": 1289,
            "name": "电流C相25次谐波",
            "groupId": "4aa52b7fc17a461383880468cc46b4b4",
            "id": "bff0ea21e6184dfea9bffe7f7256fef4",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": 1696673678000,
            "no": 1290,
            "name": "电流C相26次谐波",
            "groupId": "4aa52b7fc17a461383880468cc46b4b4",
            "id": "f46b6302f2f443aca9450149ffd96495",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": 1696673678000,
            "no": 1291,
            "name": "电流C相27次谐波",
            "groupId": "4aa52b7fc17a461383880468cc46b4b4",
            "id": "b2e1744a6eda4341be367fe97b5ceeb3",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": 1696673678000,
            "no": 1292,
            "name": "电流C相28次谐波",
            "groupId": "4aa52b7fc17a461383880468cc46b4b4",
            "id": "1060a1c19085487f8572dfdef10ce675",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": 1696673678000,
            "no": 1293,
            "name": "电流C相29次谐波",
            "groupId": "4aa52b7fc17a461383880468cc46b4b4",
            "id": "ad8897900c8647b98a8724735ee1b736",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": 1696673678000,
            "no": 1294,
            "name": "电流C相30次谐波",
            "groupId": "4aa52b7fc17a461383880468cc46b4b4",
            "id": "cede99e3813d4de9b4412137e8d2dc42",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": 1696673678000,
            "no": 1295,
            "name": "电流C相31次谐波",
            "groupId": "4aa52b7fc17a461383880468cc46b4b4",
            "id": "e2030d4613234e388a5db7b9a0cd8afa",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": 1696673678000,
            "no": 1296,
            "name": "电流C相32次谐波",
            "groupId": "4aa52b7fc17a461383880468cc46b4b4",
            "id": "916c1686fd9d4ec99167d47723f4a343",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": 1696673678000,
            "no": 1297,
            "name": "电流C相33次谐波",
            "groupId": "4aa52b7fc17a461383880468cc46b4b4",
            "id": "fdc8076344674d9eb9ede7d1c3bc576b",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": 1696673679000,
            "no": 1298,
            "name": "电流C相34次谐波",
            "groupId": "4aa52b7fc17a461383880468cc46b4b4",
            "id": "f34e80e8680144919641e50114eca418",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": 1696673679000,
            "no": 1299,
            "name": "电流C相35次谐波",
            "groupId": "4aa52b7fc17a461383880468cc46b4b4",
            "id": "24ee13dd57a948da99207c8994d87e26",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": 1696673679000,
            "no": 1300,
            "name": "电流C相36次谐波",
            "groupId": "4aa52b7fc17a461383880468cc46b4b4",
            "id": "e9f9117e6e3e419cb1e0158c7a889273",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": 1696673679000,
            "no": 1301,
            "name": "电流C相37次谐波",
            "groupId": "4aa52b7fc17a461383880468cc46b4b4",
            "id": "bc8de19c719c4ef1a5ec2abaaed031e4",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": 1696673679000,
            "no": 1302,
            "name": "电流C相38次谐波",
            "groupId": "4aa52b7fc17a461383880468cc46b4b4",
            "id": "855c5fb93fff4f58916bf6c27ad9322b",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": 1696673679000,
            "no": 1303,
            "name": "电流C相39次谐波",
            "groupId": "4aa52b7fc17a461383880468cc46b4b4",
            "id": "9720c4e6e4c542ea8f41fa617338edba",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": 1696673679000,
            "no": 1304,
            "name": "电流C相40次谐波",
            "groupId": "4aa52b7fc17a461383880468cc46b4b4",
            "id": "d0b4f2f162134af69773b7f27073d0e2",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": 1696673679000,
            "no": 1305,
            "name": "电流C相41次谐波",
            "groupId": "4aa52b7fc17a461383880468cc46b4b4",
            "id": "293b36f000fe4f34b5b0433603e91e4d",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": 1696673679000,
            "no": 1306,
            "name": "电流C相42次谐波",
            "groupId": "4aa52b7fc17a461383880468cc46b4b4",
            "id": "e9d7cfd26409496d9159521aef919f3c",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": 1696673679000,
            "no": 1307,
            "name": "电流C相43次谐波",
            "groupId": "4aa52b7fc17a461383880468cc46b4b4",
            "id": "1a835def955344ed9b44b8656c09330f",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": 1696673679000,
            "no": 1308,
            "name": "电流C相44次谐波",
            "groupId": "4aa52b7fc17a461383880468cc46b4b4",
            "id": "1073f48298c3470ea105bbc802d75b4c",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": 1696673679000,
            "no": 1309,
            "name": "电流C相45次谐波",
            "groupId": "4aa52b7fc17a461383880468cc46b4b4",
            "id": "e996918ab43040bab9f8b6a2da44ca90",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": 1696673679000,
            "no": 1310,
            "name": "电流C相46次谐波",
            "groupId": "4aa52b7fc17a461383880468cc46b4b4",
            "id": "5613297d70164c86bca20af725d8dd9a",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": 1696673679000,
            "no": 1311,
            "name": "电流C相47次谐波",
            "groupId": "4aa52b7fc17a461383880468cc46b4b4",
            "id": "4852f7ede5a4465189b57ccaec81f0be",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": 1696673680000,
            "no": 1312,
            "name": "电流C相48次谐波",
            "groupId": "4aa52b7fc17a461383880468cc46b4b4",
            "id": "055b09bf6e564acebdf4d8461501a8be",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": 1696673680000,
            "no": 1313,
            "name": "电流C相49次谐波",
            "groupId": "4aa52b7fc17a461383880468cc46b4b4",
            "id": "ca9eccf214b449cf8cdc2ee4707f435c",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          },
          {
            "createTime": 1696673680000,
            "no": 1314,
            "name": "电流C相50次谐波",
            "groupId": "4aa52b7fc17a461383880468cc46b4b4",
            "id": "20cd99c2157b4760bd372c4367e8876b",
            "energyType": 0,
            "useDifference": 0,
            "enable": 1,
            "entityName": "AppType"
          }
        ],
        optionsd: {},
        defaultProps: {
          children: "next",
          label: "name"
        },
        dialogVisible: false,
        rules: {
          name: [
            {required: true,message: '请输入类型名称',trigger: 'blur'}
          ],
        },
        options: [],
        typeOptions: [],
        listData: {
          "Page": 1,
          "Rows": 10
        },

        columns: [
          {
            name: "编码",
            // key: "Code",
            key: "no",
            width: 90,
            al: 'center'
          },{
            name: "类型",
            // key: "Coefficient",
            key: "entityName",
            width: 90,
            al: 'center'
          }
        ],
      };
    },
    computed: {
      getResourcesByName () {
        return resourcesStore.getters.getResourcesByName
      },
    },
    watch: {
      'temp.appType': function(val) {
        // console.log("askdbhk",val);
        if(val==''||!val) {
          this.typeOptions=[]
          return
        }

        getAppTypeByGroupId({'groupId': val}).then(res => {
          // console.log(res);
          if(res.code==200) {
            this.typeOptions=res.data
          }
        })
      },
      dialogVisible: function(val) {
        // console.log(val);
        if(!val) {
          this.temp={}
        }
      },
      searchName (val) {
        if(val=='') {
          this.loading=true
          setTimeout(() => {
            this.loading=false
          },1000);
          this.deviceTableData=this.deviceTableDataCopy
        }
      },
    },
    mounted () {
      //应用类型编码
      getAllTypeByGroup().then(res => {
        //  console.log("res应用类型",res);
        this.options=res.data;
        this.getList();//获取列表数据 
      })

    },
    methods: {
      //搜索列表
      search_fn () {
        this.loading=true
        setTimeout(() => {
          this.loading=false
        },1000);
        this.tableData=this.tableDataCopy.filter((item) => item.name.includes(this.searchName));
      },

      //详情
      detail (v) {
        this.temp=v;
        this.detail_status=true;
      },
      // 删除管理员
      delete_fn (v) {
        this.$confirm(`是否删除 ${v.name}`,'提示',{
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          // console.log(v);
          apptypeDeleteById({'no': v.no}).then(res => {
            if(res.code==200) {
              this.$message({showClose: true,message: '删除成功',type: 'success'});
              this.getList();
            } else {
              this.$message.error(`删除失败，${res.message}`);
            }
          })
        }).catch(() => {
          // ...
        });

      },
      // 确认添加
      add_fn (formName) {
        this.$refs[formName].validate((valid) => {
          if(valid) {
            this.temp.uid=null
            apptypeSave(this.temp).then(data => {
              if(data.code==200) {
                this.getList();
                this.temp={}
                this.dialogVisible=false;
                this.$message({showClose: true,message: '添加成功',type: 'success'});
              } else {
                this.$message.error(`添加失败，${data.message}`);
              }
            })
          } else {
            return false;
          }
        });
      },
      // 添加弹窗
      add_ed (v,l) {
        this.dialogStatus='add';
        this.dialogVisible=true;
        this.topLevel=v
        // console.log(v);
        this.$nextTick(() => {
          this.$refs["temp"].clearValidate();
        });
        // this.temp = { EnergyTypeParentId: v || null};
      },
      // 确认编辑
      edit_fn (formName) {
        this.$refs[formName].validate((valid) => {
          if(valid) {
            // console.log("this.temp",this.temp);
            // this.temp.uid = this.temp.no
            var d={
              "name": this.temp.name,
              "uid": this.temp.no,
            }
            apptypeSave(d).then(data => {
              // console.log(data);
              if(data.code==200) {
                this.getList();
                this.temp={}
                this.dialogVisible=false;
                this.$message({showClose: true,message: '修改成功',type: 'success'});
              } else {
                this.$message.error(`修改失败，${data.message}`);
              }
            })
          } else {
            return false;
          }
        });
      },
      //编辑弹窗
      edit_ed (v) {
        this.dialogStatus='edit';
        this.temp=Object.assign({},v);
        this.dialogVisible=true;
        this.$nextTick(() => {
          this.$refs["temp"].clearValidate();
        });

      },


      //获取列表数据
      getList () {

      },


    }
  };
</script>

<style lang="scss" scoped>
  .applicationtype {
    .con {
      width: 100%;
      height: 100%;
      padding: 12px 20px;
      box-sizing: border-box;
      background-color: #fff;

    }

    /deep/.el-dialog {
      width: 460px !important;

    }

    .mydialog {
      /deep/.el-input {
        width: 240px !important;
      }
    }

    .public-flex {
      display: flex;
      align-items: center;
      justify-content: center;
    }

    /deep/.el-dialog__header {
      display: flex;
      align-items: center;
      border-bottom: 1px solid #E6E6E6;

      span {
        color: #67A3ED;
        font-size: 14px;
        font-weight: bold;
      }

      .el-icon-close {
        font-size: 20px !important;
      }

    }

    /deep/.el-dialog__footer {
      margin-top: 20px;
      text-align: right !important;
      border-top: 1px solid #E6E6E6;

      button {
        padding: 8px 17px;
      }
    }



    /deep/.el-form-item {
      display: flex;
      margin-left: 20px;
    }

    /deep/.el-form-item__label {
      white-space: nowrap;
      width: 86px;
    }

    /deep/.el-dialog__body {
      padding: 20px 0px 0px 20px !important;
    }

  }
</style>